var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const BUILD = {
  allRenderFn: false,
  cmpDidLoad: true,
  cmpDidUnload: false,
  cmpDidUpdate: true,
  cmpDidRender: true,
  cmpWillLoad: true,
  cmpWillUpdate: true,
  cmpWillRender: true,
  connectedCallback: true,
  disconnectedCallback: true,
  element: true,
  event: true,
  hasRenderFn: true,
  lifecycle: true,
  hostListener: true,
  hostListenerTargetWindow: true,
  hostListenerTargetDocument: true,
  hostListenerTargetBody: true,
  hostListenerTargetParent: false,
  hostListenerTarget: true,
  member: true,
  method: true,
  mode: true,
  observeAttribute: true,
  prop: true,
  propMutable: true,
  reflect: true,
  scoped: true,
  shadowDom: true,
  slot: true,
  cssAnnotations: true,
  state: true,
  style: true,
  svg: true,
  updatable: true,
  vdomAttribute: true,
  vdomXlink: true,
  vdomClass: true,
  vdomFunctional: true,
  vdomKey: true,
  vdomListener: true,
  vdomRef: true,
  vdomPropOrAttr: true,
  vdomRender: true,
  vdomStyle: true,
  vdomText: true,
  watchCallback: true,
  taskQueue: true,
  hotModuleReplacement: false,
  isDebug: false,
  isDev: false,
  isTesting: false,
  hydrateServerSide: false,
  hydrateClientSide: false,
  lifecycleDOMEvents: false,
  lazyLoad: false,
  profile: false,
  slotRelocation: true,
  appendChildSlotFix: false,
  cloneNodeFix: false,
  hydratedAttribute: false,
  hydratedClass: true,
  safari10: false,
  scriptDataOpts: false,
  scopedSlotTextContentFix: false,
  shadowDomShim: false,
  slotChildNodesFix: false,
  invisiblePrehydration: true,
  propBoolean: true,
  propNumber: true,
  propString: true,
  cssVarShim: false,
  constructableCSS: true,
  cmpShouldUpdate: true,
  devTools: false,
  dynamicImportShim: false,
  shadowDelegatesFocus: true,
  initializeNextTick: false,
  asyncLoading: false,
  asyncQueue: false,
  transformTagName: false,
  attachStyles: true
};
let scopeId;
let contentRef;
let hostTagName;
let useNativeShadowDom = false;
let checkSlotFallbackVisibility = false;
let checkSlotRelocate = false;
let isSvgMode = false;
let renderingRef = null;
let queuePending = false;
const setAssetPath = (path) => plt.$resourcesUrl$ = path;
const createTime = (fnName, tagName = "") => {
  {
    return () => {
      return;
    };
  }
};
const XLINK_NS = "http://www.w3.org/1999/xlink";
const EMPTY_OBJ = {};
const SVG_NS = "http://www.w3.org/2000/svg";
const HTML_NS = "http://www.w3.org/1999/xhtml";
const isDef = (v) => v != null;
const isComplexType = (o) => {
  o = typeof o;
  return o === "object" || o === "function";
};
const h = (nodeName, vnodeData, ...children) => {
  let child = null;
  let key = null;
  let slotName = null;
  let simple = false;
  let lastSimple = false;
  const vNodeChildren = [];
  const walk = (c) => {
    for (let i = 0; i < c.length; i++) {
      child = c[i];
      if (Array.isArray(child)) {
        walk(child);
      } else if (child != null && typeof child !== "boolean") {
        if (simple = typeof nodeName !== "function" && !isComplexType(child)) {
          child = String(child);
        }
        if (simple && lastSimple) {
          vNodeChildren[vNodeChildren.length - 1].$text$ += child;
        } else {
          vNodeChildren.push(simple ? newVNode(null, child) : child);
        }
        lastSimple = simple;
      }
    }
  };
  walk(children);
  if (vnodeData) {
    if (vnodeData.key) {
      key = vnodeData.key;
    }
    if (vnodeData.name) {
      slotName = vnodeData.name;
    }
    {
      const classData = vnodeData.className || vnodeData.class;
      if (classData) {
        vnodeData.class = typeof classData !== "object" ? classData : Object.keys(classData).filter((k) => classData[k]).join(" ");
      }
    }
  }
  if (typeof nodeName === "function") {
    return nodeName(vnodeData === null ? {} : vnodeData, vNodeChildren, vdomFnUtils);
  }
  const vnode = newVNode(nodeName, null);
  vnode.$attrs$ = vnodeData;
  if (vNodeChildren.length > 0) {
    vnode.$children$ = vNodeChildren;
  }
  {
    vnode.$key$ = key;
  }
  {
    vnode.$name$ = slotName;
  }
  return vnode;
};
const newVNode = (tag, text) => {
  const vnode = {
    $flags$: 0,
    $tag$: tag,
    $text$: text,
    $elm$: null,
    $children$: null
  };
  {
    vnode.$attrs$ = null;
  }
  {
    vnode.$key$ = null;
  }
  {
    vnode.$name$ = null;
  }
  return vnode;
};
const Host = {};
const isHost = (node) => node && node.$tag$ === Host;
const vdomFnUtils = {
  forEach: (children, cb) => children.map(convertToPublic).forEach(cb),
  map: (children, cb) => children.map(convertToPublic).map(cb).map(convertToPrivate)
};
const convertToPublic = (node) => ({
  vattrs: node.$attrs$,
  vchildren: node.$children$,
  vkey: node.$key$,
  vname: node.$name$,
  vtag: node.$tag$,
  vtext: node.$text$
});
const convertToPrivate = (node) => {
  if (typeof node.vtag === "function") {
    const vnodeData = Object.assign({}, node.vattrs);
    if (node.vkey) {
      vnodeData.key = node.vkey;
    }
    if (node.vname) {
      vnodeData.name = node.vname;
    }
    return h(node.vtag, vnodeData, ...node.vchildren || []);
  }
  const vnode = newVNode(node.vtag, node.vtext);
  vnode.$attrs$ = node.vattrs;
  vnode.$children$ = node.vchildren;
  vnode.$key$ = node.vkey;
  vnode.$name$ = node.vname;
  return vnode;
};
const computeMode = (elm) => modeResolutionChain.map((h2) => h2(elm)).find((m) => !!m);
const parsePropertyValue = (propValue, propType) => {
  if (propValue != null && !isComplexType(propValue)) {
    if (propType & 4) {
      return propValue === "false" ? false : propValue === "" || !!propValue;
    }
    if (propType & 2) {
      return parseFloat(propValue);
    }
    if (propType & 1) {
      return String(propValue);
    }
    return propValue;
  }
  return propValue;
};
const getElement = (ref) => ref;
const createEvent = (ref, name, flags) => {
  const elm = getElement(ref);
  return {
    emit: (detail) => {
      return emitEvent(elm, name, {
        bubbles: !!(flags & 4),
        composed: !!(flags & 2),
        cancelable: !!(flags & 1),
        detail
      });
    }
  };
};
const emitEvent = (elm, name, opts) => {
  const ev = plt.ce(name, opts);
  elm.dispatchEvent(ev);
  return ev;
};
const rootAppliedStyles = /* @__PURE__ */ new WeakMap();
const registerStyle = (scopeId2, cssText, allowCS) => {
  let style = styles.get(scopeId2);
  if (supportsConstructableStylesheets && allowCS) {
    style = style || new CSSStyleSheet();
    if (typeof style === "string") {
      style = cssText;
    } else {
      style.replaceSync(cssText);
    }
  } else {
    style = cssText;
  }
  styles.set(scopeId2, style);
};
const addStyle = (styleContainerNode, cmpMeta, mode, hostElm) => {
  let scopeId2 = getScopeId(cmpMeta, mode);
  const style = styles.get(scopeId2);
  styleContainerNode = styleContainerNode.nodeType === 11 ? styleContainerNode : doc;
  if (style) {
    if (typeof style === "string") {
      styleContainerNode = styleContainerNode.head || styleContainerNode;
      let appliedStyles = rootAppliedStyles.get(styleContainerNode);
      let styleElm;
      if (!appliedStyles) {
        rootAppliedStyles.set(styleContainerNode, appliedStyles = /* @__PURE__ */ new Set());
      }
      if (!appliedStyles.has(scopeId2)) {
        {
          {
            styleElm = doc.createElement("style");
            styleElm.innerHTML = style;
          }
          styleContainerNode.insertBefore(styleElm, styleContainerNode.querySelector("link"));
        }
        if (appliedStyles) {
          appliedStyles.add(scopeId2);
        }
      }
    } else if (!styleContainerNode.adoptedStyleSheets.includes(style)) {
      styleContainerNode.adoptedStyleSheets = [...styleContainerNode.adoptedStyleSheets, style];
    }
  }
  return scopeId2;
};
const attachStyles = (hostRef) => {
  const cmpMeta = hostRef.$cmpMeta$;
  const elm = hostRef.$hostElement$;
  const flags = cmpMeta.$flags$;
  const endAttachStyles = createTime("attachStyles", cmpMeta.$tagName$);
  const scopeId2 = addStyle(elm.shadowRoot ? elm.shadowRoot : elm.getRootNode(), cmpMeta, hostRef.$modeName$);
  if (flags & 10) {
    elm["s-sc"] = scopeId2;
    elm.classList.add(scopeId2 + "-h");
    if (flags & 2) {
      elm.classList.add(scopeId2 + "-s");
    }
  }
  endAttachStyles();
};
const getScopeId = (cmp, mode) => "sc-" + (mode && cmp.$flags$ & 32 ? cmp.$tagName$ + "-" + mode : cmp.$tagName$);
const setAccessor = (elm, memberName, oldValue, newValue, isSvg, flags) => {
  if (oldValue !== newValue) {
    let isProp = isMemberInElement(elm, memberName);
    let ln = memberName.toLowerCase();
    if (memberName === "class") {
      const classList = elm.classList;
      const oldClasses = parseClassList(oldValue);
      const newClasses = parseClassList(newValue);
      classList.remove(...oldClasses.filter((c) => c && !newClasses.includes(c)));
      classList.add(...newClasses.filter((c) => c && !oldClasses.includes(c)));
    } else if (memberName === "style") {
      {
        for (const prop in oldValue) {
          if (!newValue || newValue[prop] == null) {
            if (prop.includes("-")) {
              elm.style.removeProperty(prop);
            } else {
              elm.style[prop] = "";
            }
          }
        }
      }
      for (const prop in newValue) {
        if (!oldValue || newValue[prop] !== oldValue[prop]) {
          if (prop.includes("-")) {
            elm.style.setProperty(prop, newValue[prop]);
          } else {
            elm.style[prop] = newValue[prop];
          }
        }
      }
    } else if (memberName === "key")
      ;
    else if (memberName === "ref") {
      if (newValue) {
        newValue(elm);
      }
    } else if (!elm.__lookupSetter__(memberName) && memberName[0] === "o" && memberName[1] === "n") {
      if (memberName[2] === "-") {
        memberName = memberName.slice(3);
      } else if (isMemberInElement(win, ln)) {
        memberName = ln.slice(2);
      } else {
        memberName = ln[2] + memberName.slice(3);
      }
      if (oldValue) {
        plt.rel(elm, memberName, oldValue, false);
      }
      if (newValue) {
        plt.ael(elm, memberName, newValue, false);
      }
    } else {
      const isComplex = isComplexType(newValue);
      if ((isProp || isComplex && newValue !== null) && !isSvg) {
        try {
          if (!elm.tagName.includes("-")) {
            const n = newValue == null ? "" : newValue;
            if (memberName === "list") {
              isProp = false;
            } else if (oldValue == null || elm[memberName] != n) {
              elm[memberName] = n;
            }
          } else {
            elm[memberName] = newValue;
          }
        } catch (e) {
        }
      }
      let xlink = false;
      {
        if (ln !== (ln = ln.replace(/^xlink\:?/, ""))) {
          memberName = ln;
          xlink = true;
        }
      }
      if (newValue == null || newValue === false) {
        if (newValue !== false || elm.getAttribute(memberName) === "") {
          if (xlink) {
            elm.removeAttributeNS(XLINK_NS, memberName);
          } else {
            elm.removeAttribute(memberName);
          }
        }
      } else if ((!isProp || flags & 4 || isSvg) && !isComplex) {
        newValue = newValue === true ? "" : newValue;
        if (xlink) {
          elm.setAttributeNS(XLINK_NS, memberName, newValue);
        } else {
          elm.setAttribute(memberName, newValue);
        }
      }
    }
  }
};
const parseClassListRegex = /\s/;
const parseClassList = (value) => !value ? [] : value.split(parseClassListRegex);
const updateElement = (oldVnode, newVnode, isSvgMode2, memberName) => {
  const elm = newVnode.$elm$.nodeType === 11 && newVnode.$elm$.host ? newVnode.$elm$.host : newVnode.$elm$;
  const oldVnodeAttrs = oldVnode && oldVnode.$attrs$ || EMPTY_OBJ;
  const newVnodeAttrs = newVnode.$attrs$ || EMPTY_OBJ;
  {
    for (memberName in oldVnodeAttrs) {
      if (!(memberName in newVnodeAttrs)) {
        setAccessor(elm, memberName, oldVnodeAttrs[memberName], void 0, isSvgMode2, newVnode.$flags$);
      }
    }
  }
  for (memberName in newVnodeAttrs) {
    setAccessor(elm, memberName, oldVnodeAttrs[memberName], newVnodeAttrs[memberName], isSvgMode2, newVnode.$flags$);
  }
};
const createElm = (oldParentVNode, newParentVNode, childIndex, parentElm) => {
  const newVNode2 = newParentVNode.$children$[childIndex];
  let i = 0;
  let elm;
  let childNode;
  let oldVNode;
  if (!useNativeShadowDom) {
    checkSlotRelocate = true;
    if (newVNode2.$tag$ === "slot") {
      if (scopeId) {
        parentElm.classList.add(scopeId + "-s");
      }
      newVNode2.$flags$ |= newVNode2.$children$ ? (
        // slot element has fallback content
        2
      ) : (
        // slot element does not have fallback content
        1
      );
    }
  }
  if (newVNode2.$text$ !== null) {
    elm = newVNode2.$elm$ = doc.createTextNode(newVNode2.$text$);
  } else if (newVNode2.$flags$ & 1) {
    elm = newVNode2.$elm$ = doc.createTextNode("");
  } else {
    if (!isSvgMode) {
      isSvgMode = newVNode2.$tag$ === "svg";
    }
    elm = newVNode2.$elm$ = doc.createElementNS(isSvgMode ? SVG_NS : HTML_NS, newVNode2.$flags$ & 2 ? "slot-fb" : newVNode2.$tag$);
    if (isSvgMode && newVNode2.$tag$ === "foreignObject") {
      isSvgMode = false;
    }
    {
      updateElement(null, newVNode2, isSvgMode);
    }
    if (isDef(scopeId) && elm["s-si"] !== scopeId) {
      elm.classList.add(elm["s-si"] = scopeId);
    }
    if (newVNode2.$children$) {
      for (i = 0; i < newVNode2.$children$.length; ++i) {
        childNode = createElm(oldParentVNode, newVNode2, i, elm);
        if (childNode) {
          elm.appendChild(childNode);
        }
      }
    }
    {
      if (newVNode2.$tag$ === "svg") {
        isSvgMode = false;
      } else if (elm.tagName === "foreignObject") {
        isSvgMode = true;
      }
    }
  }
  {
    elm["s-hn"] = hostTagName;
    if (newVNode2.$flags$ & (2 | 1)) {
      elm["s-sr"] = true;
      elm["s-cr"] = contentRef;
      elm["s-sn"] = newVNode2.$name$ || "";
      oldVNode = oldParentVNode && oldParentVNode.$children$ && oldParentVNode.$children$[childIndex];
      if (oldVNode && oldVNode.$tag$ === newVNode2.$tag$ && oldParentVNode.$elm$) {
        putBackInOriginalLocation(oldParentVNode.$elm$, false);
      }
    }
  }
  return elm;
};
const putBackInOriginalLocation = (parentElm, recursive) => {
  plt.$flags$ |= 1;
  const oldSlotChildNodes = parentElm.childNodes;
  for (let i = oldSlotChildNodes.length - 1; i >= 0; i--) {
    const childNode = oldSlotChildNodes[i];
    if (childNode["s-hn"] !== hostTagName && childNode["s-ol"]) {
      parentReferenceNode(childNode).insertBefore(childNode, referenceNode(childNode));
      childNode["s-ol"].remove();
      childNode["s-ol"] = void 0;
      checkSlotRelocate = true;
    }
    if (recursive) {
      putBackInOriginalLocation(childNode, recursive);
    }
  }
  plt.$flags$ &= ~1;
};
const addVnodes = (parentElm, before, parentVNode, vnodes, startIdx, endIdx) => {
  let containerElm = parentElm["s-cr"] && parentElm["s-cr"].parentNode || parentElm;
  let childNode;
  if (containerElm.shadowRoot && containerElm.tagName === hostTagName) {
    containerElm = containerElm.shadowRoot;
  }
  for (; startIdx <= endIdx; ++startIdx) {
    if (vnodes[startIdx]) {
      childNode = createElm(null, parentVNode, startIdx, parentElm);
      if (childNode) {
        vnodes[startIdx].$elm$ = childNode;
        containerElm.insertBefore(childNode, referenceNode(before));
      }
    }
  }
};
const removeVnodes = (vnodes, startIdx, endIdx, vnode, elm) => {
  for (; startIdx <= endIdx; ++startIdx) {
    if (vnode = vnodes[startIdx]) {
      elm = vnode.$elm$;
      callNodeRefs(vnode);
      {
        checkSlotFallbackVisibility = true;
        if (elm["s-ol"]) {
          elm["s-ol"].remove();
        } else {
          putBackInOriginalLocation(elm, true);
        }
      }
      elm.remove();
    }
  }
};
const updateChildren = (parentElm, oldCh, newVNode2, newCh) => {
  let oldStartIdx = 0;
  let newStartIdx = 0;
  let idxInOld = 0;
  let i = 0;
  let oldEndIdx = oldCh.length - 1;
  let oldStartVnode = oldCh[0];
  let oldEndVnode = oldCh[oldEndIdx];
  let newEndIdx = newCh.length - 1;
  let newStartVnode = newCh[0];
  let newEndVnode = newCh[newEndIdx];
  let node;
  let elmToMove;
  while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
    if (oldStartVnode == null) {
      oldStartVnode = oldCh[++oldStartIdx];
    } else if (oldEndVnode == null) {
      oldEndVnode = oldCh[--oldEndIdx];
    } else if (newStartVnode == null) {
      newStartVnode = newCh[++newStartIdx];
    } else if (newEndVnode == null) {
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newStartVnode)) {
      patch(oldStartVnode, newStartVnode);
      oldStartVnode = oldCh[++oldStartIdx];
      newStartVnode = newCh[++newStartIdx];
    } else if (isSameVnode(oldEndVnode, newEndVnode)) {
      patch(oldEndVnode, newEndVnode);
      oldEndVnode = oldCh[--oldEndIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldStartVnode, newEndVnode)) {
      if (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot") {
        putBackInOriginalLocation(oldStartVnode.$elm$.parentNode, false);
      }
      patch(oldStartVnode, newEndVnode);
      parentElm.insertBefore(oldStartVnode.$elm$, oldEndVnode.$elm$.nextSibling);
      oldStartVnode = oldCh[++oldStartIdx];
      newEndVnode = newCh[--newEndIdx];
    } else if (isSameVnode(oldEndVnode, newStartVnode)) {
      if (oldStartVnode.$tag$ === "slot" || newEndVnode.$tag$ === "slot") {
        putBackInOriginalLocation(oldEndVnode.$elm$.parentNode, false);
      }
      patch(oldEndVnode, newStartVnode);
      parentElm.insertBefore(oldEndVnode.$elm$, oldStartVnode.$elm$);
      oldEndVnode = oldCh[--oldEndIdx];
      newStartVnode = newCh[++newStartIdx];
    } else {
      idxInOld = -1;
      {
        for (i = oldStartIdx; i <= oldEndIdx; ++i) {
          if (oldCh[i] && oldCh[i].$key$ !== null && oldCh[i].$key$ === newStartVnode.$key$) {
            idxInOld = i;
            break;
          }
        }
      }
      if (idxInOld >= 0) {
        elmToMove = oldCh[idxInOld];
        if (elmToMove.$tag$ !== newStartVnode.$tag$) {
          node = createElm(oldCh && oldCh[newStartIdx], newVNode2, idxInOld, parentElm);
        } else {
          patch(elmToMove, newStartVnode);
          oldCh[idxInOld] = void 0;
          node = elmToMove.$elm$;
        }
        newStartVnode = newCh[++newStartIdx];
      } else {
        node = createElm(oldCh && oldCh[newStartIdx], newVNode2, newStartIdx, parentElm);
        newStartVnode = newCh[++newStartIdx];
      }
      if (node) {
        {
          parentReferenceNode(oldStartVnode.$elm$).insertBefore(node, referenceNode(oldStartVnode.$elm$));
        }
      }
    }
  }
  if (oldStartIdx > oldEndIdx) {
    addVnodes(parentElm, newCh[newEndIdx + 1] == null ? null : newCh[newEndIdx + 1].$elm$, newVNode2, newCh, newStartIdx, newEndIdx);
  } else if (newStartIdx > newEndIdx) {
    removeVnodes(oldCh, oldStartIdx, oldEndIdx);
  }
};
const isSameVnode = (leftVNode, rightVNode) => {
  if (leftVNode.$tag$ === rightVNode.$tag$) {
    if (leftVNode.$tag$ === "slot") {
      return leftVNode.$name$ === rightVNode.$name$;
    }
    {
      return leftVNode.$key$ === rightVNode.$key$;
    }
  }
  return false;
};
const referenceNode = (node) => {
  return node && node["s-ol"] || node;
};
const parentReferenceNode = (node) => (node["s-ol"] ? node["s-ol"] : node).parentNode;
const patch = (oldVNode, newVNode2) => {
  const elm = newVNode2.$elm$ = oldVNode.$elm$;
  const oldChildren = oldVNode.$children$;
  const newChildren = newVNode2.$children$;
  const tag = newVNode2.$tag$;
  const text = newVNode2.$text$;
  let defaultHolder;
  if (text === null) {
    {
      isSvgMode = tag === "svg" ? true : tag === "foreignObject" ? false : isSvgMode;
    }
    {
      if (tag === "slot")
        ;
      else {
        updateElement(oldVNode, newVNode2, isSvgMode);
      }
    }
    if (oldChildren !== null && newChildren !== null) {
      updateChildren(elm, oldChildren, newVNode2, newChildren);
    } else if (newChildren !== null) {
      if (oldVNode.$text$ !== null) {
        elm.textContent = "";
      }
      addVnodes(elm, null, newVNode2, newChildren, 0, newChildren.length - 1);
    } else if (oldChildren !== null) {
      removeVnodes(oldChildren, 0, oldChildren.length - 1);
    }
    if (isSvgMode && tag === "svg") {
      isSvgMode = false;
    }
  } else if (defaultHolder = elm["s-cr"]) {
    defaultHolder.parentNode.textContent = text;
  } else if (oldVNode.$text$ !== text) {
    elm.data = text;
  }
};
const updateFallbackSlotVisibility = (elm) => {
  const childNodes = elm.childNodes;
  let childNode;
  let i;
  let ilen;
  let j;
  let slotNameAttr;
  let nodeType;
  for (i = 0, ilen = childNodes.length; i < ilen; i++) {
    childNode = childNodes[i];
    if (childNode.nodeType === 1) {
      if (childNode["s-sr"]) {
        slotNameAttr = childNode["s-sn"];
        childNode.hidden = false;
        for (j = 0; j < ilen; j++) {
          nodeType = childNodes[j].nodeType;
          if (childNodes[j]["s-hn"] !== childNode["s-hn"] || slotNameAttr !== "") {
            if (nodeType === 1 && slotNameAttr === childNodes[j].getAttribute("slot")) {
              childNode.hidden = true;
              break;
            }
          } else {
            if (nodeType === 1 || nodeType === 3 && childNodes[j].textContent.trim() !== "") {
              childNode.hidden = true;
              break;
            }
          }
        }
      }
      updateFallbackSlotVisibility(childNode);
    }
  }
};
const relocateNodes = [];
const relocateSlotContent = (elm) => {
  let childNode;
  let node;
  let hostContentNodes;
  let slotNameAttr;
  let relocateNodeData;
  let j;
  let i = 0;
  const childNodes = elm.childNodes;
  const ilen = childNodes.length;
  for (; i < ilen; i++) {
    childNode = childNodes[i];
    if (childNode["s-sr"] && (node = childNode["s-cr"]) && node.parentNode) {
      hostContentNodes = node.parentNode.childNodes;
      slotNameAttr = childNode["s-sn"];
      for (j = hostContentNodes.length - 1; j >= 0; j--) {
        node = hostContentNodes[j];
        if (!node["s-cn"] && !node["s-nr"] && node["s-hn"] !== childNode["s-hn"]) {
          if (isNodeLocatedInSlot(node, slotNameAttr)) {
            relocateNodeData = relocateNodes.find((r) => r.$nodeToRelocate$ === node);
            checkSlotFallbackVisibility = true;
            node["s-sn"] = node["s-sn"] || slotNameAttr;
            if (relocateNodeData) {
              relocateNodeData.$slotRefNode$ = childNode;
            } else {
              relocateNodes.push({
                $slotRefNode$: childNode,
                $nodeToRelocate$: node
              });
            }
            if (node["s-sr"]) {
              relocateNodes.map((relocateNode) => {
                if (isNodeLocatedInSlot(relocateNode.$nodeToRelocate$, node["s-sn"])) {
                  relocateNodeData = relocateNodes.find((r) => r.$nodeToRelocate$ === node);
                  if (relocateNodeData && !relocateNode.$slotRefNode$) {
                    relocateNode.$slotRefNode$ = relocateNodeData.$slotRefNode$;
                  }
                }
              });
            }
          } else if (!relocateNodes.some((r) => r.$nodeToRelocate$ === node)) {
            relocateNodes.push({
              $nodeToRelocate$: node
            });
          }
        }
      }
    }
    if (childNode.nodeType === 1) {
      relocateSlotContent(childNode);
    }
  }
};
const isNodeLocatedInSlot = (nodeToRelocate, slotNameAttr) => {
  if (nodeToRelocate.nodeType === 1) {
    if (nodeToRelocate.getAttribute("slot") === null && slotNameAttr === "") {
      return true;
    }
    if (nodeToRelocate.getAttribute("slot") === slotNameAttr) {
      return true;
    }
    return false;
  }
  if (nodeToRelocate["s-sn"] === slotNameAttr) {
    return true;
  }
  return slotNameAttr === "";
};
const callNodeRefs = (vNode) => {
  {
    vNode.$attrs$ && vNode.$attrs$.ref && vNode.$attrs$.ref(null);
    vNode.$children$ && vNode.$children$.map(callNodeRefs);
  }
};
const renderVdom = (hostRef, renderFnResults) => {
  const hostElm = hostRef.$hostElement$;
  const cmpMeta = hostRef.$cmpMeta$;
  const oldVNode = hostRef.$vnode$ || newVNode(null, null);
  const rootVnode = isHost(renderFnResults) ? renderFnResults : h(null, null, renderFnResults);
  hostTagName = hostElm.tagName;
  if (cmpMeta.$attrsToReflect$) {
    rootVnode.$attrs$ = rootVnode.$attrs$ || {};
    cmpMeta.$attrsToReflect$.map(([propName, attribute]) => rootVnode.$attrs$[attribute] = hostElm[propName]);
  }
  rootVnode.$tag$ = null;
  rootVnode.$flags$ |= 4;
  hostRef.$vnode$ = rootVnode;
  rootVnode.$elm$ = oldVNode.$elm$ = hostElm.shadowRoot || hostElm;
  {
    scopeId = hostElm["s-sc"];
  }
  {
    contentRef = hostElm["s-cr"];
    useNativeShadowDom = (cmpMeta.$flags$ & 1) !== 0;
    checkSlotFallbackVisibility = false;
  }
  patch(oldVNode, rootVnode);
  {
    plt.$flags$ |= 1;
    if (checkSlotRelocate) {
      relocateSlotContent(rootVnode.$elm$);
      let relocateData;
      let nodeToRelocate;
      let orgLocationNode;
      let parentNodeRef;
      let insertBeforeNode;
      let refNode;
      let i = 0;
      for (; i < relocateNodes.length; i++) {
        relocateData = relocateNodes[i];
        nodeToRelocate = relocateData.$nodeToRelocate$;
        if (!nodeToRelocate["s-ol"]) {
          orgLocationNode = doc.createTextNode("");
          orgLocationNode["s-nr"] = nodeToRelocate;
          nodeToRelocate.parentNode.insertBefore(nodeToRelocate["s-ol"] = orgLocationNode, nodeToRelocate);
        }
      }
      for (i = 0; i < relocateNodes.length; i++) {
        relocateData = relocateNodes[i];
        nodeToRelocate = relocateData.$nodeToRelocate$;
        if (relocateData.$slotRefNode$) {
          parentNodeRef = relocateData.$slotRefNode$.parentNode;
          insertBeforeNode = relocateData.$slotRefNode$.nextSibling;
          orgLocationNode = nodeToRelocate["s-ol"];
          while (orgLocationNode = orgLocationNode.previousSibling) {
            refNode = orgLocationNode["s-nr"];
            if (refNode && refNode["s-sn"] === nodeToRelocate["s-sn"] && parentNodeRef === refNode.parentNode) {
              refNode = refNode.nextSibling;
              if (!refNode || !refNode["s-nr"]) {
                insertBeforeNode = refNode;
                break;
              }
            }
          }
          if (!insertBeforeNode && parentNodeRef !== nodeToRelocate.parentNode || nodeToRelocate.nextSibling !== insertBeforeNode) {
            if (nodeToRelocate !== insertBeforeNode) {
              if (!nodeToRelocate["s-hn"] && nodeToRelocate["s-ol"]) {
                nodeToRelocate["s-hn"] = nodeToRelocate["s-ol"].parentNode.nodeName;
              }
              parentNodeRef.insertBefore(nodeToRelocate, insertBeforeNode);
            }
          }
        } else {
          if (nodeToRelocate.nodeType === 1) {
            nodeToRelocate.hidden = true;
          }
        }
      }
    }
    if (checkSlotFallbackVisibility) {
      updateFallbackSlotVisibility(rootVnode.$elm$);
    }
    plt.$flags$ &= ~1;
    relocateNodes.length = 0;
  }
};
const attachToAncestor = (hostRef, ancestorComponent) => {
};
const scheduleUpdate = (hostRef, isInitialLoad) => {
  {
    hostRef.$flags$ |= 16;
  }
  attachToAncestor(hostRef, hostRef.$ancestorComponent$);
  const dispatch = () => dispatchHooks(hostRef, isInitialLoad);
  return writeTask(dispatch);
};
const dispatchHooks = (hostRef, isInitialLoad) => {
  const elm = hostRef.$hostElement$;
  const endSchedule = createTime("scheduleUpdate", hostRef.$cmpMeta$.$tagName$);
  const instance = elm;
  let promise;
  if (isInitialLoad) {
    {
      promise = safeCall(instance, "componentWillLoad");
    }
  } else {
    {
      promise = safeCall(instance, "componentWillUpdate");
    }
  }
  {
    promise = then(promise, () => safeCall(instance, "componentWillRender"));
  }
  endSchedule();
  return then(promise, () => updateComponent(hostRef, instance, isInitialLoad));
};
const updateComponent = (hostRef, instance, isInitialLoad) => __async(void 0, null, function* () {
  const elm = hostRef.$hostElement$;
  const endUpdate = createTime("update", hostRef.$cmpMeta$.$tagName$);
  elm["s-rc"];
  if (isInitialLoad) {
    attachStyles(hostRef);
  }
  const endRender = createTime("render", hostRef.$cmpMeta$.$tagName$);
  {
    callRender(hostRef, instance, elm);
  }
  endRender();
  endUpdate();
  {
    postUpdateComponent(hostRef);
  }
});
const callRender = (hostRef, instance, elm) => {
  const allRenderFn = false;
  const lazyLoad = false;
  const taskQueue = true;
  const updatable = true;
  try {
    renderingRef = instance;
    instance = allRenderFn ? instance.render() : instance.render && instance.render();
    if (updatable && taskQueue) {
      hostRef.$flags$ &= ~16;
    }
    if (updatable || lazyLoad) {
      hostRef.$flags$ |= 2;
    }
    if (BUILD.hasRenderFn || BUILD.reflect) {
      if (BUILD.vdomRender || BUILD.reflect) {
        if (BUILD.hydrateServerSide) ;
        else {
          renderVdom(hostRef, instance);
        }
      }
    }
  } catch (e) {
    consoleError(e, hostRef.$hostElement$);
  }
  renderingRef = null;
  return null;
};
const getRenderingRef = () => renderingRef;
const postUpdateComponent = (hostRef) => {
  const tagName = hostRef.$cmpMeta$.$tagName$;
  const elm = hostRef.$hostElement$;
  const endPostUpdate = createTime("postUpdate", tagName);
  const instance = elm;
  hostRef.$ancestorComponent$;
  {
    safeCall(instance, "componentDidRender");
  }
  if (!(hostRef.$flags$ & 64)) {
    hostRef.$flags$ |= 64;
    {
      safeCall(instance, "componentDidLoad");
    }
    endPostUpdate();
  } else {
    {
      safeCall(instance, "componentDidUpdate");
    }
    endPostUpdate();
  }
};
const safeCall = (instance, method, arg) => {
  if (instance && instance[method]) {
    try {
      return instance[method](arg);
    } catch (e) {
      consoleError(e);
    }
  }
  return void 0;
};
const then = (promise, thenFn) => {
  return promise && promise.then ? promise.then(thenFn) : thenFn();
};
const getValue = (ref, propName) => getHostRef(ref).$instanceValues$.get(propName);
const setValue = (ref, propName, newVal, cmpMeta) => {
  const hostRef = getHostRef(ref);
  const elm = ref;
  const oldVal = hostRef.$instanceValues$.get(propName);
  const flags = hostRef.$flags$;
  const instance = elm;
  newVal = parsePropertyValue(newVal, cmpMeta.$members$[propName][0]);
  const areBothNaN = Number.isNaN(oldVal) && Number.isNaN(newVal);
  const didValueChange = newVal !== oldVal && !areBothNaN;
  if (didValueChange) {
    hostRef.$instanceValues$.set(propName, newVal);
    {
      if (cmpMeta.$watchers$ && flags & 128) {
        const watchMethods = cmpMeta.$watchers$[propName];
        if (watchMethods) {
          watchMethods.map((watchMethodName) => {
            try {
              instance[watchMethodName](newVal, oldVal, propName);
            } catch (e) {
              consoleError(e, elm);
            }
          });
        }
      }
      if ((flags & (2 | 16)) === 2) {
        if (instance.componentShouldUpdate) {
          if (instance.componentShouldUpdate(newVal, oldVal, propName) === false) {
            return;
          }
        }
        scheduleUpdate(hostRef, false);
      }
    }
  }
};
const proxyComponent = (Cstr, cmpMeta, flags) => {
  if (cmpMeta.$members$) {
    if (Cstr.watchers) {
      cmpMeta.$watchers$ = Cstr.watchers;
    }
    const members = Object.entries(cmpMeta.$members$);
    const prototype = Cstr.prototype;
    members.map(([memberName, [memberFlags]]) => {
      if (memberFlags & 31 || memberFlags & 32) {
        Object.defineProperty(prototype, memberName, {
          get() {
            return getValue(this, memberName);
          },
          set(newValue) {
            setValue(this, memberName, newValue, cmpMeta);
          },
          configurable: true,
          enumerable: true
        });
      }
    });
    {
      const attrNameToPropName = /* @__PURE__ */ new Map();
      prototype.attributeChangedCallback = function(attrName, _oldValue, newValue) {
        plt.jmp(() => {
          const propName = attrNameToPropName.get(attrName);
          if (this.hasOwnProperty(propName)) {
            newValue = this[propName];
            delete this[propName];
          } else if (prototype.hasOwnProperty(propName) && typeof this[propName] === "number" && this[propName] == newValue) {
            return;
          }
          this[propName] = newValue === null && typeof this[propName] === "boolean" ? false : newValue;
        });
      };
      Cstr.observedAttributes = members.filter(
        ([_, m]) => m[0] & 15
        /* MEMBER_FLAGS.HasAttribute */
      ).map(([propName, m]) => {
        const attrName = m[1] || propName;
        attrNameToPropName.set(attrName, propName);
        if (m[0] & 512) {
          cmpMeta.$attrsToReflect$.push([propName, attrName]);
        }
        return attrName;
      });
    }
  }
  return Cstr;
};
const initializeComponent = (elm, hostRef, cmpMeta, hmrVersionId, Cstr) => __async(void 0, null, function* () {
  if ((hostRef.$flags$ & 32) === 0) {
    {
      Cstr = elm.constructor;
      hostRef.$flags$ |= 32;
      customElements.whenDefined(cmpMeta.$tagName$).then(() => hostRef.$flags$ |= 128);
    }
    if (Cstr.style) {
      let style = Cstr.style;
      if (typeof style !== "string") {
        style = style[hostRef.$modeName$ = computeMode(elm)];
      }
      const scopeId2 = getScopeId(cmpMeta, hostRef.$modeName$);
      if (!styles.has(scopeId2)) {
        const endRegisterStyles = createTime("registerStyles", cmpMeta.$tagName$);
        registerStyle(scopeId2, style, !!(cmpMeta.$flags$ & 1));
        endRegisterStyles();
      }
    }
  }
  hostRef.$ancestorComponent$;
  const schedule = () => scheduleUpdate(hostRef, true);
  {
    schedule();
  }
});
const fireConnectedCallback = (instance) => {
};
const connectedCallback = (elm) => {
  if ((plt.$flags$ & 1) === 0) {
    const hostRef = getHostRef(elm);
    const cmpMeta = hostRef.$cmpMeta$;
    const endConnected = createTime("connectedCallback", cmpMeta.$tagName$);
    if (!(hostRef.$flags$ & 1)) {
      hostRef.$flags$ |= 1;
      {
        if (cmpMeta.$flags$ & (4 | 8)) {
          setContentReference(elm);
        }
      }
      if (cmpMeta.$members$) {
        Object.entries(cmpMeta.$members$).map(([memberName, [memberFlags]]) => {
          if (memberFlags & 31 && elm.hasOwnProperty(memberName)) {
            const value = elm[memberName];
            delete elm[memberName];
            elm[memberName] = value;
          }
        });
      }
      {
        initializeComponent(elm, hostRef, cmpMeta);
      }
    } else {
      addHostEventListeners(elm, hostRef, cmpMeta.$listeners$);
      fireConnectedCallback(hostRef.$lazyInstance$);
    }
    endConnected();
  }
};
const setContentReference = (elm) => {
  const contentRefElm = elm["s-cr"] = doc.createComment("");
  contentRefElm["s-cn"] = true;
  elm.insertBefore(contentRefElm, elm.firstChild);
};
const disconnectedCallback = (elm) => {
  if ((plt.$flags$ & 1) === 0) {
    const hostRef = getHostRef(elm);
    {
      if (hostRef.$rmListeners$) {
        hostRef.$rmListeners$.map((rmListener) => rmListener());
        hostRef.$rmListeners$ = void 0;
      }
    }
  }
};
const proxyCustomElement = (Cstr, compactMeta) => {
  const cmpMeta = {
    $flags$: compactMeta[0],
    $tagName$: compactMeta[1]
  };
  {
    cmpMeta.$members$ = compactMeta[2];
  }
  {
    cmpMeta.$listeners$ = compactMeta[3];
  }
  {
    cmpMeta.$watchers$ = Cstr.$watchers$;
  }
  {
    cmpMeta.$attrsToReflect$ = [];
  }
  const originalConnectedCallback = Cstr.prototype.connectedCallback;
  const originalDisconnectedCallback = Cstr.prototype.disconnectedCallback;
  Object.assign(Cstr.prototype, {
    __registerHost() {
      registerHost(this, cmpMeta);
    },
    connectedCallback() {
      connectedCallback(this);
      if (originalConnectedCallback) {
        originalConnectedCallback.call(this);
      }
    },
    disconnectedCallback() {
      disconnectedCallback(this);
      if (originalDisconnectedCallback) {
        originalDisconnectedCallback.call(this);
      }
    },
    __attachShadow() {
      {
        {
          this.attachShadow({
            mode: "open",
            delegatesFocus: !!(cmpMeta.$flags$ & 16)
          });
        }
      }
    }
  });
  Cstr.is = cmpMeta.$tagName$;
  return proxyComponent(Cstr, cmpMeta);
};
const Fragment = (_, children) => children;
const addHostEventListeners = (elm, hostRef, listeners, attachParentListeners) => {
  if (listeners) {
    listeners.map(([flags, name, method]) => {
      const target = getHostListenerTarget(elm, flags);
      const handler = hostListenerProxy(hostRef, method);
      const opts = hostListenerOpts(flags);
      plt.ael(target, name, handler, opts);
      (hostRef.$rmListeners$ = hostRef.$rmListeners$ || []).push(() => plt.rel(target, name, handler, opts));
    });
  }
};
const hostListenerProxy = (hostRef, methodName) => (ev) => {
  try {
    if (BUILD.lazyLoad) ;
    else {
      hostRef.$hostElement$[methodName](ev);
    }
  } catch (e) {
    consoleError(e);
  }
};
const getHostListenerTarget = (elm, flags) => {
  if (flags & 4)
    return doc;
  if (flags & 8)
    return win;
  if (flags & 16)
    return doc.body;
  return elm;
};
const hostListenerOpts = (flags) => supportsListenerOptions ? {
  passive: (flags & 1) !== 0,
  capture: (flags & 2) !== 0
} : (flags & 2) !== 0;
const setPlatformOptions = (opts) => Object.assign(plt, opts);
const hostRefs = /* @__PURE__ */ new WeakMap();
const getHostRef = (ref) => hostRefs.get(ref);
const registerHost = (elm, cmpMeta) => {
  const hostRef = {
    $flags$: 0,
    $hostElement$: elm,
    $cmpMeta$: cmpMeta,
    $instanceValues$: /* @__PURE__ */ new Map()
  };
  addHostEventListeners(elm, hostRef, cmpMeta.$listeners$);
  return hostRefs.set(elm, hostRef);
};
const isMemberInElement = (elm, memberName) => memberName in elm;
const consoleError = (e, el) => (0, console.error)(e, el);
const styles = /* @__PURE__ */ new Map();
const modeResolutionChain = [];
const win = typeof window !== "undefined" ? window : {};
const doc = win.document || { head: {} };
const H = win.HTMLElement || class {
};
const plt = {
  $flags$: 0,
  $resourcesUrl$: "",
  jmp: (h2) => h2(),
  raf: (h2) => requestAnimationFrame(h2),
  ael: (el, eventName, listener, opts) => el.addEventListener(eventName, listener, opts),
  rel: (el, eventName, listener, opts) => el.removeEventListener(eventName, listener, opts),
  ce: (eventName, opts) => new CustomEvent(eventName, opts)
};
const supportsListenerOptions = /* @__PURE__ */ (() => {
  let supportsListenerOptions2 = false;
  try {
    doc.addEventListener("e", null, Object.defineProperty({}, "passive", {
      get() {
        supportsListenerOptions2 = true;
      }
    }));
  } catch (e) {
  }
  return supportsListenerOptions2;
})();
const promiseResolve = (v) => Promise.resolve(v);
const supportsConstructableStylesheets = /* @__PURE__ */ (() => {
  try {
    new CSSStyleSheet();
    return typeof new CSSStyleSheet().replaceSync === "function";
  } catch (e) {
  }
  return false;
})();
const queueDomReads = [];
const queueDomWrites = [];
const queueTask = (queue, write) => (cb) => {
  queue.push(cb);
  if (!queuePending) {
    queuePending = true;
    if (write && plt.$flags$ & 4) {
      nextTick(flush);
    } else {
      plt.raf(flush);
    }
  }
};
const consume = (queue) => {
  for (let i = 0; i < queue.length; i++) {
    try {
      queue[i](performance.now());
    } catch (e) {
      consoleError(e);
    }
  }
  queue.length = 0;
};
const flush = () => {
  consume(queueDomReads);
  {
    consume(queueDomWrites);
    if (queuePending = queueDomReads.length > 0) {
      plt.raf(flush);
    }
  }
};
const nextTick = (cb) => promiseResolve().then(cb);
const writeTask = /* @__PURE__ */ queueTask(queueDomWrites, true);
(function() {
  var n = window.Document.prototype.createElement, p = window.Document.prototype.createElementNS, aa = window.Document.prototype.importNode, ba = window.Document.prototype.prepend, ca = window.Document.prototype.append, da = window.DocumentFragment.prototype.prepend, ea = window.DocumentFragment.prototype.append, q = window.Node.prototype.cloneNode, r = window.Node.prototype.appendChild, t = window.Node.prototype.insertBefore, u = window.Node.prototype.removeChild, v = window.Node.prototype.replaceChild, w = Object.getOwnPropertyDescriptor(
    window.Node.prototype,
    "textContent"
  ), y = window.Element.prototype.attachShadow, z = Object.getOwnPropertyDescriptor(window.Element.prototype, "innerHTML"), A = window.Element.prototype.getAttribute, B = window.Element.prototype.setAttribute, C = window.Element.prototype.removeAttribute, D = window.Element.prototype.toggleAttribute, E = window.Element.prototype.getAttributeNS, F = window.Element.prototype.setAttributeNS, G = window.Element.prototype.removeAttributeNS, H2 = window.Element.prototype.insertAdjacentElement, fa = window.Element.prototype.insertAdjacentHTML, ha = window.Element.prototype.prepend, ia = window.Element.prototype.append, ja = window.Element.prototype.before, ka = window.Element.prototype.after, la = window.Element.prototype.replaceWith, ma = window.Element.prototype.remove, na = window.HTMLElement, I = Object.getOwnPropertyDescriptor(window.HTMLElement.prototype, "innerHTML"), oa = window.HTMLElement.prototype.insertAdjacentElement, pa = window.HTMLElement.prototype.insertAdjacentHTML;
  var qa = /* @__PURE__ */ new Set();
  "annotation-xml color-profile font-face font-face-src font-face-uri font-face-format font-face-name missing-glyph".split(" ").forEach(function(a) {
    return qa.add(a);
  });
  function ra(a) {
    var b = qa.has(a);
    a = /^[a-z][.0-9_a-z]*-[-.0-9_a-z]*$/.test(a);
    return !b && a;
  }
  var sa = document.contains ? document.contains.bind(document) : document.documentElement.contains.bind(document.documentElement);
  function J(a) {
    var b = a.isConnected;
    if (void 0 !== b) return b;
    if (sa(a)) return true;
    for (; a && !(a.__CE_isImportDocument || a instanceof Document); ) a = a.parentNode || (window.ShadowRoot && a instanceof ShadowRoot ? a.host : void 0);
    return !(!a || !(a.__CE_isImportDocument || a instanceof Document));
  }
  function K(a) {
    var b = a.children;
    if (b) return Array.prototype.slice.call(b);
    b = [];
    for (a = a.firstChild; a; a = a.nextSibling) a.nodeType === Node.ELEMENT_NODE && b.push(a);
    return b;
  }
  function L(a, b) {
    for (; b && b !== a && !b.nextSibling; ) b = b.parentNode;
    return b && b !== a ? b.nextSibling : null;
  }
  function M(a, b, d) {
    for (var f = a; f; ) {
      if (f.nodeType === Node.ELEMENT_NODE) {
        var c = f;
        b(c);
        var e = c.localName;
        if ("link" === e && "import" === c.getAttribute("rel")) {
          f = c.import;
          void 0 === d && (d = /* @__PURE__ */ new Set());
          if (f instanceof Node && !d.has(f)) for (d.add(f), f = f.firstChild; f; f = f.nextSibling) M(f, b, d);
          f = L(a, c);
          continue;
        } else if ("template" === e) {
          f = L(a, c);
          continue;
        }
        if (c = c.__CE_shadowRoot) for (c = c.firstChild; c; c = c.nextSibling) M(c, b, d);
      }
      f = f.firstChild ? f.firstChild : L(a, f);
    }
  }
  function N() {
    var a = !(null === O || void 0 === O || !O.noDocumentConstructionObserver), b = !(null === O || void 0 === O || !O.shadyDomFastWalk);
    this.m = [];
    this.g = [];
    this.j = false;
    this.shadyDomFastWalk = b;
    this.I = !a;
  }
  function P(a, b, d, f) {
    var c = window.ShadyDOM;
    if (a.shadyDomFastWalk && c && c.inUse) {
      if (b.nodeType === Node.ELEMENT_NODE && d(b), b.querySelectorAll) for (a = c.nativeMethods.querySelectorAll.call(b, "*"), b = 0; b < a.length; b++) d(a[b]);
    } else M(b, d, f);
  }
  function ta(a, b) {
    a.j = true;
    a.m.push(b);
  }
  function ua(a, b) {
    a.j = true;
    a.g.push(b);
  }
  function Q(a, b) {
    a.j && P(a, b, function(d) {
      return R(a, d);
    });
  }
  function R(a, b) {
    if (a.j && !b.__CE_patched) {
      b.__CE_patched = true;
      for (var d = 0; d < a.m.length; d++) a.m[d](b);
      for (d = 0; d < a.g.length; d++) a.g[d](b);
    }
  }
  function S(a, b) {
    var d = [];
    P(a, b, function(c) {
      return d.push(c);
    });
    for (b = 0; b < d.length; b++) {
      var f = d[b];
      1 === f.__CE_state ? a.connectedCallback(f) : T(a, f);
    }
  }
  function U(a, b) {
    var d = [];
    P(a, b, function(c) {
      return d.push(c);
    });
    for (b = 0; b < d.length; b++) {
      var f = d[b];
      1 === f.__CE_state && a.disconnectedCallback(f);
    }
  }
  function V(a, b, d) {
    d = void 0 === d ? {} : d;
    var f = d.J, c = d.upgrade || function(g) {
      return T(a, g);
    }, e = [];
    P(a, b, function(g) {
      a.j && R(a, g);
      if ("link" === g.localName && "import" === g.getAttribute("rel")) {
        var h2 = g.import;
        h2 instanceof Node && (h2.__CE_isImportDocument = true, h2.__CE_registry = document.__CE_registry);
        h2 && "complete" === h2.readyState ? h2.__CE_documentLoadHandled = true : g.addEventListener("load", function() {
          var k = g.import;
          if (!k.__CE_documentLoadHandled) {
            k.__CE_documentLoadHandled = true;
            var l = /* @__PURE__ */ new Set();
            f && (f.forEach(function(m) {
              return l.add(m);
            }), l.delete(k));
            V(a, k, { J: l, upgrade: c });
          }
        });
      } else e.push(g);
    }, f);
    for (b = 0; b < e.length; b++) c(e[b]);
  }
  function T(a, b) {
    try {
      var d = b.ownerDocument, f = d.__CE_registry;
      var c = f && (d.defaultView || d.__CE_isImportDocument) ? W(f, b.localName) : void 0;
      if (c && void 0 === b.__CE_state) {
        c.constructionStack.push(b);
        try {
          try {
            if (new c.constructorFunction() !== b) throw Error("The custom element constructor did not produce the element being upgraded.");
          } finally {
            c.constructionStack.pop();
          }
        } catch (k) {
          throw b.__CE_state = 2, k;
        }
        b.__CE_state = 1;
        b.__CE_definition = c;
        if (c.attributeChangedCallback && b.hasAttributes()) {
          var e = c.observedAttributes;
          for (c = 0; c < e.length; c++) {
            var g = e[c], h2 = b.getAttribute(g);
            null !== h2 && a.attributeChangedCallback(b, g, null, h2, null);
          }
        }
        J(b) && a.connectedCallback(b);
      }
    } catch (k) {
      X(k);
    }
  }
  N.prototype.connectedCallback = function(a) {
    var b = a.__CE_definition;
    if (b.connectedCallback) try {
      b.connectedCallback.call(a);
    } catch (d) {
      X(d);
    }
  };
  N.prototype.disconnectedCallback = function(a) {
    var b = a.__CE_definition;
    if (b.disconnectedCallback) try {
      b.disconnectedCallback.call(a);
    } catch (d) {
      X(d);
    }
  };
  N.prototype.attributeChangedCallback = function(a, b, d, f, c) {
    var e = a.__CE_definition;
    if (e.attributeChangedCallback && -1 < e.observedAttributes.indexOf(b)) try {
      e.attributeChangedCallback.call(a, b, d, f, c);
    } catch (g) {
      X(g);
    }
  };
  function va(a, b, d, f) {
    var c = b.__CE_registry;
    if (c && (null === f || "http://www.w3.org/1999/xhtml" === f) && (c = W(c, d))) try {
      var e = new c.constructorFunction();
      if (void 0 === e.__CE_state || void 0 === e.__CE_definition) throw Error("Failed to construct '" + d + "': The returned value was not constructed with the HTMLElement constructor.");
      if ("http://www.w3.org/1999/xhtml" !== e.namespaceURI) throw Error("Failed to construct '" + d + "': The constructed element's namespace must be the HTML namespace.");
      if (e.hasAttributes()) throw Error("Failed to construct '" + d + "': The constructed element must not have any attributes.");
      if (null !== e.firstChild) throw Error("Failed to construct '" + d + "': The constructed element must not have any children.");
      if (null !== e.parentNode) throw Error("Failed to construct '" + d + "': The constructed element must not have a parent node.");
      if (e.ownerDocument !== b) throw Error("Failed to construct '" + d + "': The constructed element's owner document is incorrect.");
      if (e.localName !== d) throw Error("Failed to construct '" + d + "': The constructed element's local name is incorrect.");
      return e;
    } catch (g) {
      return X(g), b = null === f ? n.call(b, d) : p.call(b, f, d), Object.setPrototypeOf(b, HTMLUnknownElement.prototype), b.__CE_state = 2, b.__CE_definition = void 0, R(a, b), b;
    }
    b = null === f ? n.call(b, d) : p.call(b, f, d);
    R(a, b);
    return b;
  }
  function X(a) {
    var b = "", d = "", f = 0, c = 0;
    a instanceof Error ? (b = a.message, d = a.sourceURL || a.fileName || "", f = a.line || a.lineNumber || 0, c = a.column || a.columnNumber || 0) : b = "Uncaught " + String(a);
    var e = void 0;
    void 0 === ErrorEvent.prototype.initErrorEvent ? e = new ErrorEvent("error", { cancelable: true, message: b, filename: d, lineno: f, colno: c, error: a }) : (e = document.createEvent("ErrorEvent"), e.initErrorEvent("error", false, true, b, d, f), e.preventDefault = function() {
      Object.defineProperty(this, "defaultPrevented", { configurable: true, get: function() {
        return true;
      } });
    });
    void 0 === e.error && Object.defineProperty(e, "error", { configurable: true, enumerable: true, get: function() {
      return a;
    } });
    window.dispatchEvent(e);
    e.defaultPrevented || console.error(a);
  }
  function wa() {
    var a = this;
    this.g = void 0;
    this.F = new Promise(function(b) {
      a.l = b;
    });
  }
  wa.prototype.resolve = function(a) {
    if (this.g) throw Error("Already resolved.");
    this.g = a;
    this.l(a);
  };
  function xa(a) {
    var b = document;
    this.l = void 0;
    this.h = a;
    this.g = b;
    V(this.h, this.g);
    "loading" === this.g.readyState && (this.l = new MutationObserver(this.G.bind(this)), this.l.observe(this.g, { childList: true, subtree: true }));
  }
  function ya(a) {
    a.l && a.l.disconnect();
  }
  xa.prototype.G = function(a) {
    var b = this.g.readyState;
    "interactive" !== b && "complete" !== b || ya(this);
    for (b = 0; b < a.length; b++) for (var d = a[b].addedNodes, f = 0; f < d.length; f++) V(this.h, d[f]);
  };
  function Y(a) {
    this.s = /* @__PURE__ */ new Map();
    this.u = /* @__PURE__ */ new Map();
    this.C = /* @__PURE__ */ new Map();
    this.A = false;
    this.B = /* @__PURE__ */ new Map();
    this.o = function(b) {
      return b();
    };
    this.i = false;
    this.v = [];
    this.h = a;
    this.D = a.I ? new xa(a) : void 0;
  }
  Y.prototype.H = function(a, b) {
    var d = this;
    if (!(b instanceof Function)) throw new TypeError("Custom element constructor getters must be functions.");
    za(this, a);
    this.s.set(a, b);
    this.v.push(a);
    this.i || (this.i = true, this.o(function() {
      return Aa(d);
    }));
  };
  Y.prototype.define = function(a, b) {
    var d = this;
    if (!(b instanceof Function)) throw new TypeError("Custom element constructors must be functions.");
    za(this, a);
    Ba(this, a, b);
    this.v.push(a);
    this.i || (this.i = true, this.o(function() {
      return Aa(d);
    }));
  };
  function za(a, b) {
    if (!ra(b)) throw new SyntaxError("The element name '" + b + "' is not valid.");
    if (W(a, b)) throw Error("A custom element with name '" + (b + "' has already been defined."));
    if (a.A) throw Error("A custom element is already being defined.");
  }
  function Ba(a, b, d) {
    a.A = true;
    var f;
    try {
      var c = d.prototype;
      if (!(c instanceof Object)) throw new TypeError("The custom element constructor's prototype is not an object.");
      var e = function(m) {
        var x = c[m];
        if (void 0 !== x && !(x instanceof Function)) throw Error("The '" + m + "' callback must be a function.");
        return x;
      };
      var g = e("connectedCallback");
      var h2 = e("disconnectedCallback");
      var k = e("adoptedCallback");
      var l = (f = e("attributeChangedCallback")) && d.observedAttributes || [];
    } catch (m) {
      throw m;
    } finally {
      a.A = false;
    }
    d = {
      localName: b,
      constructorFunction: d,
      connectedCallback: g,
      disconnectedCallback: h2,
      adoptedCallback: k,
      attributeChangedCallback: f,
      observedAttributes: l,
      constructionStack: []
    };
    a.u.set(b, d);
    a.C.set(d.constructorFunction, d);
    return d;
  }
  Y.prototype.upgrade = function(a) {
    V(this.h, a);
  };
  function Aa(a) {
    if (false !== a.i) {
      a.i = false;
      for (var b = [], d = a.v, f = /* @__PURE__ */ new Map(), c = 0; c < d.length; c++) f.set(d[c], []);
      V(a.h, document, { upgrade: function(k) {
        if (void 0 === k.__CE_state) {
          var l = k.localName, m = f.get(l);
          m ? m.push(k) : a.u.has(l) && b.push(k);
        }
      } });
      for (c = 0; c < b.length; c++) T(a.h, b[c]);
      for (c = 0; c < d.length; c++) {
        for (var e = d[c], g = f.get(e), h2 = 0; h2 < g.length; h2++) T(a.h, g[h2]);
        (e = a.B.get(e)) && e.resolve(void 0);
      }
      d.length = 0;
    }
  }
  Y.prototype.get = function(a) {
    if (a = W(this, a)) return a.constructorFunction;
  };
  Y.prototype.whenDefined = function(a) {
    if (!ra(a)) return Promise.reject(new SyntaxError("'" + a + "' is not a valid custom element name."));
    var b = this.B.get(a);
    if (b) return b.F;
    b = new wa();
    this.B.set(a, b);
    var d = this.u.has(a) || this.s.has(a);
    a = -1 === this.v.indexOf(a);
    d && a && b.resolve(void 0);
    return b.F;
  };
  Y.prototype.polyfillWrapFlushCallback = function(a) {
    this.D && ya(this.D);
    var b = this.o;
    this.o = function(d) {
      return a(function() {
        return b(d);
      });
    };
  };
  function W(a, b) {
    var d = a.u.get(b);
    if (d) return d;
    if (d = a.s.get(b)) {
      a.s.delete(b);
      try {
        return Ba(a, b, d());
      } catch (f) {
        X(f);
      }
    }
  }
  Y.prototype.define = Y.prototype.define;
  Y.prototype.upgrade = Y.prototype.upgrade;
  Y.prototype.get = Y.prototype.get;
  Y.prototype.whenDefined = Y.prototype.whenDefined;
  Y.prototype.polyfillDefineLazy = Y.prototype.H;
  Y.prototype.polyfillWrapFlushCallback = Y.prototype.polyfillWrapFlushCallback;
  function Z(a, b, d) {
    function f(c) {
      return function(e) {
        for (var g = [], h2 = 0; h2 < arguments.length; ++h2) g[h2] = arguments[h2];
        h2 = [];
        for (var k = [], l = 0; l < g.length; l++) {
          var m = g[l];
          m instanceof Element && J(m) && k.push(m);
          if (m instanceof DocumentFragment) for (m = m.firstChild; m; m = m.nextSibling) h2.push(m);
          else h2.push(m);
        }
        c.apply(this, g);
        for (g = 0; g < k.length; g++) U(a, k[g]);
        if (J(this)) for (g = 0; g < h2.length; g++) k = h2[g], k instanceof Element && S(a, k);
      };
    }
    void 0 !== d.prepend && (b.prepend = f(d.prepend));
    void 0 !== d.append && (b.append = f(d.append));
  }
  function Ca(a) {
    Document.prototype.createElement = function(b) {
      return va(a, this, b, null);
    };
    Document.prototype.importNode = function(b, d) {
      b = aa.call(this, b, !!d);
      this.__CE_registry ? V(a, b) : Q(a, b);
      return b;
    };
    Document.prototype.createElementNS = function(b, d) {
      return va(a, this, d, b);
    };
    Z(a, Document.prototype, { prepend: ba, append: ca });
  }
  function Da(a) {
    function b(f) {
      return function(c) {
        for (var e = [], g = 0; g < arguments.length; ++g) e[g] = arguments[g];
        g = [];
        for (var h2 = [], k = 0; k < e.length; k++) {
          var l = e[k];
          l instanceof Element && J(l) && h2.push(l);
          if (l instanceof DocumentFragment) for (l = l.firstChild; l; l = l.nextSibling) g.push(l);
          else g.push(l);
        }
        f.apply(this, e);
        for (e = 0; e < h2.length; e++) U(a, h2[e]);
        if (J(this)) for (e = 0; e < g.length; e++) h2 = g[e], h2 instanceof Element && S(a, h2);
      };
    }
    var d = Element.prototype;
    void 0 !== ja && (d.before = b(ja));
    void 0 !== ka && (d.after = b(ka));
    void 0 !== la && (d.replaceWith = function(f) {
      for (var c = [], e = 0; e < arguments.length; ++e) c[e] = arguments[e];
      e = [];
      for (var g = [], h2 = 0; h2 < c.length; h2++) {
        var k = c[h2];
        k instanceof Element && J(k) && g.push(k);
        if (k instanceof DocumentFragment) for (k = k.firstChild; k; k = k.nextSibling) e.push(k);
        else e.push(k);
      }
      h2 = J(this);
      la.apply(this, c);
      for (c = 0; c < g.length; c++) U(a, g[c]);
      if (h2) for (U(a, this), c = 0; c < e.length; c++) g = e[c], g instanceof Element && S(a, g);
    });
    void 0 !== ma && (d.remove = function() {
      var f = J(this);
      ma.call(this);
      f && U(a, this);
    });
  }
  function Ea(a) {
    function b(c, e) {
      Object.defineProperty(c, "innerHTML", { enumerable: e.enumerable, configurable: true, get: e.get, set: function(g) {
        var h2 = this, k = void 0;
        J(this) && (k = [], P(a, this, function(x) {
          x !== h2 && k.push(x);
        }));
        e.set.call(this, g);
        if (k) for (var l = 0; l < k.length; l++) {
          var m = k[l];
          1 === m.__CE_state && a.disconnectedCallback(m);
        }
        this.ownerDocument.__CE_registry ? V(a, this) : Q(a, this);
        return g;
      } });
    }
    function d(c, e) {
      c.insertAdjacentElement = function(g, h2) {
        var k = J(h2);
        g = e.call(this, g, h2);
        k && U(a, h2);
        J(g) && S(a, h2);
        return g;
      };
    }
    function f(c, e) {
      function g(h2, k) {
        for (var l = []; h2 !== k; h2 = h2.nextSibling) l.push(h2);
        for (k = 0; k < l.length; k++) V(a, l[k]);
      }
      c.insertAdjacentHTML = function(h2, k) {
        h2 = h2.toLowerCase();
        if ("beforebegin" === h2) {
          var l = this.previousSibling;
          e.call(this, h2, k);
          g(l || this.parentNode.firstChild, this);
        } else if ("afterbegin" === h2) l = this.firstChild, e.call(this, h2, k), g(this.firstChild, l);
        else if ("beforeend" === h2) l = this.lastChild, e.call(this, h2, k), g(l || this.firstChild, null);
        else if ("afterend" === h2) l = this.nextSibling, e.call(this, h2, k), g(this.nextSibling, l);
        else throw new SyntaxError("The value provided (" + String(h2) + ") is not one of 'beforebegin', 'afterbegin', 'beforeend', or 'afterend'.");
      };
    }
    y && (Element.prototype.attachShadow = function(c) {
      c = y.call(this, c);
      if (a.j && !c.__CE_patched) {
        c.__CE_patched = true;
        for (var e = 0; e < a.m.length; e++) a.m[e](c);
      }
      return this.__CE_shadowRoot = c;
    });
    z && z.get ? b(Element.prototype, z) : I && I.get ? b(HTMLElement.prototype, I) : ua(a, function(c) {
      b(c, { enumerable: true, configurable: true, get: function() {
        return q.call(this, true).innerHTML;
      }, set: function(e) {
        var g = "template" === this.localName, h2 = g ? this.content : this, k = p.call(document, this.namespaceURI, this.localName);
        for (k.innerHTML = e; 0 < h2.childNodes.length; ) u.call(h2, h2.childNodes[0]);
        for (e = g ? k.content : k; 0 < e.childNodes.length; ) r.call(h2, e.childNodes[0]);
      } });
    });
    Element.prototype.setAttribute = function(c, e) {
      if (1 !== this.__CE_state) return B.call(this, c, e);
      var g = A.call(this, c);
      B.call(this, c, e);
      e = A.call(this, c);
      a.attributeChangedCallback(this, c, g, e, null);
    };
    Element.prototype.setAttributeNS = function(c, e, g) {
      if (1 !== this.__CE_state) return F.call(
        this,
        c,
        e,
        g
      );
      var h2 = E.call(this, c, e);
      F.call(this, c, e, g);
      g = E.call(this, c, e);
      a.attributeChangedCallback(this, e, h2, g, c);
    };
    Element.prototype.removeAttribute = function(c) {
      if (1 !== this.__CE_state) return C.call(this, c);
      var e = A.call(this, c);
      C.call(this, c);
      null !== e && a.attributeChangedCallback(this, c, e, null, null);
    };
    D && (Element.prototype.toggleAttribute = function(c, e) {
      if (1 !== this.__CE_state) return D.call(this, c, e);
      var g = A.call(this, c), h2 = null !== g;
      e = D.call(this, c, e);
      h2 !== e && a.attributeChangedCallback(this, c, g, e ? "" : null, null);
      return e;
    });
    Element.prototype.removeAttributeNS = function(c, e) {
      if (1 !== this.__CE_state) return G.call(this, c, e);
      var g = E.call(this, c, e);
      G.call(this, c, e);
      var h2 = E.call(this, c, e);
      g !== h2 && a.attributeChangedCallback(this, e, g, h2, c);
    };
    oa ? d(HTMLElement.prototype, oa) : H2 && d(Element.prototype, H2);
    pa ? f(HTMLElement.prototype, pa) : fa && f(Element.prototype, fa);
    Z(a, Element.prototype, { prepend: ha, append: ia });
    Da(a);
  }
  var Fa = {};
  function Ga(a) {
    function b() {
      var d = this.constructor;
      var f = document.__CE_registry.C.get(d);
      if (!f) throw Error("Failed to construct a custom element: The constructor was not registered with `customElements`.");
      var c = f.constructionStack;
      if (0 === c.length) return c = n.call(document, f.localName), Object.setPrototypeOf(c, d.prototype), c.__CE_state = 1, c.__CE_definition = f, R(a, c), c;
      var e = c.length - 1, g = c[e];
      if (g === Fa) throw Error("Failed to construct '" + f.localName + "': This element was already constructed.");
      c[e] = Fa;
      Object.setPrototypeOf(g, d.prototype);
      R(a, g);
      return g;
    }
    b.prototype = na.prototype;
    Object.defineProperty(HTMLElement.prototype, "constructor", { writable: true, configurable: true, enumerable: false, value: b });
    window.HTMLElement = b;
  }
  function Ha(a) {
    function b(d, f) {
      Object.defineProperty(d, "textContent", { enumerable: f.enumerable, configurable: true, get: f.get, set: function(c) {
        if (this.nodeType === Node.TEXT_NODE) f.set.call(this, c);
        else {
          var e = void 0;
          if (this.firstChild) {
            var g = this.childNodes, h2 = g.length;
            if (0 < h2 && J(this)) {
              e = Array(h2);
              for (var k = 0; k < h2; k++) e[k] = g[k];
            }
          }
          f.set.call(this, c);
          if (e) for (c = 0; c < e.length; c++) U(a, e[c]);
        }
      } });
    }
    Node.prototype.insertBefore = function(d, f) {
      if (d instanceof DocumentFragment) {
        var c = K(d);
        d = t.call(this, d, f);
        if (J(this)) for (f = 0; f < c.length; f++) S(a, c[f]);
        return d;
      }
      c = d instanceof Element && J(d);
      f = t.call(this, d, f);
      c && U(a, d);
      J(this) && S(a, d);
      return f;
    };
    Node.prototype.appendChild = function(d) {
      if (d instanceof DocumentFragment) {
        var f = K(d);
        d = r.call(this, d);
        if (J(this)) for (var c = 0; c < f.length; c++) S(a, f[c]);
        return d;
      }
      f = d instanceof Element && J(d);
      c = r.call(this, d);
      f && U(a, d);
      J(this) && S(a, d);
      return c;
    };
    Node.prototype.cloneNode = function(d) {
      d = q.call(this, !!d);
      this.ownerDocument.__CE_registry ? V(a, d) : Q(a, d);
      return d;
    };
    Node.prototype.removeChild = function(d) {
      var f = d instanceof Element && J(d), c = u.call(this, d);
      f && U(a, d);
      return c;
    };
    Node.prototype.replaceChild = function(d, f) {
      if (d instanceof DocumentFragment) {
        var c = K(d);
        d = v.call(this, d, f);
        if (J(this)) for (U(a, f), f = 0; f < c.length; f++) S(a, c[f]);
        return d;
      }
      c = d instanceof Element && J(d);
      var e = v.call(this, d, f), g = J(this);
      g && U(a, f);
      c && U(a, d);
      g && S(a, d);
      return e;
    };
    w && w.get ? b(Node.prototype, w) : ta(a, function(d) {
      b(d, { enumerable: true, configurable: true, get: function() {
        for (var f = [], c = this.firstChild; c; c = c.nextSibling) c.nodeType !== Node.COMMENT_NODE && f.push(c.textContent);
        return f.join("");
      }, set: function(f) {
        for (; this.firstChild; ) u.call(this, this.firstChild);
        null != f && "" !== f && r.call(this, document.createTextNode(f));
      } });
    });
  }
  var O = window.customElements;
  function Ia() {
    var a = new N();
    Ga(a);
    Ca(a);
    Z(a, DocumentFragment.prototype, { prepend: da, append: ea });
    Ha(a);
    Ea(a);
    window.CustomElementRegistry = Y;
    a = new Y(a);
    document.__CE_registry = a;
    Object.defineProperty(window, "customElements", { configurable: true, enumerable: true, value: a });
  }
  O && !O.forcePolyfill && "function" == typeof O.define && "function" == typeof O.get || Ia();
  window.__CE_installPolyfill = Ia;
}).call(self);
/*!
 * css-vars-ponyfill
 * v2.4.9
 * https://jhildenbiddle.github.io/css-vars-ponyfill/
 * (c) 2018-2024 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/*!
 * get-css-data
 * v2.1.0
 * https://github.com/jhildenbiddle/get-css-data
 * (c) 2018-2022 John Hildenbiddle <http://hildenbiddle.com>
 * MIT license
 */
function getUrls(urls) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var settings = {
    mimeType: options.mimeType || null,
    onBeforeSend: options.onBeforeSend || Function.prototype,
    onSuccess: options.onSuccess || Function.prototype,
    onError: options.onError || Function.prototype,
    onComplete: options.onComplete || Function.prototype
  };
  var urlArray = Array.isArray(urls) ? urls : [urls];
  var urlQueue = Array.apply(null, Array(urlArray.length)).map(function(x) {
    return null;
  });
  function isValidCss(text) {
    var isString = typeof text === "string";
    var isHTML = isString && text.trim().charAt(0) === "<";
    return isString && !isHTML;
  }
  function onError2(xhr, urlIndex) {
    settings.onError(xhr, urlArray[urlIndex], urlIndex);
  }
  function onSuccess2(responseText, urlIndex) {
    var returnVal = settings.onSuccess(responseText, urlArray[urlIndex], urlIndex);
    responseText = returnVal === false ? "" : returnVal || responseText;
    urlQueue[urlIndex] = responseText;
    if (urlQueue.indexOf(null) === -1) {
      settings.onComplete(urlQueue);
    }
  }
  var parser = document.createElement("a");
  urlArray.forEach(function(url, i) {
    parser.setAttribute("href", url);
    parser.href = String(parser.href);
    var isIElte9 = Boolean(document.all && !window.atob);
    var isIElte9CORS = isIElte9 && parser.host.split(":")[0] !== location.host.split(":")[0];
    if (isIElte9CORS) {
      var isSameProtocol = parser.protocol === location.protocol;
      if (isSameProtocol) {
        var xdr = new XDomainRequest();
        xdr.open("GET", url);
        xdr.timeout = 0;
        xdr.onprogress = Function.prototype;
        xdr.ontimeout = Function.prototype;
        xdr.onload = function() {
          var text = xdr.responseText;
          if (isValidCss(text)) {
            onSuccess2(text, i);
          } else {
            onError2(xdr, i);
          }
        };
        xdr.onerror = function(err) {
          onError2(xdr, i);
        };
        setTimeout(function() {
          xdr.send();
        }, 0);
      } else {
        console.warn("Internet Explorer 9 Cross-Origin (CORS) requests must use the same protocol (".concat(url, ")"));
        onError2(null, i);
      }
    } else {
      var xhr = new XMLHttpRequest();
      xhr.open("GET", url);
      if (settings.mimeType && xhr.overrideMimeType) {
        xhr.overrideMimeType(settings.mimeType);
      }
      settings.onBeforeSend(xhr, url, i);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          var text = xhr.responseText;
          if (xhr.status < 400 && isValidCss(text)) {
            onSuccess2(text, i);
          } else if (xhr.status === 0 && isValidCss(text)) {
            onSuccess2(text, i);
          } else {
            onError2(xhr, i);
          }
        }
      };
      xhr.send();
    }
  });
}
/**
 * Gets CSS data from <style> and <link> nodes (including @imports), then
 * returns data in order processed by DOM. Allows specifying nodes to
 * include/exclude and filtering CSS data using RegEx.
 *
 * @preserve
 * @param {object}   [options] The options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes.
 * @param {string}   [options.include] CSS selector matching <link> and <style>
 *                   nodes to include
 * @param {string}   [options.exclude] CSS selector matching <link> and <style>
 *                   nodes to exclude
 * @param {object}   [options.filter] Regular expression used to filter node CSS
 *                   data. Each block of CSS data is tested against the filter,
 *                   and only matching data is included.
 * @param {boolean}  [options.skipDisabled=true] Determines if disabled
 *                   stylesheets will be skipped while collecting CSS data.
 * @param {boolean}  [options.useCSSOM=false] Determines if CSS data will be
 *                   collected from a stylesheet's runtime values instead of its
 *                   text content. This is required to get accurate CSS data
 *                   when a stylesheet has been modified using the deleteRule()
 *                   or insertRule() methods because these modifications will
 *                   not be reflected in the stylesheet's text content.
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments.
 * @param {function} [options.onSuccess] Callback on each CSS node read. Passes
 *                   1) CSS text, 2) source node reference, and 3) the source
 *                   URL as arguments.
 * @param {function} [options.onError] Callback on each error. Passes 1) the XHR
 *                   object for inspection, 2) soure node reference, and 3) the
 *                   source URL that failed (either a <link> href or an @import)
 *                   as arguments
 * @param {function} [options.onComplete] Callback after all nodes have been
 *                   processed. Passes 1) concatenated CSS text, 2) an array of
 *                   CSS text in DOM order, and 3) an array of nodes in DOM
 *                   order as arguments.
 *
 * @example
 *
 *   getCssData({
 *     rootElement : document,
 *     include     : 'style,link[rel="stylesheet"]',
 *     exclude     : '[href="skip.css"]',
 *     filter      : /red/,
 *     skipDisabled: true,
 *     useCSSOM    : false,
 *     onBeforeSend(xhr, node, url) {
 *       // ...
 *     }
 *     onSuccess(cssText, node, url) {
 *       // ...
 *     }
 *     onError(xhr, node, url) {
 *       // ...
 *     },
 *     onComplete(cssText, cssArray, nodeArray) {
 *       // ...
 *     }
 *   });
 */
function getCssData(options) {
  var regex2 = {
    cssComments: /\/\*[\s\S]+?\*\//g,
    cssImports: /(?:@import\s*)(?:url\(\s*)?(?:['"])([^'"]*)(?:['"])(?:\s*\))?(?:[^;]*;)/g
  };
  var settings = {
    rootElement: options.rootElement || document,
    include: options.include || 'style,link[rel="stylesheet"]',
    exclude: options.exclude || null,
    filter: options.filter || null,
    skipDisabled: options.skipDisabled !== false,
    useCSSOM: options.useCSSOM || false,
    onBeforeSend: options.onBeforeSend || Function.prototype,
    onSuccess: options.onSuccess || Function.prototype,
    onError: options.onError || Function.prototype,
    onComplete: options.onComplete || Function.prototype
  };
  var sourceNodes = Array.apply(null, settings.rootElement.querySelectorAll(settings.include)).filter(function(node) {
    return !matchesSelector(node, settings.exclude);
  });
  var cssArray = Array.apply(null, Array(sourceNodes.length)).map(function(x) {
    return null;
  });
  function handleComplete() {
    var isComplete = cssArray.indexOf(null) === -1;
    if (isComplete) {
      cssArray.reduce(function(skipIndices, value, i) {
        if (value === "") {
          skipIndices.push(i);
        }
        return skipIndices;
      }, []).reverse().forEach(function(skipIndex) {
        return [sourceNodes, cssArray].forEach(function(arr) {
          return arr.splice(skipIndex, 1);
        });
      });
      var cssText = cssArray.join("");
      settings.onComplete(cssText, cssArray, sourceNodes);
    }
  }
  function handleSuccess(cssText, cssIndex, node, sourceUrl) {
    var returnVal = settings.onSuccess(cssText, node, sourceUrl);
    cssText = returnVal !== void 0 && Boolean(returnVal) === false ? "" : returnVal || cssText;
    resolveImports(cssText, node, sourceUrl, function(resolvedCssText, errorData) {
      if (cssArray[cssIndex] === null) {
        errorData.forEach(function(data) {
          return settings.onError(data.xhr, node, data.url);
        });
        if (!settings.filter || settings.filter.test(resolvedCssText)) {
          cssArray[cssIndex] = resolvedCssText;
        } else {
          cssArray[cssIndex] = "";
        }
        handleComplete();
      }
    });
  }
  function parseImportData(cssText, baseUrl) {
    var ignoreRules = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var importData = {};
    importData.rules = (cssText.replace(regex2.cssComments, "").match(regex2.cssImports) || []).filter(function(rule) {
      return ignoreRules.indexOf(rule) === -1;
    });
    importData.urls = importData.rules.map(function(rule) {
      return rule.replace(regex2.cssImports, "$1");
    });
    importData.absoluteUrls = importData.urls.map(function(url) {
      return getFullUrl$1(url, baseUrl);
    });
    importData.absoluteRules = importData.rules.map(function(rule, i) {
      var oldUrl = importData.urls[i];
      var newUrl = getFullUrl$1(importData.absoluteUrls[i], baseUrl);
      return rule.replace(oldUrl, newUrl);
    });
    return importData;
  }
  function resolveImports(cssText, node, baseUrl, callbackFn) {
    var __errorData = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : [];
    var __errorRules = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
    var importData = parseImportData(cssText, baseUrl, __errorRules);
    if (importData.rules.length) {
      getUrls(importData.absoluteUrls, {
        onBeforeSend: function onBeforeSend2(xhr, url, urlIndex) {
          settings.onBeforeSend(xhr, node, url);
        },
        onSuccess: function onSuccess2(cssText2, url, urlIndex) {
          var returnVal = settings.onSuccess(cssText2, node, url);
          cssText2 = returnVal === false ? "" : returnVal || cssText2;
          var responseImportData = parseImportData(cssText2, url, __errorRules);
          responseImportData.rules.forEach(function(rule, i) {
            cssText2 = cssText2.replace(rule, responseImportData.absoluteRules[i]);
          });
          return cssText2;
        },
        onError: function onError2(xhr, url, urlIndex) {
          __errorData.push({
            xhr,
            url
          });
          __errorRules.push(importData.rules[urlIndex]);
          resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
        },
        onComplete: function onComplete2(responseArray) {
          responseArray.forEach(function(importText, i) {
            cssText = cssText.replace(importData.rules[i], importText);
          });
          resolveImports(cssText, node, baseUrl, callbackFn, __errorData, __errorRules);
        }
      });
    } else {
      callbackFn(cssText, __errorData);
    }
  }
  if (sourceNodes.length) {
    sourceNodes.forEach(function(node, i) {
      var linkHref = node.getAttribute("href");
      var linkRel = node.getAttribute("rel");
      var isLink = node.nodeName.toLowerCase() === "link" && linkHref && linkRel && linkRel.toLowerCase().indexOf("stylesheet") !== -1;
      var isSkip = settings.skipDisabled === false ? false : node.disabled;
      var isStyle = node.nodeName.toLowerCase() === "style";
      if (isLink && !isSkip) {
        var isURIScheme = linkHref.indexOf("data:text/css") !== -1;
        if (isURIScheme) {
          var cssText = decodeURIComponent(linkHref.substring(linkHref.indexOf(",") + 1));
          if (settings.useCSSOM) {
            cssText = Array.apply(null, node.sheet.cssRules).map(function(rule) {
              return rule.cssText;
            }).join("");
          }
          handleSuccess(cssText, i, node, location.href);
        } else {
          getUrls(linkHref, {
            mimeType: "text/css",
            onBeforeSend: function onBeforeSend2(xhr, url, urlIndex) {
              settings.onBeforeSend(xhr, node, url);
            },
            onSuccess: function onSuccess2(cssText2, url, urlIndex) {
              var sourceUrl = getFullUrl$1(linkHref);
              handleSuccess(cssText2, i, node, sourceUrl);
            },
            onError: function onError2(xhr, url, urlIndex) {
              cssArray[i] = "";
              settings.onError(xhr, node, url);
              handleComplete();
            }
          });
        }
      } else if (isStyle && !isSkip) {
        var _cssText = node.textContent;
        if (settings.useCSSOM) {
          _cssText = Array.apply(null, node.sheet.cssRules).map(function(rule) {
            return rule.cssText;
          }).join("");
        }
        handleSuccess(_cssText, i, node, location.href);
      } else {
        cssArray[i] = "";
        handleComplete();
      }
    });
  } else {
    settings.onComplete("", []);
  }
}
function getFullUrl$1(url, base) {
  var d = document.implementation.createHTMLDocument("");
  var b = d.createElement("base");
  var a = d.createElement("a");
  d.head.appendChild(b);
  d.body.appendChild(a);
  b.href = base || document.baseURI || (document.querySelector("base") || {}).href || location.href;
  a.href = url;
  return a.href;
}
function matchesSelector(elm, selector) {
  var matches = elm.matches || elm.matchesSelector || elm.webkitMatchesSelector || elm.mozMatchesSelector || elm.msMatchesSelector || elm.oMatchesSelector;
  return matches.call(elm, selector);
}
var balancedMatch = balanced;
function balanced(a, b, str) {
  if (a instanceof RegExp) a = maybeMatch(a, str);
  if (b instanceof RegExp) b = maybeMatch(b, str);
  var r = range(a, b, str);
  return r && {
    start: r[0],
    end: r[1],
    pre: str.slice(0, r[0]),
    body: str.slice(r[0] + a.length, r[1]),
    post: str.slice(r[1] + b.length)
  };
}
function maybeMatch(reg, str) {
  var m = str.match(reg);
  return m ? m[0] : null;
}
balanced.range = range;
function range(a, b, str) {
  var begs, beg, left, right, result;
  var ai = str.indexOf(a);
  var bi = str.indexOf(b, ai + 1);
  var i = ai;
  if (ai >= 0 && bi > 0) {
    if (a === b) {
      return [ai, bi];
    }
    begs = [];
    left = str.length;
    while (i >= 0 && !result) {
      if (i == ai) {
        begs.push(i);
        ai = str.indexOf(a, i + 1);
      } else if (begs.length == 1) {
        result = [begs.pop(), bi];
      } else {
        beg = begs.pop();
        if (beg < left) {
          left = beg;
          right = bi;
        }
        bi = str.indexOf(b, i + 1);
      }
      i = ai < bi && ai >= 0 ? ai : bi;
    }
    if (begs.length) {
      result = [left, right];
    }
  }
  return result;
}
function parseCss(css) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var defaults2 = {
    preserveStatic: true,
    removeComments: false
  };
  var settings = _extends({}, defaults2, options);
  var errors = [];
  function error(msg) {
    throw new Error("CSS parse error: ".concat(msg));
  }
  function match(re) {
    var m = re.exec(css);
    if (m) {
      css = css.slice(m[0].length);
      return m;
    }
  }
  function open() {
    return match(/^{\s*/);
  }
  function close() {
    return match(/^}/);
  }
  function whitespace() {
    match(/^\s*/);
  }
  function comment() {
    whitespace();
    if (css[0] !== "/" || css[1] !== "*") {
      return;
    }
    var i = 2;
    while (css[i] && (css[i] !== "*" || css[i + 1] !== "/")) {
      i++;
    }
    if (!css[i]) {
      return error("end of comment is missing");
    }
    var str = css.slice(2, i);
    css = css.slice(i + 2);
    return {
      type: "comment",
      comment: str
    };
  }
  function comments() {
    var cmnts = [];
    var c;
    while (c = comment()) {
      cmnts.push(c);
    }
    return settings.removeComments ? [] : cmnts;
  }
  function selector() {
    whitespace();
    while (css[0] === "}") {
      error("extra closing bracket");
    }
    var m = match(/^(("(?:\\"|[^"])*"|'(?:\\'|[^'])*'|[^{])+)/);
    if (m) {
      var _selector = m[0].trim();
      var selectorItems;
      var hasComment = /\/\*/.test(_selector);
      if (hasComment) {
        _selector = _selector.replace(/\/\*([^*]|[\r\n]|(\*+([^*/]|[\r\n])))*\*\/+/g, "");
      }
      var hasCommaInQuotes = /["']\w*,\w*["']/.test(_selector);
      if (hasCommaInQuotes) {
        _selector = _selector.replace(/"(?:\\"|[^"])*"|'(?:\\'|[^'])*'/g, function(m2) {
          return m2.replace(/,/g, "‌");
        });
      }
      var hasMultipleSelectors = /,/.test(_selector);
      if (hasMultipleSelectors) {
        selectorItems = _selector.split(/\s*(?![^(]*\)),\s*/);
      } else {
        selectorItems = [_selector];
      }
      if (hasCommaInQuotes) {
        selectorItems = selectorItems.map(function(s) {
          return s.replace(/\u200C/g, ",");
        });
      }
      return selectorItems;
    }
  }
  function declaration() {
    if (css[0] === "@") {
      return at_rule();
    }
    match(/^([;\s]*)+/);
    var comment_regexp = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
    var prop = match(/^(\*?[-#/*\\\w.]+(\[[0-9a-z_-]+\])?)\s*/);
    if (!prop) {
      return;
    }
    prop = prop[0].trim();
    if (!match(/^:\s*/)) {
      return error("property missing ':'");
    }
    var val = match(/^((?:\/\*.*?\*\/|'(?:\\'|.)*?'|"(?:\\"|.)*?"|\((\s*'(?:\\'|.)*?'|"(?:\\"|.)*?"|[^)]*?)\s*\)|[^};])+)/);
    var ret = {
      type: "declaration",
      property: prop.replace(comment_regexp, ""),
      value: val ? val[0].replace(comment_regexp, "").trim() : ""
    };
    match(/^[;\s]*/);
    return ret;
  }
  function declarations() {
    if (!open()) {
      return error("missing '{'");
    }
    var d;
    var decls = comments();
    while (d = declaration()) {
      decls.push(d);
      decls = decls.concat(comments());
    }
    if (!close()) {
      return error("missing '}'");
    }
    return decls;
  }
  function keyframe() {
    whitespace();
    var vals = [];
    var m;
    while (m = match(/^((\d+\.\d+|\.\d+|\d+)%?|[a-z]+)\s*/)) {
      vals.push(m[1]);
      match(/^,\s*/);
    }
    if (vals.length) {
      return {
        type: "keyframe",
        values: vals,
        declarations: declarations()
      };
    }
  }
  function at_keyframes() {
    var m = match(/^@([-\w]+)?keyframes\s*/);
    if (!m) {
      return;
    }
    var vendor = m[1];
    m = match(/^([-\w]+)\s*/);
    if (!m) {
      return error("@keyframes missing name");
    }
    var name = m[1];
    if (!open()) {
      return error("@keyframes missing '{'");
    }
    var frame;
    var frames = comments();
    while (frame = keyframe()) {
      frames.push(frame);
      frames = frames.concat(comments());
    }
    if (!close()) {
      return error("@keyframes missing '}'");
    }
    return {
      type: "keyframes",
      name,
      vendor,
      keyframes: frames
    };
  }
  function at_page() {
    var m = match(/^@page */);
    if (m) {
      var sel = selector() || [];
      return {
        type: "page",
        selectors: sel,
        declarations: declarations()
      };
    }
  }
  function at_page_margin_box() {
    var m = match(/@(top|bottom|left|right)-(left|center|right|top|middle|bottom)-?(corner)?\s*/);
    if (m) {
      var name = "".concat(m[1], "-").concat(m[2]) + (m[3] ? "-".concat(m[3]) : "");
      return {
        type: "page-margin-box",
        name,
        declarations: declarations()
      };
    }
  }
  function at_fontface() {
    var m = match(/^@font-face\s*/);
    if (m) {
      return {
        type: "font-face",
        declarations: declarations()
      };
    }
  }
  function at_supports() {
    var m = match(/^@supports *([^{]+)/);
    if (m) {
      return {
        type: "supports",
        supports: m[1].trim(),
        rules: rules()
      };
    }
  }
  function at_host() {
    var m = match(/^@host\s*/);
    if (m) {
      return {
        type: "host",
        rules: rules()
      };
    }
  }
  function at_media() {
    var m = match(/^@media([^{]+)*/);
    if (m) {
      return {
        type: "media",
        media: (m[1] || "").trim(),
        rules: rules()
      };
    }
  }
  function at_custom_m() {
    var m = match(/^@custom-media\s+(--[^\s]+)\s*([^{;]+);/);
    if (m) {
      return {
        type: "custom-media",
        name: m[1].trim(),
        media: m[2].trim()
      };
    }
  }
  function at_document() {
    var m = match(/^@([-\w]+)?document *([^{]+)/);
    if (m) {
      return {
        type: "document",
        document: m[2].trim(),
        vendor: m[1] ? m[1].trim() : null,
        rules: rules()
      };
    }
  }
  function at_x() {
    var m = match(/^@(import|charset|namespace)\s*([^;]+);/);
    if (m) {
      return {
        type: m[1],
        name: m[2].trim()
      };
    }
  }
  function at_rule() {
    whitespace();
    if (css[0] === "@") {
      var ret = at_x() || at_fontface() || at_media() || at_keyframes() || at_supports() || at_document() || at_custom_m() || at_host() || at_page() || at_page_margin_box();
      if (ret && !settings.preserveStatic) {
        var hasVarFunc = false;
        if (ret.declarations) {
          hasVarFunc = ret.declarations.some(function(decl) {
            return /var\(/.test(decl.value);
          });
        } else {
          var arr = ret.keyframes || ret.rules || [];
          hasVarFunc = arr.some(function(obj) {
            return (obj.declarations || []).some(function(decl) {
              return /var\(/.test(decl.value);
            });
          });
        }
        return hasVarFunc ? ret : {};
      }
      return ret;
    }
  }
  function rule() {
    if (!settings.preserveStatic) {
      var balancedMatch$1 = balancedMatch("{", "}", css);
      if (balancedMatch$1) {
        var hasVarDecl = /:(?:root|host)(?![.:#(])/.test(balancedMatch$1.pre) && /--\S*\s*:/.test(balancedMatch$1.body);
        var hasVarFunc = /var\(/.test(balancedMatch$1.body);
        if (!hasVarDecl && !hasVarFunc) {
          css = css.slice(balancedMatch$1.end + 1);
          return {};
        }
      }
    }
    var sel = selector() || [];
    var decls = settings.preserveStatic ? declarations() : declarations().filter(function(decl) {
      var hasVarDecl2 = sel.some(function(s) {
        return /:(?:root|host)(?![.:#(])/.test(s);
      }) && /^--\S/.test(decl.property);
      var hasVarFunc2 = /var\(/.test(decl.value);
      return hasVarDecl2 || hasVarFunc2;
    });
    if (!sel.length) {
      error("selector missing");
    }
    return {
      type: "rule",
      selectors: sel,
      declarations: decls
    };
  }
  function rules(core) {
    if (!core && !open()) {
      return error("missing '{'");
    }
    var node;
    var rules2 = comments();
    while (css.length && (core || css[0] !== "}") && (node = at_rule() || rule())) {
      if (node.type) {
        rules2.push(node);
      }
      rules2 = rules2.concat(comments());
    }
    if (!core && !close()) {
      return error("missing '}'");
    }
    return rules2;
  }
  return {
    type: "stylesheet",
    stylesheet: {
      rules: rules(true),
      errors
    }
  };
}
function parseVars(cssData) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var defaults2 = {
    parseHost: false,
    store: {},
    onWarning: function onWarning2() {
    }
  };
  var settings = _extends({}, defaults2, options);
  var reVarDeclSelectors = new RegExp(":".concat(settings.parseHost ? "host" : "root", "$"));
  if (typeof cssData === "string") {
    cssData = parseCss(cssData, settings);
  }
  cssData.stylesheet.rules.forEach(function(rule) {
    if (rule.type !== "rule" || !rule.selectors.some(function(s) {
      return reVarDeclSelectors.test(s);
    })) {
      return;
    }
    rule.declarations.forEach(function(decl, i) {
      var prop = decl.property;
      var value = decl.value;
      if (prop && prop.indexOf("--") === 0) {
        settings.store[prop] = value;
      }
    });
  });
  return settings.store;
}
function stringifyCss(tree) {
  var delim = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  var cb = arguments.length > 2 ? arguments[2] : void 0;
  var renderMethods = {
    charset: function charset(node) {
      return "@charset " + node.name + ";";
    },
    comment: function comment(node) {
      return node.comment.indexOf("__CSSVARSPONYFILL") === 0 ? "/*" + node.comment + "*/" : "";
    },
    "custom-media": function customMedia(node) {
      return "@custom-media " + node.name + " " + node.media + ";";
    },
    declaration: function declaration(node) {
      return node.property + ":" + node.value + ";";
    },
    document: function document2(node) {
      return "@" + (node.vendor || "") + "document " + node.document + "{" + visit(node.rules) + "}";
    },
    "font-face": function fontFace(node) {
      return "@font-face{" + visit(node.declarations) + "}";
    },
    host: function host(node) {
      return "@host{" + visit(node.rules) + "}";
    },
    import: function _import(node) {
      return "@import " + node.name + ";";
    },
    keyframe: function keyframe(node) {
      return node.values.join(",") + "{" + visit(node.declarations) + "}";
    },
    keyframes: function keyframes(node) {
      return "@" + (node.vendor || "") + "keyframes " + node.name + "{" + visit(node.keyframes) + "}";
    },
    media: function media(node) {
      return "@media " + node.media + "{" + visit(node.rules) + "}";
    },
    namespace: function namespace(node) {
      return "@namespace " + node.name + ";";
    },
    page: function page(node) {
      return "@page " + (node.selectors.length ? node.selectors.join(", ") : "") + "{" + visit(node.declarations) + "}";
    },
    "page-margin-box": function pageMarginBox(node) {
      return "@" + node.name + "{" + visit(node.declarations) + "}";
    },
    rule: function rule(node) {
      var decls = node.declarations;
      if (decls.length) {
        return node.selectors.join(",") + "{" + visit(decls) + "}";
      }
    },
    supports: function supports(node) {
      return "@supports " + node.supports + "{" + visit(node.rules) + "}";
    }
  };
  function visit(nodes) {
    var buf = "";
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (cb) {
        cb(n);
      }
      var txt = renderMethods[n.type](n);
      if (txt) {
        buf += txt;
        if (txt.length && n.selectors) {
          buf += delim;
        }
      }
    }
    return buf;
  }
  return visit(tree.stylesheet.rules);
}
function walkCss(node, fn) {
  node.rules.forEach(function(rule) {
    if (rule.rules) {
      walkCss(rule, fn);
      return;
    }
    if (rule.keyframes) {
      rule.keyframes.forEach(function(keyframe) {
        if (keyframe.type === "keyframe") {
          fn(keyframe.declarations, rule);
        }
      });
      return;
    }
    if (!rule.declarations) {
      return;
    }
    fn(rule.declarations, node);
  });
}
var VAR_PROP_IDENTIFIER = "--";
var VAR_FUNC_IDENTIFIER = "var";
function transformCss(cssData) {
  var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var defaults2 = {
    preserveStatic: true,
    preserveVars: false,
    variables: {},
    onWarning: function onWarning2() {
    }
  };
  var settings = _extends({}, defaults2, options);
  if (typeof cssData === "string") {
    cssData = parseCss(cssData, settings);
  }
  walkCss(cssData.stylesheet, function(declarations, node) {
    for (var i = 0; i < declarations.length; i++) {
      var decl = declarations[i];
      var type = decl.type;
      var prop = decl.property;
      var value = decl.value;
      if (type !== "declaration") {
        continue;
      }
      if (!settings.preserveVars && prop && prop.indexOf(VAR_PROP_IDENTIFIER) === 0) {
        declarations.splice(i, 1);
        i--;
        continue;
      }
      if (value.indexOf(VAR_FUNC_IDENTIFIER + "(") !== -1) {
        var resolvedValue = resolveValue(value, settings);
        if (resolvedValue !== decl.value) {
          resolvedValue = fixNestedCalc(resolvedValue);
          if (!settings.preserveVars) {
            decl.value = resolvedValue;
          } else {
            declarations.splice(i, 0, {
              type,
              property: prop,
              value: resolvedValue
            });
            i++;
          }
        }
      }
    }
  });
  return stringifyCss(cssData);
}
function fixNestedCalc(value) {
  var reCalcVal = /calc\(([^)]+)\)/g;
  (value.match(reCalcVal) || []).forEach(function(match) {
    var newVal = "calc".concat(match.split("calc").join(""));
    value = value.replace(match, newVal);
  });
  return value;
}
function resolveValue(value) {
  var settings = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var __recursiveFallback = arguments.length > 2 ? arguments[2] : void 0;
  if (value.indexOf("var(") === -1) {
    return value;
  }
  var valueData = balancedMatch("(", ")", value);
  function resolveFunc(value2) {
    var name = value2.split(",")[0].replace(/[\s\n\t]/g, "");
    var fallback = (value2.match(/(?:\s*,\s*){1}(.*)?/) || [])[1];
    var match = Object.prototype.hasOwnProperty.call(settings.variables, name) ? String(settings.variables[name]) : void 0;
    var replacement = match || (fallback ? String(fallback) : void 0);
    var unresolvedFallback = __recursiveFallback || value2;
    if (!match) {
      settings.onWarning('variable "'.concat(name, '" is undefined'));
    }
    if (replacement && replacement !== "undefined" && replacement.length > 0) {
      return resolveValue(replacement, settings, unresolvedFallback);
    } else {
      return "var(".concat(unresolvedFallback, ")");
    }
  }
  if (!valueData) {
    if (value.indexOf("var(") !== -1) {
      settings.onWarning('missing closing ")" in the value "'.concat(value, '"'));
    }
    return value;
  } else if (valueData.pre.slice(-3) === "var") {
    var isEmptyVarFunc = valueData.body.trim().length === 0;
    if (isEmptyVarFunc) {
      settings.onWarning("var() must contain a non-whitespace string");
      return value;
    } else {
      return valueData.pre.slice(0, -3) + resolveFunc(valueData.body) + resolveValue(valueData.post, settings);
    }
  } else {
    return valueData.pre + "(".concat(resolveValue(valueData.body, settings), ")") + resolveValue(valueData.post, settings);
  }
}
var isBrowser = typeof window !== "undefined";
var isNativeSupport = isBrowser && window.CSS && window.CSS.supports && window.CSS.supports("(--a: 0)");
var counters = {
  group: 0,
  job: 0
};
var defaults = {
  rootElement: isBrowser ? document : null,
  shadowDOM: false,
  include: "style,link[rel=stylesheet]",
  exclude: "",
  variables: {},
  onlyLegacy: true,
  preserveStatic: true,
  preserveVars: false,
  silent: false,
  updateDOM: true,
  updateURLs: true,
  watch: null,
  onBeforeSend: function onBeforeSend() {
  },
  onError: function onError() {
  },
  onWarning: function onWarning() {
  },
  onSuccess: function onSuccess() {
  },
  onComplete: function onComplete() {
  },
  onFinally: function onFinally() {
  }
};
var regex = {
  cssComments: /\/\*[\s\S]+?\*\//g,
  cssKeyframes: /@(?:-\w*-)?keyframes/,
  cssMediaQueries: /@media[^{]+\{([\s\S]+?})\s*}/g,
  cssUrls: /url\((?!['"]?(?:data|http|\/\/):)['"]?([^'")]*)['"]?\)/g,
  cssVarDeclRules: /(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^}]*})/g,
  cssVarDecls: /(?:[\s;]*)(-{2}\w[\w-]*)(?:\s*:\s*)([^;]*);/g,
  cssVarFunc: /var\(\s*--[\w-]/,
  cssVars: /(?:(?::(?:root|host)(?![.:#(])[\s,]*[^{]*{\s*[^;]*;*\s*)|(?:var\(\s*))(--[^:)]+)(?:\s*[:)])/
};
var variableStore = {
  dom: {},
  job: {},
  user: {}
};
var cssVarsIsRunning = false;
var cssVarsObserver = null;
var cssVarsSrcNodeCount = 0;
var debounceTimer = null;
var isShadowDOMReady = false;
/**
 * Fetches, parses, and transforms CSS custom properties from specified
 * <style> and <link> elements into static values, then appends a new <style>
 * element with static values to the DOM to provide CSS custom property
 * compatibility for legacy browsers. Also provides a single interface for
 * live updates of runtime values in both modern and legacy browsers.
 *
 * @preserve
 * @param {object}   [options] Options object
 * @param {object}   [options.rootElement=document] Root element to traverse for
 *                   <link> and <style> nodes
 * @param {boolean}  [options.shadowDOM=false] Determines if shadow DOM <link>
 *                   and <style> nodes will be processed.
 * @param {string}   [options.include="style,link[rel=stylesheet]"] CSS selector
 *                   matching <link re="stylesheet"> and <style> nodes to
 *                   process
 * @param {string}   [options.exclude] CSS selector matching <link
 *                   rel="stylehseet"> and <style> nodes to exclude from those
 *                   matches by options.include
 * @param {object}   [options.variables] A map of custom property name/value
 *                   pairs. Property names can omit or include the leading
 *                   double-hyphen (—), and values specified will override
 *                   previous values
 * @param {boolean}  [options.onlyLegacy=true] Determines if the ponyfill will
 *                   only generate legacy-compatible CSS in browsers that lack
 *                   native support (i.e., legacy browsers)
 * @param {boolean}  [options.preserveStatic=true] Determines if CSS
 *                   declarations that do not reference a custom property will
 *                   be preserved in the transformed CSS
 * @param {boolean}  [options.preserveVars=false] Determines if CSS custom
 *                   property declarations will be preserved in the transformed
 *                   CSS
 * @param {boolean}  [options.silent=false] Determines if warning and error
 *                   messages will be displayed on the console
 * @param {boolean}  [options.updateDOM=true] Determines if the ponyfill will
 *                   update the DOM after processing CSS custom properties
 * @param {boolean}  [options.updateURLs=true] Determines if relative url()
 *                   paths will be converted to absolute urls in external CSS
 * @param {boolean}  [options.watch=false] Determines if a MutationObserver will
 *                   be created that will execute the ponyfill when a <link> or
 *                   <style> DOM mutation is observed
 * @param {function} [options.onBeforeSend] Callback before XHR is sent. Passes
 *                   1) the XHR object, 2) source node reference, and 3) the
 *                   source URL as arguments
 * @param {function} [options.onError] Callback after a CSS parsing error has
 *                   occurred or an XHR request has failed. Passes 1) an error
 *                   message, and 2) source node reference, 3) xhr, and 4 url as
 *                   arguments.
 * @param {function} [options.onWarning] Callback after each CSS parsing warning
 *                   has occurred. Passes 1) a warning message as an argument.
 * @param {function} [options.onSuccess] Callback after CSS data has been
 *                   collected from each node and before CSS custom properties
 *                   have been transformed. Allows modifying the CSS data before
 *                   it is transformed by returning any string value (or false
 *                   to skip). Passes 1) CSS text, 2) source node reference, and
 *                   3) the source URL as arguments.
 * @param {function} [options.onComplete] Callback after all CSS has been
 *                   processed, legacy-compatible CSS has been generated, and
 *                   (optionally) the DOM has been updated. Passes 1) a CSS
 *                   string with CSS variable values resolved, 2) an array of
 *                   output <style> node references that have been appended to
 *                   the DOM, 3) an object containing all custom properies names
 *                   and values, and 4) the ponyfill execution time in
 *                   milliseconds.
 * @param {function} [options.onFinally] Callback in modern and legacy browsers
 *                   after the ponyfill has finished all tasks. Passes 1) a
 *                   boolean indicating if the last ponyfill call resulted in a
 *                   style change, 2) a boolean indicating if the current
 *                   browser provides native support for CSS custom properties,
 *                   and 3) the ponyfill execution time in milliseconds.
 * @example
 *
 *   cssVars({
 *     rootElement   : document,
 *     shadowDOM     : false,
 *     include       : 'style,link[rel="stylesheet"]',
 *     exclude       : '',
 *     variables     : {},
 *     onlyLegacy    : true,
 *     preserveStatic: true,
 *     preserveVars  : false,
 *     silent        : false,
 *     updateDOM     : true,
 *     updateURLs    : true,
 *     watch         : false,
 *     onBeforeSend(xhr, node, url) {},
 *     onError(message, node, xhr, url) {},
 *     onWarning(message) {},
 *     onSuccess(cssText, node, url) {},
 *     onComplete(cssText, styleNode, cssVariables, benchmark) {},
 *     onFinally(hasChanged, hasNativeSupport, benchmark)
 *   });
 */
function cssVars() {
  var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var msgPrefix = "cssVars(): ";
  var settings = _extends({}, defaults, options);
  function handleError(message, sourceNode, xhr, url) {
    if (!settings.silent && window.console) {
      console.error("".concat(msgPrefix).concat(message, "\n"), sourceNode);
    }
    settings.onError(message, sourceNode, xhr, url);
  }
  function handleWarning(message) {
    if (!settings.silent && window.console) {
      console.warn("".concat(msgPrefix).concat(message));
    }
    settings.onWarning(message);
  }
  function handleFinally(hasChanged) {
    settings.onFinally(Boolean(hasChanged), isNativeSupport, getTimeStamp() - settings.__benchmark);
  }
  if (!isBrowser) {
    return;
  }
  if (settings.watch) {
    settings.watch = defaults.watch;
    addMutationObserver(settings);
    cssVars(settings);
    return;
  } else if (settings.watch === false && cssVarsObserver) {
    cssVarsObserver.disconnect();
    cssVarsObserver = null;
  }
  if (!settings.__benchmark) {
    if (cssVarsIsRunning === settings.rootElement) {
      cssVarsDebounced(options);
      return;
    }
    var srcNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])'));
    settings.__benchmark = getTimeStamp();
    settings.exclude = [cssVarsObserver ? '[data-cssvars]:not([data-cssvars=""])' : '[data-cssvars="out"]', "link[disabled]:not([data-cssvars])", settings.exclude].filter(function(selector) {
      return selector;
    }).join(",");
    settings.variables = fixVarNames(settings.variables);
    srcNodes.forEach(function(srcNode) {
      var hasStyleCache = srcNode.nodeName.toLowerCase() === "style" && srcNode.__cssVars.text;
      var hasStyleChanged = hasStyleCache && srcNode.textContent !== srcNode.__cssVars.text;
      if (hasStyleCache && hasStyleChanged) {
        srcNode.sheet && (srcNode.sheet.disabled = false);
        srcNode.setAttribute("data-cssvars", "");
      }
    });
    if (!cssVarsObserver) {
      var outNodes = [].slice.call(settings.rootElement.querySelectorAll('[data-cssvars="out"]'));
      outNodes.forEach(function(outNode) {
        var dataGroup = outNode.getAttribute("data-cssvars-group");
        var srcNode = dataGroup ? settings.rootElement.querySelector('[data-cssvars="src"][data-cssvars-group="'.concat(dataGroup, '"]')) : null;
        if (!srcNode) {
          outNode.parentNode.removeChild(outNode);
        }
      });
      if (cssVarsSrcNodeCount && srcNodes.length < cssVarsSrcNodeCount) {
        cssVarsSrcNodeCount = srcNodes.length;
        variableStore.dom = {};
      }
    }
  }
  if (document.readyState !== "loading") {
    if (isNativeSupport && settings.onlyLegacy) {
      var hasVarChange = false;
      if (settings.updateDOM) {
        var targetElm = settings.rootElement.host || (settings.rootElement === document ? document.documentElement : settings.rootElement);
        Object.keys(settings.variables).forEach(function(key) {
          var varValue = settings.variables[key];
          hasVarChange = hasVarChange || varValue !== getComputedStyle(targetElm).getPropertyValue(key);
          targetElm.style.setProperty(key, varValue);
        });
      }
      handleFinally(hasVarChange);
    } else if (!isShadowDOMReady && (settings.shadowDOM || settings.rootElement.shadowRoot || settings.rootElement.host)) {
      getCssData({
        rootElement: defaults.rootElement,
        include: defaults.include,
        exclude: settings.exclude,
        skipDisabled: false,
        onSuccess: function onSuccess2(cssText, node, url) {
          var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
          if (isUserDisabled) {
            return false;
          }
          cssText = cssText.replace(regex.cssComments, "").replace(regex.cssMediaQueries, "");
          cssText = (cssText.match(regex.cssVarDeclRules) || []).join("");
          return cssText || false;
        },
        onComplete: function onComplete2(cssText, cssArray, nodeArray) {
          parseVars(cssText, {
            store: variableStore.dom,
            onWarning: handleWarning
          });
          isShadowDOMReady = true;
          cssVars(settings);
        }
      });
    } else {
      cssVarsIsRunning = settings.rootElement;
      getCssData({
        rootElement: settings.rootElement,
        include: settings.include,
        exclude: settings.exclude,
        skipDisabled: false,
        onBeforeSend: settings.onBeforeSend,
        onError: function onError2(xhr, node, url) {
          var responseUrl = xhr.responseURL || getFullUrl(url, location.href);
          var statusText = xhr.statusText ? "(".concat(xhr.statusText, ")") : "Unspecified Error" + (xhr.status === 0 ? " (possibly CORS related)" : "");
          var errorMsg = "CSS XHR Error: ".concat(responseUrl, " ").concat(xhr.status, " ").concat(statusText);
          handleError(errorMsg, node, xhr, responseUrl);
        },
        onSuccess: function onSuccess2(cssText, node, url) {
          var isUserDisabled = (node.sheet || {}).disabled && !node.__cssVars;
          if (isUserDisabled) {
            return false;
          }
          var isLink = node.nodeName.toLowerCase() === "link";
          var isStyleImport = node.nodeName.toLowerCase() === "style" && cssText !== node.textContent;
          var returnVal = settings.onSuccess(cssText, node, url);
          cssText = returnVal !== void 0 && Boolean(returnVal) === false ? "" : returnVal || cssText;
          if (settings.updateURLs && (isLink || isStyleImport)) {
            cssText = fixRelativeCssUrls(cssText, url);
          }
          return cssText;
        },
        onComplete: function onComplete2(cssText, cssArray) {
          var nodeArray = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
          var currentVars = _extends({}, variableStore.dom, variableStore.user);
          var hasVarChange2 = false;
          variableStore.job = {};
          nodeArray.forEach(function(node, i2) {
            var nodeCSS = cssArray[i2];
            node.__cssVars = node.__cssVars || {};
            node.__cssVars.text = nodeCSS;
            if (regex.cssVars.test(nodeCSS)) {
              try {
                var cssTree = parseCss(nodeCSS, {
                  preserveStatic: settings.preserveStatic,
                  removeComments: true
                });
                parseVars(cssTree, {
                  parseHost: Boolean(settings.rootElement.host),
                  store: variableStore.dom,
                  onWarning: handleWarning
                });
                node.__cssVars.tree = cssTree;
              } catch (err) {
                handleError(err.message, node);
              }
            }
          });
          _extends(variableStore.job, variableStore.dom);
          if (settings.updateDOM) {
            _extends(variableStore.user, settings.variables);
            _extends(variableStore.job, variableStore.user);
          } else {
            _extends(variableStore.job, variableStore.user, settings.variables);
            _extends(currentVars, settings.variables);
          }
          hasVarChange2 = counters.job > 0 && Boolean(Object.keys(variableStore.job).length > Object.keys(currentVars).length || Boolean(Object.keys(currentVars).length && Object.keys(variableStore.job).some(function(key) {
            return variableStore.job[key] !== currentVars[key];
          })));
          if (hasVarChange2) {
            resetCssNodes(settings.rootElement);
            cssVars(settings);
          } else {
            var outCssArray = [];
            var outNodeArray = [];
            var hasKeyframesWithVars = false;
            if (settings.updateDOM) {
              counters.job++;
            }
            nodeArray.forEach(function(node, i2) {
              var isSkip = !node.__cssVars.tree;
              if (node.__cssVars.tree) {
                try {
                  transformCss(node.__cssVars.tree, _extends({}, settings, {
                    variables: variableStore.job,
                    onWarning: handleWarning
                  }));
                  var outCss = stringifyCss(node.__cssVars.tree);
                  if (settings.updateDOM) {
                    var nodeCSS = cssArray[i2];
                    var hasCSSVarFunc = regex.cssVarFunc.test(nodeCSS);
                    if (!node.getAttribute("data-cssvars")) {
                      node.setAttribute("data-cssvars", "src");
                    }
                    if (outCss.length && hasCSSVarFunc) {
                      var dataGroup = node.getAttribute("data-cssvars-group") || ++counters.group;
                      var outCssNoSpaces = outCss.replace(/\s/g, "");
                      var outNode = settings.rootElement.querySelector('[data-cssvars="out"][data-cssvars-group="'.concat(dataGroup, '"]')) || document.createElement("style");
                      hasKeyframesWithVars = hasKeyframesWithVars || regex.cssKeyframes.test(outCss);
                      if (settings.preserveStatic) {
                        node.sheet && (node.sheet.disabled = true);
                      }
                      if (!outNode.hasAttribute("data-cssvars")) {
                        outNode.setAttribute("data-cssvars", "out");
                      }
                      if (outCssNoSpaces === node.textContent.replace(/\s/g, "")) {
                        isSkip = true;
                        if (outNode && outNode.parentNode) {
                          node.removeAttribute("data-cssvars-group");
                          outNode.parentNode.removeChild(outNode);
                        }
                      } else if (outCssNoSpaces !== outNode.textContent.replace(/\s/g, "")) {
                        [node, outNode].forEach(function(n) {
                          n.setAttribute("data-cssvars-job", counters.job);
                          n.setAttribute("data-cssvars-group", dataGroup);
                        });
                        outNode.textContent = outCss;
                        outCssArray.push(outCss);
                        outNodeArray.push(outNode);
                        if (!outNode.parentNode) {
                          node.parentNode.insertBefore(outNode, node.nextSibling);
                        }
                      }
                    }
                  } else {
                    if (node.textContent.replace(/\s/g, "") !== outCss) {
                      outCssArray.push(outCss);
                    }
                  }
                } catch (err) {
                  handleError(err.message, node);
                }
              }
              if (isSkip) {
                node.setAttribute("data-cssvars", "skip");
              }
              if (!node.hasAttribute("data-cssvars-job")) {
                node.setAttribute("data-cssvars-job", counters.job);
              }
            });
            cssVarsSrcNodeCount = settings.rootElement.querySelectorAll('[data-cssvars]:not([data-cssvars="out"])').length;
            if (settings.shadowDOM) {
              var elms = [].concat(settings.rootElement).concat([].slice.call(settings.rootElement.querySelectorAll("*")));
              for (var i = 0, elm; elm = elms[i]; ++i) {
                if (elm.shadowRoot && elm.shadowRoot.querySelector("style")) {
                  var shadowSettings = _extends({}, settings, {
                    rootElement: elm.shadowRoot
                  });
                  cssVars(shadowSettings);
                }
              }
            }
            if (settings.updateDOM && hasKeyframesWithVars) {
              fixKeyframes(settings.rootElement);
            }
            cssVarsIsRunning = false;
            settings.onComplete(outCssArray.join(""), outNodeArray, JSON.parse(JSON.stringify(variableStore.job)), getTimeStamp() - settings.__benchmark);
            handleFinally(outNodeArray.length);
          }
        }
      });
    }
  } else {
    document.addEventListener("DOMContentLoaded", function init(evt) {
      cssVars(options);
      document.removeEventListener("DOMContentLoaded", init);
    });
  }
}
cssVars.reset = function() {
  counters.job = 0;
  counters.group = 0;
  cssVarsIsRunning = false;
  if (cssVarsObserver) {
    cssVarsObserver.disconnect();
    cssVarsObserver = null;
  }
  cssVarsSrcNodeCount = 0;
  debounceTimer = null;
  isShadowDOMReady = false;
  for (var prop in variableStore) {
    variableStore[prop] = {};
  }
};
function addMutationObserver(settings) {
  function isDisabled(node) {
    var isDisabledAttr = isLink(node) && node.hasAttribute("disabled");
    var isDisabledSheet = (node.sheet || {}).disabled;
    return isDisabledAttr || isDisabledSheet;
  }
  function isLink(node) {
    var isStylesheet = node.nodeName.toLowerCase() === "link" && (node.getAttribute("rel") || "").indexOf("stylesheet") !== -1;
    return isStylesheet;
  }
  function isStyle(node) {
    return node.nodeName.toLowerCase() === "style";
  }
  function isValidAttributeMutation(mutation) {
    var isValid = false;
    if (mutation.type === "attributes" && isLink(mutation.target) && !isDisabled(mutation.target)) {
      var isEnabledMutation = mutation.attributeName === "disabled";
      var isHrefMutation = mutation.attributeName === "href";
      var isSkipNode = mutation.target.getAttribute("data-cssvars") === "skip";
      var isSrcNode = mutation.target.getAttribute("data-cssvars") === "src";
      if (isEnabledMutation) {
        isValid = !isSkipNode && !isSrcNode;
      } else if (isHrefMutation) {
        if (isSkipNode) {
          mutation.target.setAttribute("data-cssvars", "");
        } else if (isSrcNode) {
          resetCssNodes(settings.rootElement, true);
        }
        isValid = true;
      }
    }
    return isValid;
  }
  function isValidStyleTextMutation(mutation) {
    var isValid = false;
    if (mutation.type === "childList") {
      var isStyleElm = isStyle(mutation.target);
      var isOutNode = mutation.target.getAttribute("data-cssvars") === "out";
      isValid = isStyleElm && !isOutNode;
    }
    return isValid;
  }
  function isValidAddMutation(mutation) {
    var isValid = false;
    if (mutation.type === "childList") {
      isValid = [].slice.call(mutation.addedNodes).some(function(node) {
        var isElm = node.nodeType === 1;
        var hasAttr = isElm && node.hasAttribute("data-cssvars");
        var isStyleWithVars = isStyle(node) && regex.cssVars.test(node.textContent);
        var isValid2 = !hasAttr && (isLink(node) || isStyleWithVars);
        return isValid2 && !isDisabled(node);
      });
    }
    return isValid;
  }
  function isValidRemoveMutation(mutation) {
    var isValid = false;
    if (mutation.type === "childList") {
      isValid = [].slice.call(mutation.removedNodes).some(function(node) {
        var isElm = node.nodeType === 1;
        var isOutNode = isElm && node.getAttribute("data-cssvars") === "out";
        var isSrcNode = isElm && node.getAttribute("data-cssvars") === "src";
        var isValid2 = isSrcNode;
        if (isSrcNode || isOutNode) {
          var dataGroup = node.getAttribute("data-cssvars-group");
          var orphanNode = settings.rootElement.querySelector('[data-cssvars-group="'.concat(dataGroup, '"]'));
          if (isSrcNode) {
            resetCssNodes(settings.rootElement, true);
          }
          if (orphanNode) {
            orphanNode.parentNode.removeChild(orphanNode);
          }
        }
        return isValid2;
      });
    }
    return isValid;
  }
  if (!window.MutationObserver) {
    return;
  }
  if (cssVarsObserver) {
    cssVarsObserver.disconnect();
    cssVarsObserver = null;
  }
  cssVarsObserver = new MutationObserver(function(mutations) {
    var hasValidMutation = mutations.some(function(mutation) {
      return isValidAttributeMutation(mutation) || isValidStyleTextMutation(mutation) || isValidAddMutation(mutation) || isValidRemoveMutation(mutation);
    });
    if (hasValidMutation) {
      cssVars(settings);
    }
  });
  cssVarsObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["disabled", "href"],
    childList: true,
    subtree: true
  });
}
function cssVarsDebounced(settings) {
  var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 100;
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(function() {
    settings.__benchmark = null;
    cssVars(settings);
  }, delay);
}
function fixKeyframes(rootElement) {
  var animationNameProp = ["animation-name", "-moz-animation-name", "-webkit-animation-name"].filter(function(prop) {
    return getComputedStyle(document.body)[prop];
  })[0];
  if (animationNameProp) {
    var allNodes = [].slice.call(rootElement.querySelectorAll("*"));
    var keyframeNodes = [];
    var nameMarker = "__CSSVARSPONYFILL-KEYFRAMES__";
    for (var i = 0, len = allNodes.length; i < len; i++) {
      var node = allNodes[i];
      var animationName = getComputedStyle(node)[animationNameProp];
      if (animationName !== "none") {
        node.style[animationNameProp] += nameMarker;
        keyframeNodes.push(node);
      }
    }
    for (var _i = 0, _len = keyframeNodes.length; _i < _len; _i++) {
      var nodeStyle = keyframeNodes[_i].style;
      nodeStyle[animationNameProp] = nodeStyle[animationNameProp].replace(nameMarker, "");
    }
  }
}
function fixRelativeCssUrls(cssText, baseUrl) {
  var cssUrls = cssText.replace(regex.cssComments, "").match(regex.cssUrls) || [];
  cssUrls.forEach(function(cssUrl) {
    var oldUrl = cssUrl.replace(regex.cssUrls, "$1");
    var newUrl = getFullUrl(oldUrl, baseUrl);
    cssText = cssText.replace(cssUrl, cssUrl.replace(oldUrl, newUrl));
  });
  return cssText;
}
function fixVarNames() {
  var varObj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var reLeadingHyphens = /^-{2}/;
  return Object.keys(varObj).reduce(function(obj, value) {
    var key = reLeadingHyphens.test(value) ? value : "--".concat(value.replace(/^-+/, ""));
    obj[key] = varObj[value];
    return obj;
  }, {});
}
function getFullUrl(url) {
  var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : location.href;
  var d = document.implementation.createHTMLDocument("");
  var b = d.createElement("base");
  var a = d.createElement("a");
  d.head.appendChild(b);
  d.body.appendChild(a);
  b.href = base;
  a.href = url;
  return a.href;
}
function getTimeStamp() {
  return isBrowser && (window.performance || {}).now ? window.performance.now() : (/* @__PURE__ */ new Date()).getTime();
}
function resetCssNodes(rootElement) {
  var resetDOMVariableStore = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var resetNodes = [].slice.call(rootElement.querySelectorAll('[data-cssvars="skip"],[data-cssvars="src"]'));
  resetNodes.forEach(function(node) {
    return node.setAttribute("data-cssvars", "");
  });
  if (resetDOMVariableStore) {
    variableStore.dom = {};
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function createCommonjsModule(fn, basedir, module) {
  return module = {
    path: basedir,
    exports: {},
    require: function(path, base) {
      return commonjsRequire();
    }
  }, fn(module, module.exports), module.exports;
}
function commonjsRequire() {
  throw new Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs");
}
createCommonjsModule(function(module, exports) {
  (function(global2, factory) {
    factory();
  })(commonjsGlobal, function() {
    function applyFocusVisiblePolyfill(scope) {
      var hadKeyboardEvent = true;
      var hadFocusVisibleRecently = false;
      var hadFocusVisibleRecentlyTimeout = null;
      var inputTypesAllowlist = {
        text: true,
        search: true,
        url: true,
        tel: true,
        email: true,
        password: true,
        number: true,
        date: true,
        month: true,
        week: true,
        time: true,
        datetime: true,
        "datetime-local": true
      };
      function isValidFocusTarget(el) {
        if (el && el !== document && el.nodeName !== "HTML" && el.nodeName !== "BODY" && "classList" in el && "contains" in el.classList) {
          return true;
        }
        return false;
      }
      function focusTriggersKeyboardModality(el) {
        var type = el.type;
        var tagName = el.tagName;
        if (tagName === "INPUT" && inputTypesAllowlist[type] && !el.readOnly) {
          return true;
        }
        if (tagName === "TEXTAREA" && !el.readOnly) {
          return true;
        }
        if (el.isContentEditable) {
          return true;
        }
        return false;
      }
      function addFocusVisibleClass(el) {
        if (el.classList.contains("focus-visible")) {
          return;
        }
        el.classList.add("focus-visible");
        el.setAttribute("data-focus-visible-added", "");
      }
      function removeFocusVisibleClass(el) {
        if (!el.hasAttribute("data-focus-visible-added")) {
          return;
        }
        el.classList.remove("focus-visible");
        el.removeAttribute("data-focus-visible-added");
      }
      function onKeyDown(e) {
        if (e.metaKey || e.altKey || e.ctrlKey) {
          return;
        }
        if (isValidFocusTarget(scope.activeElement)) {
          addFocusVisibleClass(scope.activeElement);
        }
        hadKeyboardEvent = true;
      }
      function onPointerDown(e) {
        hadKeyboardEvent = false;
      }
      function onFocus(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
          addFocusVisibleClass(e.target);
        }
      }
      function onBlur(e) {
        if (!isValidFocusTarget(e.target)) {
          return;
        }
        if (e.target.classList.contains("focus-visible") || e.target.hasAttribute("data-focus-visible-added")) {
          hadFocusVisibleRecently = true;
          window.clearTimeout(hadFocusVisibleRecentlyTimeout);
          hadFocusVisibleRecentlyTimeout = window.setTimeout(function() {
            hadFocusVisibleRecently = false;
          }, 100);
          removeFocusVisibleClass(e.target);
        }
      }
      function onVisibilityChange(e) {
        if (document.visibilityState === "hidden") {
          if (hadFocusVisibleRecently) {
            hadKeyboardEvent = true;
          }
          addInitialPointerMoveListeners();
        }
      }
      function addInitialPointerMoveListeners() {
        document.addEventListener("mousemove", onInitialPointerMove);
        document.addEventListener("mousedown", onInitialPointerMove);
        document.addEventListener("mouseup", onInitialPointerMove);
        document.addEventListener("pointermove", onInitialPointerMove);
        document.addEventListener("pointerdown", onInitialPointerMove);
        document.addEventListener("pointerup", onInitialPointerMove);
        document.addEventListener("touchmove", onInitialPointerMove);
        document.addEventListener("touchstart", onInitialPointerMove);
        document.addEventListener("touchend", onInitialPointerMove);
      }
      function removeInitialPointerMoveListeners() {
        document.removeEventListener("mousemove", onInitialPointerMove);
        document.removeEventListener("mousedown", onInitialPointerMove);
        document.removeEventListener("mouseup", onInitialPointerMove);
        document.removeEventListener("pointermove", onInitialPointerMove);
        document.removeEventListener("pointerdown", onInitialPointerMove);
        document.removeEventListener("pointerup", onInitialPointerMove);
        document.removeEventListener("touchmove", onInitialPointerMove);
        document.removeEventListener("touchstart", onInitialPointerMove);
        document.removeEventListener("touchend", onInitialPointerMove);
      }
      function onInitialPointerMove(e) {
        if (e.target.nodeName && e.target.nodeName.toLowerCase() === "html") {
          return;
        }
        hadKeyboardEvent = false;
        removeInitialPointerMoveListeners();
      }
      document.addEventListener("keydown", onKeyDown, true);
      document.addEventListener("mousedown", onPointerDown, true);
      document.addEventListener("pointerdown", onPointerDown, true);
      document.addEventListener("touchstart", onPointerDown, true);
      document.addEventListener("visibilitychange", onVisibilityChange, true);
      addInitialPointerMoveListeners();
      scope.addEventListener("focus", onFocus, true);
      scope.addEventListener("blur", onBlur, true);
      if (scope.nodeType === Node.DOCUMENT_FRAGMENT_NODE && scope.host) {
        scope.host.setAttribute("data-js-focus-visible", "");
      } else if (scope.nodeType === Node.DOCUMENT_NODE) {
        document.documentElement.classList.add("js-focus-visible");
        document.documentElement.setAttribute("data-js-focus-visible", "");
      }
    }
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      window.applyFocusVisiblePolyfill = applyFocusVisiblePolyfill;
      var event;
      try {
        event = new CustomEvent("focus-visible-polyfill-ready");
      } catch (error) {
        event = document.createEvent("CustomEvent");
        event.initCustomEvent("focus-visible-polyfill-ready", false, false, {});
      }
      window.dispatchEvent(event);
    }
    if (typeof document !== "undefined") {
      applyFocusVisiblePolyfill(document);
    }
  });
});
var isImplemented = function isImplemented2() {
  return Object.prototype.hasOwnProperty.call(Node.prototype, "getRootNode");
};
var getRootNodePolyfill = createCommonjsModule(function(module) {
  function getRootNode(opt) {
    var composed = typeof opt === "object" && Boolean(opt.composed);
    return composed ? getShadowIncludingRoot(this) : getRoot(this);
  }
  function getShadowIncludingRoot(node) {
    var root = getRoot(node);
    if (isShadowRoot(root)) {
      return getShadowIncludingRoot(root.host);
    }
    return root;
  }
  function getRoot(node) {
    if (node.parentNode != null) {
      return getRoot(node.parentNode);
    }
    return node;
  }
  function isShadowRoot(node) {
    return node.nodeName === "#document-fragment" && node.constructor.name === "ShadowRoot";
  }
  if (module.exports) {
    module.exports = getRootNode;
  }
});
if (!isImplemented()) {
  Object.defineProperty(Node.prototype, "getRootNode", {
    enumerable: false,
    configurable: false,
    value: getRootNodePolyfill
  });
}
var Action;
(function(Action2) {
  Action2["PLAY"] = "play";
  Action2["PAUSE"] = "pause";
  Action2["STOP"] = "stop";
  Action2["ENTER_FULLSCREEN"] = "enterfullscreen";
  Action2["EXIT_FULLSCREEN"] = "exitfullscreen";
  Action2["MUTE"] = "mute";
  Action2["UNMUTE"] = "unmute";
  Action2["TEXT_ON"] = "texton";
  Action2["TEXT_OFF"] = "textoff";
  Action2["GO_TO_LIVE"] = "gotolive";
  Action2["MENU_ITEM_SELECT"] = "menuitemselect";
  Action2["LIST_ITEM_SELECT"] = "listitemselect";
  Action2["NONE"] = "none";
  Action2["SEEK"] = "seek";
  Action2["SEEK_FORWARD"] = "seekforward";
  Action2["SEEK_BACK"] = "seekback";
  Action2["VOLUME"] = "volume";
  Action2["PREVIEW"] = "preview";
  Action2["SETTINGS_ON"] = "settingson";
  Action2["SETTINGS_OFF"] = "settingsoff";
  Action2["LANGUAGE_SELECT"] = "languageselect";
  Action2["QUALITY_SELECT"] = "qualityselect";
  Action2["POSTER_PLAY"] = "posterplay";
  Action2["PANEL_BACK"] = "panelback";
  Action2["PANEL_CLOSE"] = "panelclose";
  Action2["LOCK_ACTIVE"] = "lockactive";
  Action2["ENTER_CONTEXT"] = "entercontext";
  Action2["EXIT_CONTEXT"] = "exitcontext";
})(Action || (Action = {}));
var ActionKeyContext;
(function(ActionKeyContext2) {
  ActionKeyContext2["TV"] = "auitv";
  ActionKeyContext2["UI"] = "auiui";
  ActionKeyContext2["BUTTON"] = "auibutton";
  ActionKeyContext2["SLIDER"] = "auislider";
  ActionKeyContext2["SLIDER_ENGAGED"] = "auisliderengaged";
  ActionKeyContext2["SEEK"] = "auiseek";
  ActionKeyContext2["PANEL"] = "auipanel";
  ActionKeyContext2["MENU"] = "auimenu";
  ActionKeyContext2["PREVIEW_SLIDER_ENGAGED"] = "auipreviewsliderengaged";
})(ActionKeyContext || (ActionKeyContext = {}));
var ActiveMode;
(function(ActiveMode2) {
  ActiveMode2["AUTO"] = "auto";
  ActiveMode2["MANUAL"] = "manual";
})(ActiveMode || (ActiveMode = {}));
var ControlFunction;
(function(ControlFunction2) {
  ControlFunction2["MUTE"] = "mute";
  ControlFunction2["PLAY"] = "play";
  ControlFunction2["FULLSCREEN"] = "fullscreen";
  ControlFunction2["TEXT"] = "text";
  ControlFunction2["PLAY_OVERLAY"] = "playOverlay";
  ControlFunction2["SETTINGS"] = "settings";
  ControlFunction2["VOLUME"] = "volume";
})(ControlFunction || (ControlFunction = {}));
var ControlMode;
(function(ControlMode2) {
  ControlMode2["NONE"] = "none";
  ControlMode2["AD"] = "ad";
  ControlMode2["CONTENT"] = "content";
  ControlMode2["COMPACT"] = "compact";
})(ControlMode || (ControlMode = {}));
var CssNames;
(function(CssNames2) {
  CssNames2["HIDDEN"] = "avia-ui-hidden";
  CssNames2["ACC_VOL_ON"] = "avia-volume-on";
  CssNames2["ACC_VOL_OFF"] = "avia-volume-off";
  CssNames2["SEGMENT_MARKER"] = "avia-segment-marker";
  CssNames2["INDICATOR_ACTIVE"] = "avia-indicator-active";
  CssNames2["ACC_VOL"] = "avia-acc-vol";
  CssNames2["ACC_VOL_METER"] = "avia-acc-vol-meter";
  CssNames2["ACC_VOL_OVERLAY"] = "avia-vol-meter-overlay";
  CssNames2["ACC_FWD"] = "avia-acc-fwd";
  CssNames2["ACC_BACK"] = "avia-acc-back";
  CssNames2["ACC_ARROW"] = "avia-acc-arrow";
  CssNames2["UNMUTE_CTA"] = "avia-unmute-cta";
  CssNames2["CONTROLS_VISIBLE"] = "avia-controls-vis";
  CssNames2["SPINNER_ACTIVE"] = "avia-spinner";
  CssNames2["SPINNER_IDLE"] = "avia-spinner-idle";
  CssNames2["SETTINGS_NUDGE_LEFT"] = "avia-settings-nudge-left";
})(CssNames || (CssNames = {}));
var DeviceMode;
(function(DeviceMode2) {
  DeviceMode2["AUTO"] = "auto";
  DeviceMode2["TV"] = "tv";
  DeviceMode2["DESKTOP"] = "desktop";
  DeviceMode2["MOBILE"] = "mobile";
})(DeviceMode || (DeviceMode = {}));
var LocalizationId;
(function(LocalizationId2) {
  LocalizationId2["PLAY"] = "play";
  LocalizationId2["PAUSE"] = "pause";
  LocalizationId2["STOP"] = "stop";
  LocalizationId2["MUTE"] = "mute";
  LocalizationId2["UNMUTE"] = "unmute";
  LocalizationId2["VOLUME"] = "volume";
  LocalizationId2["CLICK_TO_UNMUTE"] = "click-to-unmute";
  LocalizationId2["TAP_TO_UNMUTE"] = "tap-to-unmute";
  LocalizationId2["LIVE"] = "live";
  LocalizationId2["GO_LIVE"] = "go-live";
  LocalizationId2["SEEK"] = "seek";
  LocalizationId2["SEEK_BACK"] = "seek-back";
  LocalizationId2["SEEK_FORWARD"] = "seek-forward";
  LocalizationId2["CLOSED_CAPTIONS_OFF"] = "closed-captions-off";
  LocalizationId2["CLOSED_CAPTIONS_ON"] = "closed-captions-on";
  LocalizationId2["FULL_SCREEN_ENTER"] = "full-screen-enter";
  LocalizationId2["FULL_SCREEN_EXIT"] = "full-screen-exit";
  LocalizationId2["HOURS"] = "hours";
  LocalizationId2["MINUTES"] = "minutes";
  LocalizationId2["SECONDS"] = "seconds";
  LocalizationId2["VALUE_OF_TOTAL"] = "value-of-total";
  LocalizationId2["UNMUTE_CTA"] = "unmute-cta";
  LocalizationId2["SETTINGS"] = "settings";
  LocalizationId2["LANGUAGE"] = "language";
  LocalizationId2["QUALITY"] = "quality";
  LocalizationId2["BACK"] = "back";
  LocalizationId2["CAPTIONS"] = "captions";
  LocalizationId2["AUDIO"] = "audio";
  LocalizationId2["CLOSE"] = "close";
  LocalizationId2["AUTO"] = "auto";
  LocalizationId2["UNKNOWN"] = "unknown";
})(LocalizationId || (LocalizationId = {}));
var LanguageLabel;
(function(LanguageLabel2) {
  LanguageLabel2["AB"] = "Abkhaz";
  LanguageLabel2["AE"] = "Avesta";
  LanguageLabel2["AF"] = "Afrikaans";
  LanguageLabel2["AK"] = "Akan";
  LanguageLabel2["AM"] = "አማርኛ";
  LanguageLabel2["AN"] = "Aragonés";
  LanguageLabel2["AR"] = "العربية";
  LanguageLabel2["AV"] = "Aвар мацӀ";
  LanguageLabel2["AY"] = "Aymar aru";
  LanguageLabel2["AZ"] = "azərbaycan dili";
  LanguageLabel2["BA"] = "башҡорт теле";
  LanguageLabel2["BE"] = "беларуская мова";
  LanguageLabel2["BG"] = "български език";
  LanguageLabel2["BH"] = "भोजपुरी";
  LanguageLabel2["BI"] = "Bislama";
  LanguageLabel2["BM"] = "Bamanankan";
  LanguageLabel2["BN"] = "বাংলা";
  LanguageLabel2["BO"] = "བོད་ཡིག";
  LanguageLabel2["BR"] = "Brezhoneg";
  LanguageLabel2["BS"] = "Bosanski jezik";
  LanguageLabel2["CA"] = "català";
  LanguageLabel2["CE"] = "нохчийн мотт";
  LanguageLabel2["CH"] = "Chamoru";
  LanguageLabel2["CO"] = "Corsu";
  LanguageLabel2["CR"] = "ᓀᐦᐃᔭᐍᐏᐣ";
  LanguageLabel2["CS"] = "čeština";
  LanguageLabel2["CU"] = "ѩзыкъ словѣньскъ";
  LanguageLabel2["CV"] = "чӑваш чӗлхи";
  LanguageLabel2["CY"] = "Cymraeg";
  LanguageLabel2["DA"] = "Dansk";
  LanguageLabel2["DE"] = "Deutsch";
  LanguageLabel2["DZ"] = "རྫོང་ཁ";
  LanguageLabel2["EE"] = "Eʋegbe";
  LanguageLabel2["EL"] = "ελληνικά";
  LanguageLabel2["EN"] = "English";
  LanguageLabel2["EO"] = "Esperanto";
  LanguageLabel2["ES"] = "Español";
  LanguageLabel2["ET"] = "Eesti";
  LanguageLabel2["EU"] = "Euskara";
  LanguageLabel2["FA"] = "فارسی";
  LanguageLabel2["FF"] = "Fulfulde";
  LanguageLabel2["FI"] = "Suomi";
  LanguageLabel2["FJ"] = "Vosa Vakaviti";
  LanguageLabel2["FO"] = "Føroyskt";
  LanguageLabel2["FR"] = "Français";
  LanguageLabel2["FY"] = "Frysk";
  LanguageLabel2["GA"] = "Gaeilge";
  LanguageLabel2["GD"] = "Gàidhlig";
  LanguageLabel2["GL"] = "Galego";
  LanguageLabel2["GN"] = "Avañe'ẽ";
  LanguageLabel2["GU"] = "ગુજરાતી";
  LanguageLabel2["GV"] = "Gaelg";
  LanguageLabel2["HA"] = "(Hausa) هَوُسَ";
  LanguageLabel2["HE"] = "עברית";
  LanguageLabel2["HI"] = "हिन्दी";
  LanguageLabel2["HO"] = "Hiri Motu";
  LanguageLabel2["HR"] = "hrvatski jezik";
  LanguageLabel2["HT"] = "Kreyòl ayisyen";
  LanguageLabel2["HU"] = "Magyar";
  LanguageLabel2["HY"] = "Հայերեն";
  LanguageLabel2["HZ"] = "Otjiherero";
  LanguageLabel2["IA"] = "Interlingua";
  LanguageLabel2["ID"] = "Bahasa Indonesia";
  LanguageLabel2["IE"] = "Interlingue";
  LanguageLabel2["IG"] = "Asụsụ Igbo";
  LanguageLabel2["II"] = "ꆈꌠ꒿ Nuosuhxop";
  LanguageLabel2["IK"] = "Iñupiaq";
  LanguageLabel2["IO"] = "Ido";
  LanguageLabel2["IS"] = "Íslenska";
  LanguageLabel2["IT"] = "Italiano";
  LanguageLabel2["IU"] = "ᐃᓄᒃᑎᑐᑦ";
  LanguageLabel2["JA"] = "日本人";
  LanguageLabel2["JV"] = "Basa Jawa";
  LanguageLabel2["KA"] = "ქართული";
  LanguageLabel2["KG"] = "Kikongo";
  LanguageLabel2["KI"] = "Gĩkũyũ";
  LanguageLabel2["KJ"] = "Kuanyama";
  LanguageLabel2["KK"] = "қазақ тілі";
  LanguageLabel2["KL"] = "kalaallisut";
  LanguageLabel2["KM"] = "ខ្មែរ";
  LanguageLabel2["KN"] = "ಕನ್ನಡ";
  LanguageLabel2["KO"] = "한국어";
  LanguageLabel2["KR"] = "Kanuri";
  LanguageLabel2["KS"] = "कश्मीरी,";
  LanguageLabel2["KU"] = "Kurdî";
  LanguageLabel2["KV"] = "коми кыв";
  LanguageLabel2["KW"] = "Kernewek";
  LanguageLabel2["KY"] = "Кыргызча";
  LanguageLabel2["LA"] = "Latine";
  LanguageLabel2["LB"] = "Lëtzebuergesch";
  LanguageLabel2["LG"] = "Luganda";
  LanguageLabel2["LI"] = "Limburgs";
  LanguageLabel2["LN"] = "Lingála";
  LanguageLabel2["LO"] = "ພາສາລາວ";
  LanguageLabel2["LT"] = "Lietuvių kalba";
  LanguageLabel2["LU"] = "Kiluba";
  LanguageLabel2["LV"] = "latviešu valoda";
  LanguageLabel2["MG"] = "fiteny malagasy";
  LanguageLabel2["MH"] = "Kajin M̧ajeļ";
  LanguageLabel2["MI"] = "te reo Māori";
  LanguageLabel2["MK"] = "македонски јазик";
  LanguageLabel2["ML"] = "മലയാളം";
  LanguageLabel2["MN"] = "Монгол хэл";
  LanguageLabel2["MR"] = "मराठी";
  LanguageLabel2["MS"] = "Bahasa Melayu";
  LanguageLabel2["MT"] = "Malti";
  LanguageLabel2["MY"] = "ဗမာစာ";
  LanguageLabel2["NA"] = "Dorerin Naoero";
  LanguageLabel2["NB"] = "Norsk Bokmål";
  LanguageLabel2["NE"] = "नेपाली";
  LanguageLabel2["NG"] = "Owambo";
  LanguageLabel2["NL"] = "Nederlands";
  LanguageLabel2["NN"] = "Norsk Nynorsk";
  LanguageLabel2["NO"] = "Norsk";
  LanguageLabel2["NR"] = "IsiNdebele";
  LanguageLabel2["NV"] = "Diné bizaad";
  LanguageLabel2["NY"] = "ChiCheŵa";
  LanguageLabel2["OC"] = "Occitan";
  LanguageLabel2["OJ"] = "ᐊᓂᔑᓈᐯᒧᐎᓐ";
  LanguageLabel2["OM"] = "Afaan Oromoo";
  LanguageLabel2["OR"] = "ଓଡ଼ିଆ";
  LanguageLabel2["OS"] = "ирон æвзаг";
  LanguageLabel2["PA"] = "ਪੰਜਾਬੀ";
  LanguageLabel2["PI"] = "पालि, पाळि";
  LanguageLabel2["PL"] = "Język polski";
  LanguageLabel2["PS"] = "پښتو";
  LanguageLabel2["PT"] = "Português";
  LanguageLabel2["QU"] = "Runa Simi";
  LanguageLabel2["RM"] = "Rumantsch Grischun";
  LanguageLabel2["RN"] = "Ikirundi";
  LanguageLabel2["RO"] = "Română";
  LanguageLabel2["RU"] = "русский";
  LanguageLabel2["RW"] = "Ikinyarwanda";
  LanguageLabel2["SA"] = "संस्कृतम्";
  LanguageLabel2["SC"] = "sardu";
  LanguageLabel2["SD"] = "सिन्धी";
  LanguageLabel2["SE"] = "Davvisámegiella";
  LanguageLabel2["SG"] = "Yângâ tî sängö";
  LanguageLabel2["SI"] = "සිංහල";
  LanguageLabel2["SK"] = "Slovenčina";
  LanguageLabel2["SL"] = "Slovenski jezik";
  LanguageLabel2["SM"] = "Gagana fa'a Samoa";
  LanguageLabel2["SN"] = "chiShona";
  LanguageLabel2["SO"] = "Soomaaliga";
  LanguageLabel2["SQ"] = "Shqip";
  LanguageLabel2["SR"] = "српски језик";
  LanguageLabel2["SS"] = "SiSwati";
  LanguageLabel2["ST"] = "Sesotho";
  LanguageLabel2["SU"] = "Basa Sunda";
  LanguageLabel2["SV"] = "Svenska";
  LanguageLabel2["SW"] = "Kiswahili";
  LanguageLabel2["TA"] = "தமிழ்";
  LanguageLabel2["TE"] = "తెలుగు";
  LanguageLabel2["TG"] = "тоҷикӣ";
  LanguageLabel2["TH"] = "ไทย";
  LanguageLabel2["TI"] = "ትግርኛ";
  LanguageLabel2["TK"] = "Türkmen";
  LanguageLabel2["TL"] = "Wikang Tagalog";
  LanguageLabel2["TN"] = "Setswana";
  LanguageLabel2["TO"] = "Faka Tonga";
  LanguageLabel2["TR"] = "Türkçe";
  LanguageLabel2["TS"] = "Xitsonga";
  LanguageLabel2["TT"] = "татар теле";
  LanguageLabel2["TW"] = "Twi";
  LanguageLabel2["TY"] = "Reo Tahiti";
  LanguageLabel2["UG"] = "ئۇيغۇرچە";
  LanguageLabel2["UK"] = "Українська";
  LanguageLabel2["UR"] = "اردو";
  LanguageLabel2["UZ"] = "Oʻzbek";
  LanguageLabel2["VE"] = "Tshivenḓa";
  LanguageLabel2["VI"] = "Tiếng Việt";
  LanguageLabel2["VO"] = "Volapük";
  LanguageLabel2["WA"] = "Walon";
  LanguageLabel2["WO"] = "Wollof";
  LanguageLabel2["XH"] = "IsiXhosa";
  LanguageLabel2["YI"] = "ייִדיש";
  LanguageLabel2["YO"] = "Yorùbá";
  LanguageLabel2["ZA"] = "Saɯ cueŋƅ";
  LanguageLabel2["ZH"] = "中文 (Zhōngwén)";
  LanguageLabel2["ZU"] = "IsiZulu";
})(LanguageLabel || (LanguageLabel = {}));
function csvToArray(str) {
  if (isEmpty(str)) {
    return [];
  }
  return str.split(",").map((v) => v.trim());
}
function toTimeObject(value = 0) {
  if (value == null || isNaN(value)) {
    value = 0;
  }
  const hms = secToHms(value, 3600).split(":");
  return {
    hours: parseInt(hms[0]),
    minutes: parseInt(hms[1]),
    seconds: parseInt(hms[2])
  };
}
function createLocalizedTimeString(time, localeData) {
  const t = toTimeObject(time);
  const hasHours = t.hours > 0;
  let ret = "";
  if (hasHours) {
    ret += `${t.hours} ${localeData[LocalizationId.HOURS]} `;
  }
  if (t.minutes > 0 || hasHours) {
    ret += `${t.minutes} ${localeData[LocalizationId.MINUTES]} `;
  }
  ret += `${t.seconds} ${localeData[LocalizationId.SECONDS]}`;
  return ret;
}
function getEventPos(event) {
  const nullEvent = event === void 0 || event === null;
  const hasTouch = !nullEvent && event.targetTouches && event.targetTouches.length;
  const pX = nullEvent || !("pageX" in event) ? null : event.pageX;
  const pY = nullEvent || !("pageY" in event) ? null : event.pageY;
  if ((pX === null || pY === null) && !hasTouch) {
    return { x: null, y: null };
  }
  const sx = window.scrollX;
  const sy = window.scrollY;
  if (hasTouch) {
    return {
      // @ts-ignore
      x: event.targetTouches[0].pageX - sx,
      // @ts-ignore
      y: event.targetTouches[0].pageY - sy
    };
  }
  const hasX = sx !== void 0 && sx !== null && !isNaN(sx);
  const hasY = sy !== void 0 && sy !== null && !isNaN(sy);
  return {
    x: pX - (hasX ? sx : window.pageXOffset),
    y: pY - (hasY ? sy : window.pageYOffset)
  };
}
function valueOfTotal(time, duration, localeData) {
  const value = createLocalizedTimeString(time, localeData);
  const total = createLocalizedTimeString(duration, localeData);
  return localize(localeData[LocalizationId.VALUE_OF_TOTAL], { value, total });
}
function toCssPercent(value) {
  return `${roundTo(value * 100, 2)}%`;
}
function blockEvent(event, stop = false) {
  if (stop) {
    event.stopPropagation();
  }
  event.preventDefault();
}
function createElementsFromString(html) {
  try {
    const template2 = document.createElement("template");
    template2.innerHTML = html;
    return Array.from(template2.content.children);
  } catch (error) {
    throw new Error(`Could not create element from string: ${html}`);
  }
}
function applyCssVars(varMap) {
  const { style } = document.documentElement;
  Object.keys(varMap).forEach((key) => style.setProperty(key, varMap[key]));
}
function getLangLabel(language) {
  const tag = language.split("-").shift().slice(0, 2).toUpperCase();
  const lbl = LanguageLabel[tag];
  return lbl;
}
function localize(message, context) {
  return template(message, context);
}
function debounce(func, delay) {
  let timeout;
  const pending = () => timeout != null;
  const cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };
  const run = (...args) => {
    cancel();
    timeout = setTimeout(func, delay, ...args);
  };
  run.cancel = cancel;
  run.flush = func;
  run.pending = pending;
  return run;
}
function isEmpty(val) {
  return val == null || val === void 0 || val === "";
}
function isUndefined(value) {
  return typeof value === "undefined";
}
function secToHms(seconds, max = 61) {
  if (seconds == null || isNaN(seconds)) {
    return "00:00";
  }
  seconds = seconds | 0;
  let time = zeroFill(seconds % 60);
  seconds = seconds / 60 | 0;
  time = zeroFill(seconds % 60) + ":" + time;
  seconds = seconds / 60 | 0;
  if (seconds > 0) {
    time = zeroFill(seconds) + ":" + time;
  }
  if (max >= 3600 && time.length === 5) {
    time = "00:" + time;
  }
  return time;
}
function template(input, context, open = "{{", close = "}}") {
  if (!input) {
    return input;
  }
  const regex2 = new RegExp(`${open}((?:(?!(${open}|${close})).)+)${close}`, "g");
  return input.replace(regex2, (match, token) => !isUndefined(context[token]) ? context[token] : match);
}
function zeroFill(time) {
  return time < 10 ? "0" + time : time.toString();
}
function mapToRange(value, fromMin, fromMax, toMin = 0, toMax = 1) {
  return (value - fromMin) * (toMax - toMin) / (fromMax - fromMin) + toMin;
}
function roundTo(num, len) {
  return Math.round(num * Math.pow(10, len)) / Math.pow(10, len);
}
function clampValue(value, min, max) {
  return Math.max(min, Math.min(max, value));
}
function uid8() {
  const s4 = function() {
    return Math.floor((1 + Math.random()) * 65536).toString(16).substring(1);
  };
  return s4() + s4();
}
const PreviewTimeTransform = {
  DEFAULT: (playerTime) => secToHms(playerTime.contentTime),
  UTC_TIME: (playerTime) => new Date(playerTime.liveStreamUtcTime).toTimeString().split(" ")[0]
};
var ProgressMode;
(function(ProgressMode2) {
  ProgressMode2["CURSOR"] = "cursor";
  ProgressMode2["VALUE"] = "value";
})(ProgressMode || (ProgressMode = {}));
var UiEvent;
(function(UiEvent2) {
  UiEvent2["PREVIEW"] = "preview";
  UiEvent2["POSTER_PLAY"] = "posterplay";
})(UiEvent || (UiEvent = {}));
class AviaPluginBase {
  constructor(id) {
    this.debug = false;
    this.logFmt = "color: #fcf; font-style: italic;";
    this.id = id;
    this.player = null;
    this.services = null;
    this.options = null;
    this.onPlayerEvent = this.onPlayerEvent.bind(this);
  }
  getId() {
    return this.id;
  }
  destroy() {
    this.listenToPlayer(false, this.getEventInterests());
    this.player = null;
    this.options = null;
    this.services = null;
    this.avia = null;
  }
  // @ts-ignore
  onPlayerEvent(event) {
  }
  // Return a list of events this plugin needs to listen to;
  // implement in subclass
  getEventInterests() {
    return [];
  }
  sendEvent(data) {
    this.services.event.dispatchPluginEvent(data);
  }
  // Add/remove listeners for the given list of player events
  // Invoke with no arg or with TRUE to add listeners, FALSE to remove
  listenToPlayer(flag, events) {
    const action = flag !== false ? "on" : "off";
    events.forEach((event) => this.player[action](event, this.onPlayerEvent));
  }
  log(msg) {
    this.services.logger.debug(msg);
  }
  onRegister(player, options, services) {
    return __async(this, null, function* () {
      this.player = player;
      this.services = services;
      this.options = options || {};
      this.avia = services.avia;
      this.debug = options.debug === true;
      yield this.initialize();
      this.listenToPlayer(true, this.getEventInterests());
      this.log(`Registered ${this.id}`);
    });
  }
  initialize() {
    return __async(this, null, function* () {
    });
  }
}
var Directions;
(function(Directions2) {
  Directions2["LEFT"] = "left";
  Directions2["RIGHT"] = "right";
  Directions2["UP"] = "up";
  Directions2["DOWN"] = "down";
  Directions2["ENTER"] = "enter";
  Directions2["UNSPECIFIED"] = "*";
})(Directions || (Directions = {}));
var Orientations;
(function(Orientations2) {
  Orientations2["VERTICAL"] = "vertical";
  Orientations2["HORIZONTAL"] = "horizontal";
})(Orientations || (Orientations = {}));
var KeyCodes = {
  4: Directions.LEFT,
  21: Directions.LEFT,
  37: Directions.LEFT,
  214: Directions.LEFT,
  205: Directions.LEFT,
  218: Directions.LEFT,
  5: Directions.RIGHT,
  22: Directions.RIGHT,
  39: Directions.RIGHT,
  213: Directions.RIGHT,
  206: Directions.RIGHT,
  217: Directions.RIGHT,
  29460: Directions.UP,
  19: Directions.UP,
  38: Directions.UP,
  211: Directions.UP,
  203: Directions.UP,
  215: Directions.UP,
  29461: Directions.DOWN,
  20: Directions.DOWN,
  40: Directions.DOWN,
  212: Directions.DOWN,
  204: Directions.DOWN,
  216: Directions.DOWN,
  29443: Directions.ENTER,
  13: Directions.ENTER,
  67: Directions.ENTER,
  32: Directions.ENTER,
  23: Directions.ENTER,
  195: Directions.ENTER
};
var closestIndex = function(values, goal) {
  return values.reduce(function(prev, curr) {
    return Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev;
  });
};
var isNodeFocusable = function(node) {
  if (!node) {
    return false;
  }
  return node.isFocusable != null ? node.isFocusable : !!node.selectAction;
};
var getDirectionForKeyCode = function(keyCode) {
  return KeyCodes[keyCode];
};
var isDirectionAndOrientationMatching = function(orientation, direction) {
  if (!orientation || !direction) {
    return false;
  }
  var validOrientation = toValidOrientation(orientation);
  var validDirection = toValidDirection(direction);
  return validDirection === Directions.UNSPECIFIED || validOrientation === Orientations.VERTICAL && (validDirection === Directions.UP || validDirection === Directions.DOWN) || validOrientation === Orientations.HORIZONTAL && (validDirection === Directions.LEFT || validDirection === Directions.RIGHT);
};
var findChildWithMatchingIndexRange = function(node, index) {
  if (!node || !node.children) {
    return void 0;
  }
  for (var i = 0; i < node.children.length; i++) {
    var child = node.children[i];
    if (child.indexRange && (child.indexRange[0] <= index && child.indexRange[1] >= index)) {
      return child;
    }
  }
  return void 0;
};
var findChildWithClosestIndex = function(node, index, indexRange) {
  if (!node || !node.children) {
    return void 0;
  }
  if (indexRange && node.activeChild && node.activeChild.index >= indexRange[0] && node.activeChild.index <= indexRange[1] && isNodeFocusable(node.activeChild)) {
    return node.activeChild;
  }
  var indices = [];
  for (var i = 0; i < node.children.length; i++) {
    if (isNodeFocusable(node.children[i]) || node.children[i].children) {
      indices.push(i);
    }
  }
  if (indices.length <= 0) {
    return void 0;
  }
  return node.children[closestIndex(indices, index)];
};
var insertChildNode = function(parent, newChild) {
  if (!parent || !newChild) {
    return;
  }
  if (!parent.children) {
    parent.children = [];
  }
  newChild.parent = parent;
  if (typeof newChild.index !== "number" || newChild.index > parent.children.length) {
    newChild.index = parent.children.length;
    parent.children.push(newChild);
  } else {
    parent.children.splice(newChild.index, 0, newChild);
    for (var i = newChild.index + 1; i < parent.children.length; i++) {
      parent.children[i].index = i;
    }
  }
};
var removeChildNode = function(parent, child) {
  if (!child || !parent || !parent.children) {
    return;
  }
  var removedChildIndex = -1;
  for (var i = 0; i < parent.children.length; i++) {
    if (parent.children[i] === child) {
      removedChildIndex = i;
    } else if (removedChildIndex !== -1) {
      parent.children[i].index = i - 1;
    }
  }
  if (removedChildIndex !== -1) {
    if (parent.children.length === 1) {
      parent.children = void 0;
    } else {
      parent.children.splice(removedChildIndex, 1);
    }
  }
};
var toValidOrientation = function(orientation) {
  if (!orientation) {
    return void 0;
  }
  for (var _i = 0, _a = Object.keys(Orientations); _i < _a.length; _i++) {
    var orientationKey = _a[_i];
    if (Orientations[orientationKey] === orientation.toLowerCase()) {
      return Orientations[orientationKey];
    }
  }
  return void 0;
};
var toValidDirection = function(direction) {
  if (!direction) {
    return void 0;
  }
  for (var _i = 0, _a = Object.keys(Directions); _i < _a.length; _i++) {
    var directionKey = _a[_i];
    if (Directions[directionKey] === direction.toLowerCase()) {
      return Directions[directionKey];
    }
  }
  return void 0;
};
var prepareNode = function(nodeId, nodeConfig) {
  if (nodeConfig === void 0) {
    nodeConfig = {};
  }
  if (!nodeId) {
    throw Error("Node ID has to be defined");
  }
  return {
    id: nodeId,
    parent: void 0,
    children: void 0,
    activeChild: void 0,
    overrides: void 0,
    overrideSources: void 0,
    index: typeof nodeConfig.index === "number" ? nodeConfig.index : void 0,
    orientation: nodeConfig.orientation,
    indexRange: nodeConfig.indexRange,
    selectAction: nodeConfig.selectAction,
    isFocusable: nodeConfig.isFocusable,
    isWrapping: nodeConfig.isWrapping,
    isStopPropagate: nodeConfig.isStopPropagate,
    isIndexAlign: nodeConfig.isIndexAlign,
    onLeave: nodeConfig.onLeave,
    onEnter: nodeConfig.onEnter,
    shouldCancelLeave: nodeConfig.shouldCancelLeave,
    onLeaveCancelled: nodeConfig.onLeaveCancelled,
    shouldCancelEnter: nodeConfig.shouldCancelEnter,
    onEnterCancelled: nodeConfig.onEnterCancelled,
    onSelect: nodeConfig.onSelect,
    onInactive: nodeConfig.onInactive,
    onActive: nodeConfig.onActive,
    onActiveChildChange: nodeConfig.onActiveChildChange,
    onBlur: nodeConfig.onBlur,
    onFocus: nodeConfig.onFocus,
    onMove: nodeConfig.onMove
  };
};
var traverseNodeSubtree = function(startNode, nodeProcessor) {
  var stack = [startNode];
  var dummyThis = /* @__PURE__ */ Object.create(null);
  var traversedNode;
  while (stack.length > 0) {
    traversedNode = stack.pop();
    if (nodeProcessor.call(dummyThis, traversedNode)) {
      return;
    }
    if (traversedNode.children) {
      for (var i = traversedNode.children.length - 1; i >= 0; i--) {
        stack.push(traversedNode.children[i]);
      }
    }
  }
};
function mitt(all) {
  all = all || /* @__PURE__ */ Object.create(null);
  return {
    /**
     * Register an event handler for the given type.
     *
     * @param  {String} type	Type of event to listen for, or `"*"` for all events
     * @param  {Function} handler Function to call in response to given event
     * @memberOf mitt
     */
    on: function on(type, handler) {
      (all[type] || (all[type] = [])).push(handler);
    },
    /**
     * Remove an event handler for the given type.
     *
     * @param  {String} type	Type of event to unregister `handler` from, or `"*"`
     * @param  {Function} handler Handler function to remove
     * @memberOf mitt
     */
    off: function off(type, handler) {
      if (all[type]) {
        all[type].splice(all[type].indexOf(handler) >>> 0, 1);
      }
    },
    /**
     * Invoke all handlers for the given type.
     * If present, `"*"` handlers are invoked after type-matched handlers.
     *
     * @param {String} type  The event type to invoke
     * @param {Any} [evt]  Any value (object is recommended and powerful), passed to each handler
     * @memberOf mitt
     */
    emit: function emit(type, evt) {
      (all[type] || []).slice().map(function(handler) {
        handler(evt);
      });
      (all["*"] || []).slice().map(function(handler) {
        handler(type, evt);
      });
    }
  };
}
var Lrud = (
  /** @class */
  function() {
    function Lrud2() {
      this.nodes = {};
      this.rootNode = void 0;
      this.currentFocusNode = void 0;
      this.isIndexAlignMode = false;
      this.emitter = mitt();
    }
    Lrud2.prototype.on = function(eventName, callback) {
      this.emitter.on(eventName, callback);
    };
    Lrud2.prototype.off = function(eventName, callback) {
      this.emitter.off(eventName, callback);
    };
    Lrud2.prototype.getRootNode = function() {
      if (!this.rootNode) {
        throw new Error("no root node");
      }
      return this.rootNode;
    };
    Lrud2.prototype.getCurrentFocusNode = function() {
      return this.currentFocusNode;
    };
    Lrud2.prototype.registerNode = function(nodeId, nodeConfig) {
      var _a;
      if (nodeConfig === void 0) {
        nodeConfig = {};
      }
      if (this.getNode(nodeId)) {
        throw Error("Node with an ID of " + nodeId + " has already been registered");
      }
      var node = prepareNode(nodeId, nodeConfig);
      if (!this.rootNode) {
        this.rootNode = node;
        this.nodes = (_a = {}, _a[nodeId] = node, _a);
        return this;
      }
      var parentNode = nodeConfig.parent ? this.getNode(nodeConfig.parent) : this.rootNode;
      if (!parentNode) {
        return this;
      }
      this.nodes[nodeId] = node;
      insertChildNode(parentNode, node);
      return this;
    };
    Lrud2.prototype.moveNode = function(node, newParentNode, options) {
      if (options === void 0) {
        options = { maintainIndex: false };
      }
      node = typeof node === "string" ? this.getNode(node) : node;
      newParentNode = typeof newParentNode === "string" ? this.getNode(newParentNode) : newParentNode;
      if (!node || !newParentNode) {
        return;
      }
      if (node === this.rootNode) {
        return;
      }
      if (node.parent === newParentNode) {
        return;
      }
      var oldParentNode = node.parent;
      removeChildNode(oldParentNode, node);
      if (typeof options.index === "number") {
        node.index = options.index;
      } else if (!options.maintainIndex) {
        node.index = void 0;
      }
      insertChildNode(newParentNode, node);
      this.unsetActiveChild(oldParentNode, node);
      if (this.isSameOrParentForChild(node, this.currentFocusNode)) {
        this.setActiveChildRecursive(newParentNode, node);
      }
    };
    Lrud2.prototype.register = function(nodeId, nodeConfig) {
      return this.registerNode(nodeId, nodeConfig);
    };
    Lrud2.prototype.unregister = function(node, unregisterOptions) {
      this.unregisterNode(node, unregisterOptions);
    };
    Lrud2.prototype.unregisterNode = function(node, unregisterOptions) {
      var _this = this;
      if (unregisterOptions === void 0) {
        unregisterOptions = { forceRefocus: true };
      }
      node = typeof node === "string" ? this.getNode(node) : node;
      if (!node) {
        return this;
      }
      if (node === this.rootNode) {
        this.nodes = {};
        this.rootNode = void 0;
        this.currentFocusNode = void 0;
        this.isIndexAlignMode = false;
        this.emitter = mitt();
        return this;
      }
      var parentNode = node.parent;
      if (parentNode.activeChild && parentNode.activeChild === node) {
        this.isIndexAlignMode = false;
        this.unsetActiveChild(parentNode, node);
      }
      removeChildNode(parentNode, node);
      var currentFocusIsLost = false;
      traverseNodeSubtree(node, function(traversedNode) {
        delete _this.nodes[traversedNode.id];
        _this.unregisterOverride(traversedNode);
        for (var i = 0, overrideSources = traversedNode.overrideSources || []; i < overrideSources.length; i++) {
          _this.unregisterOverride(overrideSources[i].node, overrideSources[i].direction);
        }
        if (traversedNode === _this.currentFocusNode) {
          _this.currentFocusNode = void 0;
          currentFocusIsLost = true;
        }
      });
      this.emitter.emit("blur", node);
      if (node.onBlur) {
        node.onBlur(node);
      }
      if (currentFocusIsLost && unregisterOptions.forceRefocus) {
        this.recalculateFocus(parentNode);
      }
      return this;
    };
    Lrud2.prototype.registerOverride = function(source, target, direction, options) {
      if (options === void 0) {
        options = {};
      }
      source = typeof source === "string" ? this.getNode(source) : source;
      if (!source) {
        throw new Error("registering override: missing source node");
      }
      target = typeof target === "string" ? this.getNode(target) : target;
      if (!target) {
        throw new Error("registering override: missing target node");
      }
      direction = toValidDirection(direction);
      if (!direction) {
        throw new Error("registering override: missing direction");
      }
      if (source.overrides && source.overrides[direction]) {
        if (options.forceOverride) {
          this.unregisterOverride(source, direction);
        } else {
          throw new Error("registering override: override from " + source.id + " to " + target.id + " in direction " + direction + " already exist");
        }
      }
      source.overrides = source.overrides || {};
      source.overrides[direction] = target;
      target.overrideSources = target.overrideSources || [];
      target.overrideSources.push({ direction, node: source });
      return this;
    };
    Lrud2.prototype.unregisterOverride = function(source, direction) {
      source = typeof source === "string" ? this.getNode(source) : source;
      if (!source || !source.overrides) {
        return;
      }
      if (direction) {
        direction = toValidDirection(direction);
        if (!direction) {
          return;
        }
      }
      var overridesToAreEmpty = true;
      for (var _i = 0, _a = Object.keys(Directions); _i < _a.length; _i++) {
        var directionKey = _a[_i];
        var directionToRemove = Directions[directionKey];
        if (direction && direction !== directionToRemove) {
          overridesToAreEmpty = overridesToAreEmpty && !(source.overrides && source.overrides[directionToRemove]);
          continue;
        }
        var target = source.overrides[directionToRemove];
        if (target && target.overrideSources) {
          for (var i = 0; i < target.overrideSources.length; i++) {
            if (target.overrideSources[i].direction === directionToRemove && target.overrideSources[i].node === source) {
              if (target.overrideSources.length === 1) {
                target.overrideSources = void 0;
              } else {
                target.overrideSources[i] = target.overrideSources[target.overrideSources.length - 1];
                target.overrideSources.length = target.overrideSources.length - 1;
              }
              break;
            }
          }
        }
        source.overrides[directionToRemove] = void 0;
      }
      if (overridesToAreEmpty) {
        source.overrides = void 0;
      }
      return this;
    };
    Lrud2.prototype.getNode = function(nodeId) {
      if (!nodeId) {
        return void 0;
      }
      return this.nodes[nodeId];
    };
    Lrud2.prototype.pickNode = function(nodeId) {
      var node = this.getNode(nodeId);
      if (!node) {
        return void 0;
      }
      this.unregisterNode(node);
      return node;
    };
    Lrud2.prototype.climbUp = function(node, direction) {
      while (node) {
        if (node.overrides && node.overrides[direction]) {
          return node.overrides[direction];
        }
        if (node === this.currentFocusNode) {
          node = node.parent;
          continue;
        }
        if (!isDirectionAndOrientationMatching(node.orientation, direction)) {
          node = node.parent;
          continue;
        }
        if (!this.getNextFocusableChildInDirection(node, direction)) {
          node = node.parent;
          continue;
        }
        return node;
      }
      return void 0;
    };
    Lrud2.prototype.digDown = function(node, direction) {
      if (direction === void 0) {
        direction = Directions.UNSPECIFIED;
      }
      while (node) {
        if (isNodeFocusable(node) && (node.isStopPropagate || !this.doesNodeHaveFocusableChildren(node))) {
          return node;
        }
        if (this.isIndexAlignMode) {
          var currentFocusedNode = this.getCurrentFocusNode();
          var currentFocusedIndexRange = currentFocusedNode.indexRange;
          var currentFocusedIndex = currentFocusedIndexRange ? currentFocusedIndexRange[0] : currentFocusedNode.index;
          if (node.isIndexAlign) {
            if (node.parent.orientation === Orientations.VERTICAL) {
              if (direction === Directions.UP) {
                node = findChildWithClosestIndex(this.getNodeLastChild(node), currentFocusedIndex, currentFocusedIndexRange);
                continue;
              }
              if (direction === Directions.DOWN) {
                node = findChildWithClosestIndex(this.getNodeFirstChild(node), currentFocusedIndex, currentFocusedIndexRange);
                continue;
              }
            }
            if (node.parent.orientation === Orientations.HORIZONTAL) {
              if (direction === Directions.LEFT) {
                node = this.getNodeLastChild(findChildWithClosestIndex(node, currentFocusedNode.parent.index));
                continue;
              }
              if (direction === Directions.RIGHT) {
                node = this.getNodeFirstChild(findChildWithClosestIndex(node, currentFocusedNode.parent.index));
                continue;
              }
            }
          }
          var matchingViaIndexRange = findChildWithMatchingIndexRange(node, currentFocusedIndex);
          if (matchingViaIndexRange) {
            node = matchingViaIndexRange;
            continue;
          } else {
            node = findChildWithClosestIndex(node, currentFocusedIndex, currentFocusedIndexRange);
            continue;
          }
        }
        if (node.activeChild) {
          node = node.activeChild;
          continue;
        }
        node = this.getNextFocusableChildInDirection(node, Directions.UNSPECIFIED);
      }
      return void 0;
    };
    Lrud2.prototype.getNextFocusableChildInDirection = function(node, direction) {
      if (!node) {
        return void 0;
      }
      var validOrientation = toValidOrientation(node.orientation);
      var validDirection = toValidDirection(direction);
      var nextChildInDirection;
      var traverseForward = validDirection === Directions.UNSPECIFIED || validOrientation === Orientations.HORIZONTAL && validDirection === Directions.RIGHT || validOrientation === Orientations.VERTICAL && validDirection === Directions.DOWN;
      if (traverseForward) {
        nextChildInDirection = this.getNextFocusableChild(node);
      }
      var traverseBackward = validDirection === Directions.UNSPECIFIED || validOrientation === Orientations.HORIZONTAL && validDirection === Directions.LEFT || validOrientation === Orientations.VERTICAL && validDirection === Directions.UP;
      if (!nextChildInDirection && traverseBackward) {
        nextChildInDirection = this.getPrevFocusableChild(node);
      }
      return nextChildInDirection;
    };
    Lrud2.prototype.getNextFocusableChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      if (!node.activeChild) {
        return this.getNodeFirstFocusableChild(node);
      }
      for (var i = node.activeChild.index + 1; i < node.children.length; i++) {
        if (this.isNodeFocusableCandidate(node.children[i])) {
          return node.children[i];
        }
      }
      if (node.isWrapping) {
        for (var i = 0; i < node.activeChild.index; i++) {
          if (this.isNodeFocusableCandidate(node.children[i])) {
            return node.children[i];
          }
        }
      }
      return void 0;
    };
    Lrud2.prototype.getPrevFocusableChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      if (!node.activeChild) {
        return this.getNodeLastFocusableChild(node);
      }
      for (var i = node.activeChild.index - 1; i >= 0; i--) {
        if (this.isNodeFocusableCandidate(node.children[i])) {
          return node.children[i];
        }
      }
      if (node.isWrapping) {
        for (var i = node.children.length - 1; i > node.activeChild.index; i--) {
          if (this.isNodeFocusableCandidate(node.children[i])) {
            return node.children[i];
          }
        }
      }
      return void 0;
    };
    Lrud2.prototype.getNodeFirstChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      return node.children[0];
    };
    Lrud2.prototype.getNodeLastChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      return node.children[node.children.length - 1];
    };
    Lrud2.prototype.getNodeFirstFocusableChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      for (var i = 0; i < node.children.length; i++) {
        if (this.isNodeFocusableCandidate(node.children[i])) {
          return node.children[i];
        }
      }
      return void 0;
    };
    Lrud2.prototype.getNodeLastFocusableChild = function(node) {
      if (!node || !node.children) {
        return void 0;
      }
      for (var i = node.children.length - 1; i >= 0; i--) {
        if (this.isNodeFocusableCandidate(node.children[i])) {
          return node.children[i];
        }
      }
      return void 0;
    };
    Lrud2.prototype.handleKeyEvent = function(event, options) {
      if (options === void 0) {
        options = { forceFocus: false };
      }
      if (!event) {
        return void 0;
      }
      var direction = event.keyCode ? getDirectionForKeyCode(event.keyCode) : toValidDirection(event.direction);
      if (!direction) {
        return void 0;
      }
      var currentFocusNode = this.getCurrentFocusNode();
      if (direction === Directions.ENTER) {
        if (currentFocusNode) {
          this.emitter.emit("select", currentFocusNode);
          if (currentFocusNode.onSelect) {
            currentFocusNode.onSelect(currentFocusNode);
          }
        }
        return currentFocusNode;
      }
      var topNode;
      var focusableNode;
      if (!currentFocusNode && options.forceFocus) {
        topNode = this.getRootNode();
        focusableNode = this.getNextFocusableChildInDirection(topNode, Directions.UNSPECIFIED);
      } else {
        topNode = this.climbUp(currentFocusNode, direction);
        if (!topNode) {
          return void 0;
        }
        this.isIndexAlignMode = topNode.isIndexAlign === true;
        var nextChild = this.getNextFocusableChildInDirection(topNode, direction);
        focusableNode = this.digDown(nextChild || topNode, direction);
      }
      if (!focusableNode) {
        return void 0;
      }
      if (currentFocusNode && currentFocusNode.shouldCancelLeave) {
        if (currentFocusNode.shouldCancelLeave(currentFocusNode, focusableNode)) {
          if (currentFocusNode.onLeaveCancelled) {
            currentFocusNode.onLeaveCancelled(currentFocusNode, focusableNode);
          }
          this.emitter.emit("cancelled", {
            leave: currentFocusNode,
            enter: focusableNode
          });
          return currentFocusNode;
        }
      }
      if (focusableNode.shouldCancelEnter) {
        if (focusableNode.shouldCancelEnter(currentFocusNode, focusableNode)) {
          if (focusableNode.onEnterCancelled) {
            focusableNode.onEnterCancelled(currentFocusNode, focusableNode);
          }
          this.emitter.emit("cancelled", {
            leave: currentFocusNode,
            enter: focusableNode
          });
          return currentFocusNode;
        }
      }
      this.assignFocus(focusableNode);
      var offset = direction === Directions.LEFT || direction === Directions.UP ? -1 : 1;
      this.emitter.emit("move", {
        leave: currentFocusNode,
        enter: focusableNode,
        direction,
        offset
      });
      if (topNode.onMove) {
        topNode.onMove({
          node: topNode,
          leave: currentFocusNode,
          enter: focusableNode,
          direction,
          offset
        });
      }
      if (currentFocusNode && currentFocusNode.onLeave) {
        currentFocusNode.onLeave(currentFocusNode);
      }
      if (focusableNode.onEnter) {
        focusableNode.onEnter(focusableNode);
      }
      return focusableNode;
    };
    Lrud2.prototype.setActiveChild = function(parent, child) {
      parent = typeof parent === "string" ? this.getNode(parent) : parent;
      child = typeof child === "string" ? this.getNode(child) : child;
      if (!parent || !child) {
        return;
      }
      if (child.parent.id !== parent.id) {
        return;
      }
      if (parent.activeChild && parent.activeChild.id !== child.id) {
        var currentActiveChild = parent.activeChild;
        parent.activeChild = child;
        this.emitter.emit("inactive", currentActiveChild);
        if (currentActiveChild.onInactive) {
          currentActiveChild.onInactive(currentActiveChild);
        }
        this.emitter.emit("active", child);
        if (child.onActive) {
          child.onActive(child);
        }
        if (parent.onActiveChildChange) {
          parent.onActiveChildChange({
            node: parent,
            leave: currentActiveChild,
            enter: child
          });
        }
      } else if (!parent.activeChild) {
        parent.activeChild = child;
        this.emitter.emit("active", child);
        if (child.onActive) {
          child.onActive(child);
        }
        if (parent.onActiveChildChange) {
          parent.onActiveChildChange({
            node: parent,
            leave: null,
            enter: child
          });
        }
      }
    };
    Lrud2.prototype.setActiveChildRecursive = function(parent, child) {
      parent = typeof parent === "string" ? this.getNode(parent) : parent;
      child = typeof child === "string" ? this.getNode(child) : child;
      while (parent) {
        this.setActiveChild(parent, child);
        child = parent;
        parent = parent.parent;
      }
    };
    Lrud2.prototype.unsetActiveChild = function(parent, activeChild) {
      parent = typeof parent === "string" ? this.getNode(parent) : parent;
      activeChild = typeof activeChild === "string" ? this.getNode(activeChild) : activeChild;
      if (!parent || !parent.activeChild) {
        return;
      }
      if (!activeChild || parent.activeChild !== activeChild) {
        return;
      }
      var isActiveChildAtCurrentFocusNodeBranch = this.isSameOrParentForChild(activeChild, this.currentFocusNode);
      while (parent && parent.activeChild) {
        var isParentAtActiveChildBranch = parent.activeChild === activeChild;
        var isParentAtCurrentFocusedNodeBranch = this.isSameOrParentForChild(parent.activeChild, this.currentFocusNode);
        if (isActiveChildAtCurrentFocusNodeBranch || isParentAtActiveChildBranch && !isParentAtCurrentFocusedNodeBranch) {
          parent.activeChild = void 0;
        }
        activeChild = parent;
        parent = parent.parent;
      }
    };
    Lrud2.prototype.assignFocus = function(node) {
      node = typeof node === "string" ? this.getNode(node) : node;
      if (node && !isNodeFocusable(node)) {
        node = this.digDown(node, Directions.UNSPECIFIED);
      }
      if (!node) {
        throw new Error("trying to assign focus to a non focusable node");
      }
      if (this.currentFocusNode) {
        this.emitter.emit("blur", this.currentFocusNode);
        if (this.currentFocusNode.onBlur) {
          this.currentFocusNode.onBlur(this.currentFocusNode);
        }
      }
      this.currentFocusNode = node;
      if (node.parent) {
        this.setActiveChildRecursive(node.parent, node);
      }
      if (node.onFocus) {
        node.onFocus(node);
      }
      this.emitter.emit("focus", node);
    };
    Lrud2.prototype.recalculateFocus = function(node) {
      var topNode = this.climbUp(node, Directions.UNSPECIFIED) || this.getRootNode();
      var nextChild = this.getNextFocusableChildInDirection(topNode, Directions.UNSPECIFIED);
      var focusableNode = this.digDown(nextChild || topNode, Directions.UNSPECIFIED);
      if (focusableNode) {
        this.assignFocus(focusableNode);
      } else {
        this.currentFocusNode = void 0;
      }
    };
    Lrud2.prototype.registerTree = function(subTreeRootNodeConfig) {
      var _this = this;
      if (!subTreeRootNodeConfig) {
        return;
      }
      traverseNodeSubtree(subTreeRootNodeConfig, function(traversedNodeConfig) {
        _this.registerNode(traversedNodeConfig.id, traversedNodeConfig);
        if (traversedNodeConfig.children) {
          for (var i = 0; i < traversedNodeConfig.children.length; i++) {
            traversedNodeConfig.children[i].parent = traversedNodeConfig.id;
          }
        }
      });
    };
    Lrud2.prototype.insertTree = function(subTreeRootNodeConfig, options) {
      if (options === void 0) {
        options = { maintainIndex: true };
      }
      if (!subTreeRootNodeConfig) {
        return;
      }
      var nodeToReplace = this.pickNode(subTreeRootNodeConfig.id);
      if (!subTreeRootNodeConfig.parent && nodeToReplace && nodeToReplace.parent) {
        subTreeRootNodeConfig.parent = nodeToReplace.parent.id;
      }
      if (options.maintainIndex && nodeToReplace && typeof nodeToReplace.index === "number") {
        subTreeRootNodeConfig.index = nodeToReplace.index;
      }
      this.registerTree(subTreeRootNodeConfig);
    };
    Lrud2.prototype.doesNodeHaveFocusableChildren = function(node) {
      if (!node || !node.children) {
        return false;
      }
      var nodeHaveFocusableChildren = false;
      traverseNodeSubtree(node, function(traversedNode) {
        if (traversedNode !== node) {
          nodeHaveFocusableChildren = nodeHaveFocusableChildren || isNodeFocusable(traversedNode);
        }
        return nodeHaveFocusableChildren;
      });
      return nodeHaveFocusableChildren;
    };
    Lrud2.prototype.isNodeFocusableCandidate = function(node) {
      return isNodeFocusable(node) || this.doesNodeHaveFocusableChildren(node);
    };
    Lrud2.prototype.isSameOrParentForChild = function(parent, child) {
      parent = typeof parent === "string" ? this.getNode(parent) : parent;
      child = typeof child === "string" ? this.getNode(child) : child;
      if (!parent || !child) {
        return false;
      }
      if (parent === child) {
        return true;
      }
      while (child) {
        if (child.parent === parent) {
          return true;
        }
        child = child.parent;
      }
      return false;
    };
    Lrud2.prototype.setNodeFocusable = function(node, isFocusable) {
      node = typeof node === "string" ? this.getNode(node) : node;
      if (!node) {
        return;
      }
      var nodeIsFocusable = isNodeFocusable(node);
      if (nodeIsFocusable === isFocusable) {
        return;
      }
      node.isFocusable = isFocusable;
      if (!isFocusable) {
        if (this.currentFocusNode === node) {
          this.recalculateFocus(node);
        }
        if (node.parent) {
          this.unsetActiveChild(node.parent, node);
        }
      }
    };
    return Lrud2;
  }()
);
var Orientation;
(function(Orientation2) {
  Orientation2["HORIZONTAL"] = "horizontal";
  Orientation2["VERTICAL"] = "vertical";
})(Orientation || (Orientation = {}));
class FocusManager {
  constructor(element, logger) {
    this.parents = [
      "[role=menu]",
      "[role=menubar]"
    ];
    this.interactive = [
      ...this.parents,
      "button",
      "a[href]",
      "input",
      "textarea",
      "select",
      "details",
      '[tabindex]:not([tabindex="-1"]'
    ];
    this.scope = document;
    this.update = debounce(() => {
      this.createGraph();
    }, 250);
    this.onActionKey = (event) => {
      if (event.defaultPrevented) {
        return;
      }
      const direction = event.detail.action;
      const result = this.navigation.handleKeyEvent({ direction });
      this.logger.verbose(event.type, direction, result);
    };
    this.onFocus = (event) => {
      const node = this.find((node2) => node2.id === event.id);
      if (node === null || node === void 0 ? void 0 : node.element) {
        node.element.focus();
      }
    };
    this.onFocusIn = debounce((event) => {
      const { navigation } = this;
      if (!navigation) {
        return;
      }
      const node = this.find((node2) => node2.element === event.target);
      this.assignFocus(node === null || node === void 0 ? void 0 : node.id);
    }, 250);
    this.element = element;
    this.logger = logger.create({ id: "FocusManager" });
    this.scope.addEventListener("actionkey", this.onActionKey);
    this.element.addEventListener("focusin", this.onFocusIn);
  }
  createGraph() {
    var _a, _b;
    const interactiveSelector = this.interactive.join(", ");
    const parentSelector = this.parents.join(", ");
    const elementMap = /* @__PURE__ */ new Map();
    this.graph = this.elementToNode(this.element);
    this.element.querySelectorAll(interactiveSelector).forEach((element) => {
      if (element.offsetParent === null) {
        return;
      }
      if (element.disabled === true) {
        return;
      }
      const base = element.matches(parentSelector) ? element.parentElement : element;
      const parent = base.closest(parentSelector) || this.element;
      if (!elementMap.has(parent)) {
        elementMap.set(parent, []);
      }
      elementMap.get(parent).push(element);
    });
    elementMap.forEach((value, key) => {
      const parentNode = this.find((node) => node.element === key);
      parentNode.children = value.map((element) => this.elementToNode(element, parentNode));
    });
    const focused = (_a = this.navigation) === null || _a === void 0 ? void 0 : _a.getCurrentFocusNode();
    (_b = this.navigation) === null || _b === void 0 ? void 0 : _b.unregisterNode(this.rootId);
    this.walk((node) => {
      if (node.children.length === 0 && !!node.orientation) {
        node.isFocusable = false;
      }
    });
    const navigation = this.navigation = new Lrud();
    navigation.registerTree(this.graph);
    this.rootId = this.graph.id;
    navigation.on("focus", this.onFocus);
    const { activeElement } = document;
    if (focused) {
      if (!activeElement) {
        this.assignFocus(focused.id);
      } else {
        const active = this.find((node) => node.element === activeElement);
        if (active) {
          this.assignFocus(active.id);
        }
      }
    }
  }
  walk(action, base = this.graph) {
    action(base);
    for (const child of base.children) {
      this.walk(action, child);
    }
  }
  find(func, base = this.graph) {
    if (func(base)) {
      return base;
    }
    for (const child of base.children) {
      const node = this.find(func, child);
      if (node) {
        return node;
      }
    }
    return null;
  }
  focus(element) {
    const interactiveSelector = this.interactive.join(", ");
    const interactive = element.querySelector(interactiveSelector);
    const node = this.find((node2) => node2.element === interactive);
    if (!node) {
      return;
    }
    this.assignFocus(node.id);
  }
  elementToNode(element, parent) {
    const role = this.getProperty(element, "role");
    const orientation = role === "menu" ? Orientation.VERTICAL : role === "menubar" ? Orientation.HORIZONTAL : void 0;
    if (!element.dataset.auid) {
      element.dataset.auid = uid8();
    }
    return {
      id: element.dataset.auid,
      element,
      parent: parent === null || parent === void 0 ? void 0 : parent.id,
      children: [],
      orientation,
      isFocusable: !!parent
    };
  }
  getProperty(element, prop) {
    return element[prop] || element.getAttribute(prop);
  }
  destroy() {
    if (this.navigation) {
      this.navigation.off("focus", this.onFocus);
      this.navigation.unregisterNode(this.rootId);
    }
    this.element.removeEventListener("focusin", this.onFocusIn);
    this.onFocusIn.cancel();
    this.scope.removeEventListener("actionkey", this.onActionKey);
    this.scope = null;
    this.update.cancel();
    this.logger = null;
  }
  assignFocus(nodeId) {
    const { navigation } = this;
    if (nodeId && navigation.isNodeFocusableCandidate(navigation.getNode(nodeId))) {
      try {
        navigation.assignFocus(nodeId);
      } catch (e) {
      }
    }
  }
}
const LocalizationData = {
  en: {
    [LocalizationId.PLAY]: "Play",
    [LocalizationId.PAUSE]: "Pause",
    [LocalizationId.STOP]: "Stop",
    [LocalizationId.MUTE]: "Mute",
    [LocalizationId.UNMUTE]: "Unmute",
    [LocalizationId.VOLUME]: "Volume",
    [LocalizationId.CLICK_TO_UNMUTE]: "Click to unmute",
    [LocalizationId.TAP_TO_UNMUTE]: "Tap to unmute",
    [LocalizationId.SEEK]: "Seek",
    [LocalizationId.SEEK_BACK]: "Seek Backward",
    [LocalizationId.SEEK_FORWARD]: "Seek Forward",
    [LocalizationId.LIVE]: "Live",
    [LocalizationId.GO_LIVE]: "Go Live",
    [LocalizationId.CLOSED_CAPTIONS_OFF]: "Closed Captions Off",
    [LocalizationId.CLOSED_CAPTIONS_ON]: "Closed Captions On",
    [LocalizationId.FULL_SCREEN_ENTER]: "Enter Fullscreen",
    [LocalizationId.FULL_SCREEN_EXIT]: "Exit Fullscreen",
    [LocalizationId.HOURS]: "Hours",
    [LocalizationId.MINUTES]: "Minutes",
    [LocalizationId.SECONDS]: "Seconds",
    [LocalizationId.VALUE_OF_TOTAL]: "{{value}} of {{total}}",
    [LocalizationId.SETTINGS]: "Settings",
    [LocalizationId.LANGUAGE]: "Language",
    [LocalizationId.QUALITY]: "Quality",
    [LocalizationId.BACK]: "Back",
    [LocalizationId.CAPTIONS]: "Captions",
    [LocalizationId.AUDIO]: "Audio",
    [LocalizationId.CLOSE]: "Close",
    [LocalizationId.AUTO]: "Auto",
    [LocalizationId.UNKNOWN]: "Unknown"
  },
  es: {
    [LocalizationId.PLAY]: "Reproducir",
    [LocalizationId.PAUSE]: "Pausa",
    [LocalizationId.STOP]: "Stop",
    [LocalizationId.MUTE]: "Silencio",
    [LocalizationId.UNMUTE]: "Dejar de silenciar",
    [LocalizationId.VOLUME]: "Volumen",
    [LocalizationId.CLICK_TO_UNMUTE]: "Haz clic para dejar de silenciar",
    [LocalizationId.TAP_TO_UNMUTE]: "Toca para dejar de silenciar",
    [LocalizationId.SEEK]: "Buscar",
    [LocalizationId.SEEK_BACK]: "Buscar hacia atrás",
    [LocalizationId.SEEK_FORWARD]: "Buscar adelante",
    [LocalizationId.LIVE]: "En Vivo",
    [LocalizationId.GO_LIVE]: "Ir a Vivir",
    [LocalizationId.CLOSED_CAPTIONS_OFF]: "Subtítulos cerrados",
    [LocalizationId.CLOSED_CAPTIONS_ON]: "Subtítulos cerrados en",
    [LocalizationId.FULL_SCREEN_ENTER]: "Ir a pantalla completa",
    [LocalizationId.FULL_SCREEN_EXIT]: "Salir de pantalla completa",
    [LocalizationId.HOURS]: "Horas",
    [LocalizationId.MINUTES]: "Minutos",
    [LocalizationId.SECONDS]: "Segundos",
    [LocalizationId.VALUE_OF_TOTAL]: "{{value}} de {{total}}",
    [LocalizationId.SETTINGS]: "Configuraciones",
    [LocalizationId.LANGUAGE]: "Lengua",
    [LocalizationId.QUALITY]: "Calidad",
    [LocalizationId.BACK]: "Volver",
    [LocalizationId.CAPTIONS]: "Subtítulos",
    [LocalizationId.AUDIO]: "Audio",
    [LocalizationId.CLOSE]: "Cerrar",
    [LocalizationId.AUTO]: "Auto",
    [LocalizationId.UNKNOWN]: "Desconocida"
  }
};
class PreviewEngine {
  constructor(context, uiPlugin) {
    this.context = context;
    this.uiPlugin = uiPlugin;
    this.INC_PCT = 5e-4;
    this.multipliers = [1, 2, 3];
    this.cursorPosition = NaN;
    this.playPending = false;
    this.direction = 0;
    this.onActionKey = (event) => {
      const { action, avia, metadata } = event.detail;
      if (event.defaultPrevented && action !== avia.ActionKey.CANCEL) {
        return;
      }
      switch (action) {
        case avia.ActionKey.FAST_FORWARD:
          this.startFfw();
          metadata.multiplier = this.getMultiplier();
          break;
        case avia.ActionKey.REWIND:
          this.startRw();
          metadata.multiplier = this.getMultiplier();
          break;
        case avia.ActionKey.SELECT:
          this.seekToCursorPosition();
          this.reset();
          break;
        case avia.ActionKey.CANCEL:
          this.playPending = true;
          this.reset();
          break;
      }
    };
    this.onEngaged = (event) => {
      const isEngaged = event.detail.engaged;
      if (!isEngaged) {
        this.reset();
      }
    };
    this.listen(true);
  }
  destroy() {
    this.stop();
    this.listen(false);
    this.context = null;
    this.uiPlugin = null;
  }
  onTick() {
    const { player } = this.context;
    const position = this.cursorPosition + this.increment;
    this.setPosition(Math.max(0, Math.min(player.contentDuration, position)));
    this.tick();
  }
  tick() {
    this.frameId = window.requestAnimationFrame(() => this.onTick());
  }
  setPosition(position) {
    this.cursorPosition = position;
    this.uiPlugin.showPreview(position);
  }
  startFfw() {
    if (this.direction > 0) {
      this.updateIncrement();
      return;
    }
    if (this.direction <= 0) {
      this.stop();
      this.direction = 1;
    }
    this.initNav();
  }
  startRw() {
    if (this.direction < 0) {
      this.updateIncrement();
      return;
    }
    if (this.direction >= 0) {
      this.stop();
      this.direction = -1;
    }
    this.initNav();
  }
  updateIncrement(reset = false) {
    this.multiplierIndex = reset ? 0 : this.multiplierIndex + 1;
    const { player } = this.context;
    this.increment = this.INC_PCT * (player.contentDuration - player.contentTime) * this.getMultiplier() * this.direction;
  }
  getMultiplier() {
    return this.multipliers[this.multiplierIndex % this.multipliers.length];
  }
  initNav() {
    var _a;
    const { player, avia } = this.context;
    player.enterActionKeyContext(ActionKeyContext.PREVIEW_SLIDER_ENGAGED);
    if (!this.cursorPosition) {
      this.cursorPosition = player.contentTime;
    }
    this.updateIncrement(true);
    if (player.playbackState === avia.PlaybackState.PLAYING) {
      this.playPending = true;
      player.pause();
    }
    (_a = this.uiPlugin.querySelector("avia-progress-bar")) === null || _a === void 0 ? void 0 : _a.focus();
    this.tick();
  }
  stop() {
    window.cancelAnimationFrame(this.frameId);
    this.direction = 0;
    this.multiplierIndex = 0;
  }
  reset() {
    return __async(this, null, function* () {
      const { player } = this.context;
      this.stop();
      player.exitActionKeyContext(ActionKeyContext.PREVIEW_SLIDER_ENGAGED);
      if (this.playPending) {
        this.playPending = false;
        player.play();
      }
      this.cursorPosition = NaN;
    });
  }
  seekToCursorPosition() {
    return __async(this, null, function* () {
      const { player } = this.context;
      if (!isNaN(this.cursorPosition)) {
        yield player.seek(this.cursorPosition);
        this.cursorPosition = NaN;
        this.uiPlugin.hidePreview();
      }
    });
  }
  //////////////////////////
  listen(flag) {
    const { avia } = this.context;
    const docVerb = `${flag ? "add" : "remove"}EventListener`;
    document[docVerb](avia.PlayerEvent.ACTION_KEY, this.onActionKey);
    document[docVerb]("engaged", this.onEngaged);
  }
}
class ViewState {
  constructor() {
    this.controlMode = ControlMode.NONE;
    this.fullscreen = false;
    this.active = null;
    this.deviceMode = DeviceMode.DESKTOP;
    this.fullscreenDisabled = true;
    this.muted = false;
    this.muteDisabled = true;
    this.volume = 1;
    this.playing = false;
    this.playDisabled = true;
    this.textTrackEnabled = false;
    this.textDisabled = true;
    this.timeDisplayValue = "";
    this.isLiveLinear = false;
    this.isLts = false;
    this.live = false;
    this.playheadPosition = 0;
    this.durationSeconds = 0;
    this.currentTimeSeconds = 0;
    this.seekDisabled = true;
    this.seekBackDisabled = true;
    this.seekForwardDisabled = true;
    this.settingsDisabled = true;
    this.adPlayheadPosition = 0;
    this.localeData = null;
    this.preview = null;
    this.unmuteCtaVisible = false;
    this.settings = null;
    this.posterActive = false;
    this.posterImageUrl = "";
    this.qualityLabel = 0;
    this.waiting = false;
    this.initialized = false;
    this.pausable = true;
    this.isTouch = false;
    this.isIosNative = false;
    this.linkMuteAndVolume = true;
    this.playerDimensions = { width: 0, height: 0 };
    this.bufferedRanges = [];
    this.options = null;
  }
}
const UI = "ui";
const ACTION = "uiaction";
function ui(options = {}) {
  return {
    id: UI,
    factory: createUiPlugin,
    options
  };
}
function createUiPlugin(services, options) {
  return __async(this, null, function* () {
    if (typeof customElements !== "object") {
      services.logger.warn(`Polyfill warning: customElements is not defined`);
    }
    if (typeof Node.prototype.getRootNode !== "function") {
      services.logger.warn(`Polyfill warning: Node.prototype.getRootNode is not defined`);
    }
    const plugin2 = new AviaUiPlugin();
    yield plugin2.onRegister(services.player, options, services);
    return plugin2;
  });
}
class AviaUiPlugin extends AviaPluginBase {
  constructor() {
    super(UI);
    this.TV_MODE_IDLE_DELAY = 7e3;
    this.defaultSeekInc = 10;
    this.accIndicatorDisplayTime = 1500;
    this.playbackStarted = false;
    this.settingsEngaged = false;
    this.firstProgressReceived = false;
    this.defaultCompactViewBreakpoint = 520;
    this.rootElement = "avia-ui";
    this.previewTimeTransform = PreviewTimeTransform.DEFAULT;
    this.pendingActive = false;
    this.activeLocked = false;
    this.resourceStarted = false;
    this.activeMode_ = ActiveMode.AUTO;
    this.idleDelay_ = NaN;
    this.BUFFERED_CHECK_COUNT_INTERVAL = 10;
    this.bufferedCheckCounter = 0;
    this.viewState = new ViewState();
    this.seekPending = false;
    this.onUiEvent = (event) => {
      const action = event.detail.action;
      const value = event.detail.value;
      if (action !== Action.POSTER_PLAY) {
        this.dispatchEvent(action, value);
      }
      switch (action) {
        case Action.ENTER_CONTEXT:
          this.player.enterActionKeyContext(value);
          break;
        case Action.EXIT_CONTEXT:
          this.player.exitActionKeyContext(value);
          break;
        case Action.POSTER_PLAY:
          if (!this.playbackStarted && this.resourceStarted) {
            this.cancelPoster(action === Action.POSTER_PLAY);
            this.player.play().catch(() => {
            });
          }
          break;
        case Action.PLAY:
        case Action.PAUSE:
        case Action.STOP:
          this.player[action]();
          break;
        case Action.ENTER_FULLSCREEN:
          this.player.enterFullscreen();
          break;
        case Action.EXIT_FULLSCREEN:
          this.player.exitFullscreen();
          break;
        case Action.MUTE:
          this.player.muted = true;
          this.updateViewState({ muted: true });
          break;
        case Action.UNMUTE:
          this.unmute();
          break;
        case Action.TEXT_ON:
        case Action.TEXT_OFF:
          const isOn = action === Action.TEXT_ON;
          this.player.textTrackEnabled = isOn;
          this.updateViewState({ textTrackEnabled: isOn });
          break;
        case Action.SEEK:
          this.seekPending = true;
          this.player.seek(value).then(() => {
            this.seekPending = false;
          }).catch((error) => {
            this.seekPending = false;
            this.log(`AviaUI: A seek() call failed: ${error.message}`);
          });
          break;
        case Action.SEEK_FORWARD:
          this.incrementalSeek(1);
          break;
        case Action.SEEK_BACK:
          this.incrementalSeek(-1);
          break;
        case Action.VOLUME:
          this.player.volume = value;
          break;
        case Action.PREVIEW:
          const { time, percent } = value;
          const { contentDuration, streamDuration, liveStreamUtcDuration, liveStreamUtcStart } = this.player;
          const streamTime = percent * streamDuration;
          this.dispatchEvent(UiEvent.PREVIEW, value);
          Promise.resolve(this.previewTimeTransform({
            contentTime: time,
            streamTime,
            liveStreamUtcTime: Math.round(streamTime * 1e3 + liveStreamUtcStart),
            contentDuration,
            streamDuration,
            liveStreamUtcDuration
          })).then((value2) => {
            this.player.getThumbnails(time).then((thumbs) => this.updateViewState({
              preview: {
                value: value2,
                thumbs,
                thumbnailScaleFactor: this.options.thumbnailScaleFactor || 0.25
              }
            }));
          });
          break;
        case Action.SETTINGS_ON:
        case Action.SETTINGS_OFF:
          this.setStateForSettings(action === Action.SETTINGS_ON);
          break;
        case Action.LANGUAGE_SELECT:
          this.selectLanguage(value);
          break;
        case Action.QUALITY_SELECT:
          this.selectQuality(value);
          break;
        case Action.GO_TO_LIVE:
          this.player.goLive();
          break;
        case Action.LOCK_ACTIVE:
          this.activeLocked = value.locked;
          this.setActive(this.activeLocked || this.viewState.active);
          break;
      }
    };
    this.onReady = (event) => {
      var _a, _b;
      const hidden = (_a = this.getContainer()) === null || _a === void 0 ? void 0 : _a.querySelectorAll("slot-fb[hidden]");
      hidden === null || hidden === void 0 ? void 0 : hidden.forEach((slot) => slot.parentElement.removeChild(slot));
      (_b = this.focusManager) === null || _b === void 0 ? void 0 : _b.update();
      const ui2 = event.target;
      if (ui2.nodeName.toLowerCase() === "avia-ui") {
        this.setUiElement(ui2);
      }
      this.progressBar_ = this.querySelector("avia-progress-bar");
    };
    this.onKeyDown = () => {
      if (this.viewState.deviceMode !== DeviceMode.TV || this.activeMode === ActiveMode.MANUAL) {
        return;
      }
      this.setActive(true);
      if (!this.aviaUi.contains(document.activeElement)) {
        this.focusTimeout = setTimeout(() => {
          const progress = this.querySelector("avia-progress-bar");
          progress === null || progress === void 0 ? void 0 : progress.focus();
        }, 0);
      }
    };
    this.onFocusIn = () => {
      this.setActive(true);
    };
    this.aviaUi = null;
    this.accVolUpdater = debounce((state) => {
      this.setAccIndicatorState(state);
    }, this.accIndicatorDisplayTime);
    this.accSeekUpdater = debounce((state) => {
      this.setAccIndicatorState(state);
    }, this.accIndicatorDisplayTime);
    this.breakStartHandler = debounce(() => {
      this.setStateForAdBreakStart();
    }, 50);
  }
  get activeMode() {
    return this.activeMode_ || ActiveMode.AUTO;
  }
  set activeMode(value) {
    this.activeMode_ = value;
  }
  get active() {
    return this.viewState.active;
  }
  set active(value) {
    this.setActive(value);
  }
  get idleDelay() {
    return this.idleDelay_;
  }
  set idleDelay(value) {
    this.idleDelay_ = value;
  }
  showPreview(time) {
    var _a;
    const active = !isNaN(time);
    this.setActive(active);
    this.activeLocked = active;
    (_a = this.progressBar) === null || _a === void 0 ? void 0 : _a.showPreview(time);
  }
  hidePreview() {
    this.activeLocked = false;
    this.progressBar.hidePreview();
  }
  querySelector(selector) {
    if (!this.aviaUi) {
      return null;
    }
    const elements = this.aviaUi.querySelectorAll(selector);
    for (let i = 0, len = elements.length; i < len; i++) {
      const element = elements[i];
      if (element.closest("slot-fb[hidden]") == null) {
        return element;
      }
    }
    return null;
  }
  destroy() {
    var _a, _b, _c, _d, _e;
    this.accVolUpdater.cancel();
    this.accSeekUpdater.cancel();
    this.breakStartHandler.cancel();
    (_a = this.previewEngine) === null || _a === void 0 ? void 0 : _a.destroy();
    this.previewEngine = null;
    (_b = this.getContainer()) === null || _b === void 0 ? void 0 : _b.removeEventListener("ready", this.onReady);
    (_c = this.aviaUi) === null || _c === void 0 ? void 0 : _c.removeEventListener(ACTION, this.onUiEvent);
    (_d = this.aviaUi) === null || _d === void 0 ? void 0 : _d.removeEventListener("focusin", this.onFocusIn);
    this.aviaUi = null;
    (_e = this.focusManager) === null || _e === void 0 ? void 0 : _e.destroy();
    document.removeEventListener("keydown", this.onKeyDown);
    clearTimeout(this.idleTimeout);
    clearTimeout(this.focusTimeout);
    super.destroy();
  }
  initKeys() {
    const { ActionKey, KeyCode } = this.avia;
    this.avia.registerActionKeyContext(ActionKeyContext.TV, {
      [KeyCode.ENTER]: ActionKey.PLAY_PAUSE
    });
    this.avia.registerActionKeyContext(ActionKeyContext.UI, {
      [KeyCode.LEFT_ARROW]: ActionKey.LEFT,
      [KeyCode.RIGHT_ARROW]: ActionKey.RIGHT,
      [KeyCode.UP_ARROW]: ActionKey.UP,
      [KeyCode.DOWN_ARROW]: ActionKey.DOWN
    });
    this.avia.registerActionKeyContext(ActionKeyContext.BUTTON, {
      [KeyCode.ENTER]: ActionKey.SELECT,
      [KeyCode.SPACE]: ActionKey.SELECT
    });
    this.avia.registerActionKeyContext(ActionKeyContext.SLIDER, {
      [KeyCode.LEFT_ARROW]: ActionKey.LEFT,
      [KeyCode.RIGHT_ARROW]: ActionKey.RIGHT,
      [KeyCode.UP_ARROW]: ActionKey.UP,
      [KeyCode.DOWN_ARROW]: ActionKey.DOWN,
      [KeyCode.PAGE_UP]: ActionKey.UP,
      [KeyCode.PAGE_DOWN]: ActionKey.DOWN
    });
    this.avia.registerActionKeyContext(ActionKeyContext.SLIDER_ENGAGED, {
      [KeyCode.ENTER]: ActionKey.SELECT,
      [KeyCode.SPACE]: ActionKey.SELECT,
      [KeyCode.MEDIA_PLAY]: ActionKey.SELECT,
      [KeyCode.MEDIA_PLAY_PAUSE]: ActionKey.SELECT
    });
    this.avia.registerActionKeyContext(ActionKeyContext.PREVIEW_SLIDER_ENGAGED, {
      [KeyCode.MEDIA_PLAY]: ActionKey.SELECT,
      [KeyCode.MEDIA_PAUSE]: ActionKey.SELECT,
      [KeyCode.MEDIA_PLAY_PAUSE]: ActionKey.SELECT,
      [KeyCode.MEDIA_STOP]: ActionKey.CANCEL,
      [KeyCode.ESCAPE]: ActionKey.CANCEL
    });
    this.avia.registerActionKeyContext(ActionKeyContext.SEEK, {
      [KeyCode.ENTER]: ActionKey.SELECT,
      [KeyCode.SPACE]: ActionKey.SELECT,
      [KeyCode.ESCAPE]: ActionKey.CANCEL
    });
    this.avia.registerActionKeyContext(ActionKeyContext.PANEL, {
      [KeyCode.ESCAPE]: ActionKey.CANCEL
    });
    this.avia.registerActionKeyContext(ActionKeyContext.MENU, {
      [KeyCode.ENTER]: ActionKey.SELECT,
      [KeyCode.SPACE]: ActionKey.SELECT,
      [KeyCode.RIGHT_ARROW]: ActionKey.RIGHT
    });
    document.addEventListener("keydown", this.onKeyDown);
  }
  updateViewState(state) {
    Object.assign(this.viewState, state);
    if (!this.aviaUi) {
      return;
    }
    Object.entries(state).forEach(([key, value]) => {
      this.aviaUi[key] = value;
    });
  }
  dispatchEvent(type, detail = {}) {
    this.services.event.dispatchPluginEvent({
      id: this.id,
      target: this,
      type,
      detail
    });
  }
  onPlayerEvent(event) {
    const { PlayerEvent, StreamType, PlaybackState } = this.avia;
    const isLive = this.player.streamType === StreamType.LIVE;
    const isLts = this.player.streamType === StreamType.LTS;
    const { type, detail } = event;
    const update = {};
    switch (type) {
      case PlayerEvent.CLOCK:
        this.bufferedCheckCounter = detail.count;
        const state = this.player.playbackState;
        if (state === PlaybackState.PAUSED || state === PlaybackState.WAITING) {
          this.updateBufferedRanges();
        }
        break;
      case PlayerEvent.READY:
        this.setPlayState();
        this.setPosterState();
        break;
      case PlayerEvent.AUTOPLAY_BLOCKED:
        this.setPosterState(true);
        break;
      case PlayerEvent.RESOURCE_START:
        this.setPosterState(this.viewState.posterActive);
        this.setSegmentBreakPositions([]);
        this.resourceStarted = true;
        break;
      case PlayerEvent.AD_CUEPOINTS_AVAILABLE:
        this.setSegmentBreakPositions(detail.cuepoints);
        break;
      case PlayerEvent.AD_SEGMENT_START:
        if (this.options.showAdControlsOnAdSegmentStart !== false) {
          this.breakStartHandler();
        } else {
          this.setControlMode(ControlMode.CONTENT);
        }
        break;
      case PlayerEvent.AD_START:
        this.setControlMode(ControlMode.AD);
        this.enableControls([ControlFunction.PLAY], true);
        this.updateViewState({ playing: true });
        break;
      case PlayerEvent.AD_BREAK_START:
        this.breakStartHandler();
        break;
      case PlayerEvent.AD_PROGRESS:
        this.setAdPosition(detail);
        break;
      case PlayerEvent.AD_SEGMENT_END:
      case PlayerEvent.AD_BREAK_COMPLETE:
        this.setControlMode(ControlMode.NONE);
        break;
      case PlayerEvent.CONTENT_START:
      case PlayerEvent.CONTENT_SEGMENT_START:
        this.setStateForContentStart(isLive, isLts);
        break;
      case PlayerEvent.CONTENT_SEGMENT_END:
        this.firstProgressReceived = false;
        this.setControlMode(ControlMode.NONE);
        break;
      case PlayerEvent.CONTENT_PLAYING:
        this.setControlMode(ControlMode.CONTENT);
        this.setPlayState();
        break;
      case PlayerEvent.AD_PAUSED:
      case PlayerEvent.CONTENT_PAUSED:
        this.updateViewState({ playing: false });
        break;
      case PlayerEvent.AD_PLAYING:
        this.updateViewState({ playing: true });
        break;
      case PlayerEvent.STREAM_TYPE_CHANGE:
        this.setLiveState(isLive, isLts);
        break;
      case PlayerEvent.CONTENT_PROGRESS:
        if (!this.firstProgressReceived) {
          this.firstProgressReceived = true;
          this.setPlayState();
          this.setLiveState(isLive, isLts);
        }
        if (!this.seekPending) {
          this.updateBufferedRanges();
          if (!isLive) {
            this.setTimeAndPosition();
          }
          if (isLive || isLts) {
            this.setLiveState(isLive, isLts);
          }
        }
        break;
      case PlayerEvent.FULLSCREEN_CHANGE:
        this.updateViewState({ fullscreen: detail.fullscreen });
        break;
      case PlayerEvent.TEXT_TRACK_ENABLED_CHANGE:
        this.updateViewState({ textTrackEnabled: detail.textTrackEnabled });
        break;
      case PlayerEvent.LANGUAGE_CHANGE:
        this.setLocalizationData(detail.language || "en");
        break;
      case PlayerEvent.MUTE_CHANGE:
        update.muted = detail.muted;
        if (!this.player.muted) {
          update.unmuteCtaVisible = false;
        }
        this.updateViewState(update);
        break;
      case PlayerEvent.VOLUME_CHANGE:
        const { volume } = detail;
        const muted = this.player.muted;
        update.volume = volume;
        if (this.viewState.volume === volume) {
          break;
        }
        if (!this.viewState.muted) {
          update.muted = Math.ceil(volume) ? false : true;
        } else if (this.viewState.muted && volume > 0) {
          this.unmute();
        }
        if (!muted) {
          update.unmuteCtaVisible = false;
        }
        this.updateViewState(update);
        break;
      case PlayerEvent.ACTION_KEY_METADATA:
        this.playbackStarted && this.setAccIndicator(detail.action, detail.metadata);
        break;
      case PlayerEvent.ACTIVE_STATE_CHANGE:
        if (this.activeMode === ActiveMode.AUTO) {
          this.setActiveState(detail.activeState);
        }
        break;
      case PlayerEvent.PRESENTATION_SIZE_CHANGE:
        this.respondToSizeChange();
        break;
      case PlayerEvent.AUDIO_TRACK_CHANGE:
      case PlayerEvent.AUDIO_TRACKS_CHANGE:
      case PlayerEvent.QUALITY_CHANGE:
      case PlayerEvent.QUALITIES_CHANGE:
      case PlayerEvent.TEXT_TRACK_CHANGE:
      case PlayerEvent.TEXT_TRACKS_CHANGE:
        if (type === PlayerEvent.TEXT_TRACKS_CHANGE) {
          this.enableControls(ControlFunction.TEXT, true);
        }
        this.enableSettingsButton();
        this.setStateForSettings();
        break;
      case PlayerEvent.RESOURCE_END:
        this.setIdleState();
        break;
      case PlayerEvent.PLAYBACK_STATE_CHANGE:
        this.setPlayState();
        break;
    }
  }
  updateBufferedRanges() {
    const update = this.bufferedCheckCounter % this.BUFFERED_CHECK_COUNT_INTERVAL === 0 && this.player.streamType !== this.avia.StreamType.LIVE;
    if (!update) {
      return;
    }
    const buffered = this.player.getBuffered();
    const ranges = (buffered || []).map((range2) => {
      return {
        start: range2.startTime,
        end: range2.endTime
      };
    });
    const t = this.player.contentTime;
    this.updateViewState({ bufferedRanges: this.options.showForwardBufferedRangeOnly === false ? ranges : ranges.filter((r) => t >= r.start && t <= r.end) });
  }
  incrementalSeek(dir) {
    const inc = this.options.seekIncrement || this.defaultSeekInc;
    const increment = dir * inc;
    this.player.jump(increment).catch((error) => {
      this.log(`AviaUI: A jump() call failed: ${error.message}`);
    });
    this.player.recordMetric(this.avia.MetricType.UI, this.avia.UiMetric.SEEK_BY, increment);
  }
  unmute() {
    this.player.muted = false;
    this.updateViewState({ muted: false });
  }
  setControlMode(mode) {
    this.updateViewState({ controlMode: mode === ControlMode.CONTENT ? this.getContentControlMode() : mode });
  }
  setActiveState(state) {
    this.active = state === this.avia.ActiveState.ACTIVE;
  }
  setActive(active) {
    var _a, _b;
    if (!this.playbackStarted) {
      this.pendingActive = true;
      return;
    }
    if (this.activeLocked) {
      return;
    }
    this.updateViewState({
      active: this.activeMode === ActiveMode.MANUAL ? active : ((_b = (_a = this.aviaUi) === null || _a === void 0 ? void 0 : _a.settings) === null || _b === void 0 ? void 0 : _b.active) ? true : active
    });
    if (this.options.offsetTimedTextOnControlsVisible && this.viewState.controlMode === ControlMode.CONTENT) {
      this.player.offsetTimedText(active ? this.controlBarHeight + 4 : 0);
    }
    if (this.viewState.active) {
      this.activateTimeout();
    } else {
      const element = document.activeElement;
      if (this.aviaUi.contains(element)) {
        element.blur();
      }
    }
  }
  activateTimeout() {
    clearTimeout(this.idleTimeout);
    if (this.activeMode === ActiveMode.MANUAL || !Number.isFinite(this.idleDelay)) {
      return;
    }
    this.idleTimeout = setTimeout(() => {
      if (this.viewState.settings.active || this.activeLocked) {
        this.activateTimeout();
        return;
      }
      this.setActive(false);
    }, this.idleDelay);
  }
  setAccIndicator(action, data) {
    const newState = {};
    const { ActionKey } = this.avia;
    switch (action) {
      case ActionKey.INCREASE_VOLUME:
      case ActionKey.DECREASE_VOLUME:
      case ActionKey.MUTE_UNMUTE:
        newState.volumeKey = true;
        this.accVolUpdater({ volumeKey: false });
        if (!this.player.muted) {
          this.updateViewState({ unmuteCtaVisible: false });
        }
        break;
      case ActionKey.SKIP_FORWARD:
      case ActionKey.SKIP_BACKWARD:
        newState.seekForward = action === ActionKey.SKIP_FORWARD;
        newState.seekBack = action === ActionKey.SKIP_BACKWARD;
        newState.seekTime = (data === null || data === void 0 ? void 0 : data.position) || 0;
        this.accSeekUpdater({ seekForward: false, seekBack: false, seekTime: null });
        break;
      case ActionKey.FAST_FORWARD:
        newState.seekForward = true;
        newState.seekBack = false;
        newState.multiplier = data.multiplier;
        break;
      case ActionKey.REWIND:
        newState.seekForward = false;
        newState.seekBack = true;
        newState.multiplier = data.multiplier;
        break;
      case ActionKey.SELECT:
      case ActionKey.CANCEL:
        newState.seekForward = false;
        newState.seekBack = false;
        newState.multiplier = 0;
        break;
    }
    this.setAccIndicatorState(newState);
  }
  setAccIndicatorState(state) {
    this.updateViewState({
      accIndicatorState: Object.assign(Object.assign({}, this.viewState.accIndicatorState), state)
    });
  }
  setStateForContentStart(isLive, isLts) {
    this.cancelPoster(false);
    this.setControlMode(ControlMode.CONTENT);
    this.setLiveState(isLive, isLts);
    const viewState = {
      muted: this.player.muted,
      volume: this.player.volume
    };
    const enabled = [ControlFunction.MUTE, ControlFunction.PLAY];
    if (this.options.disableFullscreen !== true) {
      enabled.push(ControlFunction.FULLSCREEN);
    }
    this.enableControls(enabled, true);
    this.updateViewState(viewState);
    this.setSeekDisabled(false);
    this.setStateForPlaybackStart();
    this.enableSettingsButton();
  }
  setStateForAdBreakStart() {
    const enabled = [ControlFunction.MUTE, ControlFunction.PLAY];
    if (!this.services.playerOptions.useNativeFullscreen || this.services.system.hasFullscreenApi && this.options.disableFullscreen !== true) {
      enabled.push(ControlFunction.FULLSCREEN);
    } else {
      this.enableControls([ControlFunction.FULLSCREEN], false);
    }
    this.cancelPoster(false);
    this.setControlMode(ControlMode.AD);
    this.enableControls(enabled, true);
    this.updateViewState({
      playing: true,
      muted: this.player.muted
    });
    this.setStateForPlaybackStart();
  }
  setStateForPlaybackStart() {
    if (this.options.useUnmuteCta && !this.playbackStarted && this.player.muted) {
      this.updateViewState({ unmuteCtaVisible: true });
    }
    this.playbackStarted = true;
    this.setPlayState();
    if (this.pendingActive) {
      this.pendingActive = false;
      this.setActiveState(this.avia.ActiveState.ACTIVE);
    }
  }
  setPosterState(active = this.services.playerOptions.autoplay === this.avia.Autoplay.NONE) {
    var _a;
    this.updateViewState({
      posterImageUrl: ((_a = this.player.resource) === null || _a === void 0 ? void 0 : _a.location.posterImageUrl) || this.options.posterImageUrl,
      posterActive: active
    });
  }
  cancelPoster(posterClicked) {
    this.updateViewState({ posterActive: false });
    if (posterClicked) {
      this.dispatchEvent(UiEvent.POSTER_PLAY);
    }
  }
  setIdleState() {
    this.setControlMode(ControlMode.NONE);
    this.updateViewState({
      unmuteCtaVisible: false,
      active: false
    });
    const enabled = [
      ControlFunction.MUTE,
      ControlFunction.PLAY,
      ControlFunction.TEXT
    ];
    if (this.options.disableFullscreen !== true) {
      enabled.push(ControlFunction.FULLSCREEN);
    }
    this.enableControls(enabled, false);
    this.playbackStarted = false;
  }
  setLiveState(isLive, isLts) {
    const isPlayingLive = this.player.isPlayingLive;
    this.updateViewState({
      isLiveLinear: isLive,
      isLts,
      live: isLive || isLts && isPlayingLive,
      pausable: this.player.pausable,
      seekForwardDisabled: isLts ? isPlayingLive : this.viewState.seekForwardDisabled
    });
  }
  setPlayState() {
    const { playbackState } = this.player;
    const isPlaying = playbackState === this.avia.PlaybackState.PLAYING;
    const isWaiting = playbackState === this.avia.PlaybackState.WAITING;
    const isPaused = playbackState === this.avia.PlaybackState.PAUSED;
    this.updateViewState({
      playing: isWaiting || isPlaying ? true : false,
      playDisabled: !isPlaying && !isPaused,
      waiting: isWaiting
    });
    if (this.viewState.deviceMode === DeviceMode.TV && isPaused) {
      this.setActive(true);
    }
  }
  respondToSizeChange() {
    const { controlMode } = this.aviaUi;
    this.updateViewState({
      playerDimensions: this.player.dimensions,
      controlMode: controlMode === ControlMode.CONTENT || controlMode === ControlMode.COMPACT ? this.getContentControlMode() : this.viewState.controlMode
    });
  }
  getContentControlMode() {
    const { width } = this.player.dimensions;
    const brk = this.options.compactViewBreakpoint || this.defaultCompactViewBreakpoint;
    return width > brk ? ControlMode.CONTENT : ControlMode.COMPACT;
  }
  enableSettingsButton() {
    const p = this.player;
    const t = p.textTrack;
    const a = p.audioTrack;
    const q = p.qualities.length > 1;
    this.updateViewState({ settingsDisabled: !(t || a || q) });
  }
  setStateForSettings(active = this.settingsEngaged) {
    const player = this.player;
    if (this.services.system.browser === this.avia.Browser.FIREFOX && active) {
      this.aviaUi.classList.add(CssNames.SETTINGS_NUDGE_LEFT);
    }
    const categories = /* @__PURE__ */ new Set();
    player.qualities.forEach((quality) => quality.enabled && categories.add(quality.category[this.viewState.qualityLabel]));
    this.updateViewState({
      settings: {
        active,
        languageEnabled: player.textTracks.length > 1 || player.audioTracks.length > 1,
        qualityEnabled: categories.size > 1,
        textTrack: player.textTrack,
        textTracks: player.textTracks,
        audioTrack: player.audioTrack,
        audioTracks: player.audioTracks,
        quality: player.quality,
        qualities: player.qualities,
        qualityAuto: player.autoQualitySwitching
      }
    });
    this.settingsEngaged = active;
    this.pauseOnSettings(active);
  }
  pauseOnSettings(active) {
    if (this.options.pauseOnSettings) {
      const playing = this.player.playbackState === this.avia.PlaybackState.PLAYING;
      if (active && playing) {
        this.player.pause();
        this.playPendingAfterSettings = true;
      }
      if (!active && this.playPendingAfterSettings) {
        this.playPendingAfterSettings = false;
        this.player.play();
      }
    }
  }
  enableControls(name, flag) {
    if (!this.aviaUi) {
      return;
    }
    const arr = !Array.isArray(name) ? [name] : name;
    const uir = this.aviaUi;
    arr.forEach((n) => uir[`${n}Disabled`] = !flag);
  }
  setSeekDisabled(flag) {
    this.updateViewState({
      seekDisabled: flag,
      seekBackDisabled: flag,
      seekForwardDisabled: flag
    });
  }
  setAdPosition(detail) {
    let time, dur;
    if (this.options.showBreakProgress) {
      time = detail.breakTime;
      dur = detail.breakDuration;
    } else {
      time = detail.currentTime;
      dur = detail.duration;
    }
    this.updateViewState({ adPlayheadPosition: time / dur });
  }
  setTimeAndPosition() {
    if (this.viewState.waiting && !this.player.video.paused || this.seekPending) {
      return;
    }
    const ct = this.player.contentTime;
    const dur = this.player.contentDuration;
    this.updateViewState({
      timeDisplayValue: this.getTimeDisplayValue(ct, dur),
      currentTimeSeconds: ct,
      durationSeconds: dur,
      playheadPosition: ct / dur
    });
  }
  setSegmentBreakPositions(times) {
    const d = this.player.contentDuration;
    this.updateViewState({ segmentBreakPositions: times.filter((t) => t > 0 && t !== d).join(",") });
  }
  selectLanguage(data) {
    var _a, _b;
    const t = data.trackType;
    const id = data.trackId;
    if (t === "text") {
      const track = (_a = this.player.textTracks) === null || _a === void 0 ? void 0 : _a.find((tk) => tk.id === id);
      if (track) {
        this.player.textTrack = track;
      }
    } else if (t === "audio") {
      const track = (_b = this.player.audioTracks) === null || _b === void 0 ? void 0 : _b.find((tk) => tk.id === id);
      if (track) {
        this.player.audioTrack = track;
      }
    }
  }
  selectQuality(data) {
    const { index } = data;
    if (index === -1) {
      this.player.autoQualitySwitching = true;
      return;
    }
    const quality = this.player.qualities.find((quality2) => quality2.index === index);
    const bitrate = quality === null || quality === void 0 ? void 0 : quality.bitrate;
    if (bitrate) {
      this.player.bitrate = bitrate;
    }
  }
  getTimeDisplayValue(ct, dur) {
    if (dur > 86400) {
      return "";
    }
    return `${secToHms(ct)} / ${secToHms(dur)}`;
  }
  get progressBar() {
    if (!this.progressBar_) {
      this.progressBar_ = this.querySelector("avia-progress-bar");
    }
    return this.progressBar_;
  }
  ////////////////////////
  // initialization & util
  get controlBarHeight() {
    if (this.controlBarHeight_ == null) {
      const bar = this.querySelector("avia-control-bar");
      this.controlBarHeight_ = bar.getBoundingClientRect().height;
    }
    return this.controlBarHeight_;
  }
  createUi() {
    if (this.options.focusManagerEnabled !== false) {
      this.focusManager = new FocusManager(this.getContainer(), this.services.logger);
    }
    this.applyTheme(this.options.theme);
    return customElements.whenDefined(this.rootElement).then(() => {
      this.initializeState();
    });
  }
  getContainer() {
    var _a;
    let container = this.options.container;
    if (container) {
      container = document.querySelector(container);
    }
    return container || ((_a = this.services) === null || _a === void 0 ? void 0 : _a.dom.main);
  }
  initializeState() {
    const { options, services } = this;
    const deviceMode = this.calculateDeviceMode();
    if (options.activeMode) {
      this.activeMode = options.activeMode;
    } else if (deviceMode === DeviceMode.TV) {
      this.active = true;
      this.idleDelay = options.idleDelay || this.TV_MODE_IDLE_DELAY;
      if (options.progressMode == null) {
        options.progressMode = ProgressMode.CURSOR;
      }
      this.player.exitActionKeyContext(this.avia.ActionKeyContext.HOTKEY);
      this.player.enterActionKeyContext(ActionKeyContext.TV);
      this.log("AviaUI is in TV Mode");
    }
    if (options.previewTimeTransform) {
      this.previewTimeTransform = options.previewTimeTransform;
    }
    this.updateViewState({
      accIndicatorState: {
        displayTime: this.accIndicatorDisplayTime,
        volumeKey: false,
        muted: false,
        seekForward: false,
        seekBack: false,
        seekTime: null,
        multiplier: 0
      },
      qualityLabel: options.qualityLabel || 0,
      deviceMode,
      isIosNative: deviceMode === DeviceMode.MOBILE && !services.system.hasFullscreenApi && services.playerOptions.useNativeFullscreen,
      linkMuteAndVolume: options.linkMuteAndVolume !== false,
      isTouch: "ontouchstart" in document.documentElement,
      options,
      active: options.active,
      initialized: true
    });
    this.previewEngine = new PreviewEngine(services, this);
  }
  setLocalizationData(lang) {
    const localeData = Object.values(LocalizationId).reduce((acc, id) => {
      acc[id] = this.services.localization.localize(id, lang);
      return acc;
    }, {});
    this.updateViewState({ localeData });
  }
  calculateDeviceMode() {
    const { deviceMode } = this.options;
    if (deviceMode && deviceMode !== DeviceMode.AUTO) {
      return deviceMode;
    }
    const { system } = this.services;
    if (system.isTv || system.isConsole || system.isEmbedded || system.isChromecast) {
      return DeviceMode.TV;
    }
    if (system.isMobile) {
      return DeviceMode.MOBILE;
    }
    return DeviceMode.DESKTOP;
  }
  setUiElement(element) {
    var _a;
    const previous = this.aviaUi;
    if (!element || element === previous) {
      return;
    }
    if (previous) {
      (_a = previous.parentElement) === null || _a === void 0 ? void 0 : _a.removeChild(previous);
      previous.removeEventListener(ACTION, this.onUiEvent);
      previous.removeEventListener("focusin", this.onFocusIn);
    }
    Object.entries(this.viewState).forEach(([key, value]) => {
      if (typeof value === "function" || key.startsWith("_") || value instanceof HTMLElement) {
        return;
      }
      element[key] = value;
    });
    this.aviaUi = element;
    this.aviaUi.addEventListener(ACTION, this.onUiEvent);
    this.aviaUi.addEventListener("focusin", this.onFocusIn);
    this.progressBar_ = this.querySelector("avia-progress-bar");
  }
  getEventInterests() {
    const { PlayerEvent } = this.avia;
    return [
      PlayerEvent.CLOCK,
      PlayerEvent.READY,
      PlayerEvent.AUTOPLAY_BLOCKED,
      PlayerEvent.RESOURCE_START,
      PlayerEvent.AD_CUEPOINTS_AVAILABLE,
      PlayerEvent.AD_SEGMENT_START,
      PlayerEvent.AD_START,
      PlayerEvent.AD_BREAK_START,
      PlayerEvent.AD_PROGRESS,
      PlayerEvent.AD_SEGMENT_END,
      PlayerEvent.AD_BREAK_COMPLETE,
      PlayerEvent.CONTENT_START,
      PlayerEvent.CONTENT_SEGMENT_START,
      PlayerEvent.CONTENT_SEGMENT_END,
      PlayerEvent.CONTENT_PLAYING,
      PlayerEvent.AD_PAUSED,
      PlayerEvent.CONTENT_PAUSED,
      PlayerEvent.AD_PLAYING,
      PlayerEvent.STREAM_TYPE_CHANGE,
      PlayerEvent.CONTENT_PROGRESS,
      PlayerEvent.FULLSCREEN_CHANGE,
      PlayerEvent.TEXT_TRACK_ENABLED_CHANGE,
      PlayerEvent.LANGUAGE_CHANGE,
      PlayerEvent.MUTE_CHANGE,
      PlayerEvent.VOLUME_CHANGE,
      PlayerEvent.ACTION_KEY_METADATA,
      PlayerEvent.ACTIVE_STATE_CHANGE,
      PlayerEvent.PRESENTATION_SIZE_CHANGE,
      PlayerEvent.AUDIO_TRACK_CHANGE,
      PlayerEvent.AUDIO_TRACKS_CHANGE,
      PlayerEvent.QUALITY_CHANGE,
      PlayerEvent.QUALITIES_CHANGE,
      PlayerEvent.TEXT_TRACK_CHANGE,
      PlayerEvent.TEXT_TRACKS_CHANGE,
      PlayerEvent.RESOURCE_END,
      PlayerEvent.PLAYBACK_STATE_CHANGE
    ];
  }
  initialize() {
    return __async(this, null, function* () {
      const container = this.getContainer();
      container.addEventListener("ready", this.onReady);
      this.services.localization.registerLocalizationData(LocalizationData);
      this.initKeys();
      yield this.createUi();
    });
  }
  applyTheme(theme = {}) {
    const container = this.getContainer();
    const { html, cssVars: cssVars2 } = theme;
    if (cssVars2) {
      applyCssVars(cssVars2);
    }
    let aviaUi = container.querySelector(this.rootElement);
    const shouldCreateUi = this.options.useDefaultTheme !== false && !aviaUi;
    if (html || shouldCreateUi) {
      const elements = html ? createElementsFromString(html) : [document.createElement(this.rootElement)];
      aviaUi = elements.find((element) => element.nodeName.toLowerCase() === this.rootElement);
      if (!aviaUi) {
        throw new Error(`Avia UI theme HTML must contain the root element ${this.rootElement}`);
      }
      elements.forEach((element) => container.appendChild(element));
      return;
    }
    this.setUiElement(aviaUi);
  }
}
cssVars({
  watch: true
});
const ID = UI;
const createPlugin = createUiPlugin;
const plugin = ui;
const aviaAccessibilityCss = "avia-accessibility{display:block}";
const AviaAccessibility$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("avia-volume-indicator", null), h("avia-seek-indicator", null), h("avia-scrub-indicator", null));
  }
  static get style() {
    return aviaAccessibilityCss;
  }
};
const aviaActiveCss = "avia-active{display:block;transition:var(--avia-active-transition-in)}avia-ui:not([active]) avia-active{opacity:0;transition:var(--avia-active-transition-out)}";
const AviaActive$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null);
  }
  static get style() {
    return aviaActiveCss;
  }
};
const aviaAdControlBarCss = 'avia-ad-control-bar{position:absolute;height:56px;width:100%;left:0;bottom:0;right:0;pointer-events:none;flex-direction:row;justify-content:center;display:none;transition:var(--avia-active-transition-in)}avia-ui[control-mode="ad"] avia-ad-control-bar{display:flex}.avia-ad-control-container{pointer-events:auto;display:flex;width:calc(3 * var(--avia-control-bar-btn-width) + (2 * var(--avia-default-spacing)));height:var(--avia-control-bar-btn-height);justify-content:space-between;background-color:var(--avia-ad-control-bg-color);border-radius:var(--avia-ad-control-border-radius)}avia-ui:not([active]) avia-ad-control-bar{opacity:0;transition:var(--avia-active-transition-out)}';
const AviaAdControlBar$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("div", { class: "avia-ad-control-container" }, h("avia-mute-toggle", null), h("avia-play-toggle", null), h("avia-fullscreen-toggle", null)), h("avia-ad-progress-bar", null));
  }
  static get style() {
    return aviaAdControlBarCss;
  }
};
var createDeferredPromise = function() {
  var resolve;
  var promise = new Promise(function(res) {
    resolve = res;
  });
  return { promise, resolve };
};
var openWormhole = function(Component, props, isBlocking) {
  if (isBlocking === void 0) {
    isBlocking = true;
  }
  var isConstructor = Component.constructor.name === "Function";
  var Proto = isConstructor ? Component.prototype : Component;
  var componentWillLoad = Proto.componentWillLoad;
  Proto.componentWillLoad = function() {
    var _this = this;
    var el = getElement(this);
    var onOpen = createDeferredPromise();
    var event = new CustomEvent("openWormhole", {
      bubbles: true,
      composed: true,
      detail: {
        consumer: this,
        fields: props,
        updater: function(prop, value) {
          var target = prop in el ? el : _this;
          target[prop] = value;
        },
        onOpen
      }
    });
    el.dispatchEvent(event);
    var willLoad = function() {
      if (componentWillLoad) {
        return componentWillLoad.call(_this);
      }
    };
    return isBlocking ? onOpen.promise.then(function() {
      return willLoad();
    }) : willLoad();
  };
};
var multiverse = /* @__PURE__ */ new Map();
var updateConsumer = function(_a, state) {
  var fields = _a.fields, updater = _a.updater;
  fields.forEach(function(field) {
    updater(field, state[field]);
  });
};
var Universe = {
  create: function(creator, initialState) {
    var el = getElement(creator);
    var wormholes = /* @__PURE__ */ new Map();
    var universe = { wormholes, state: initialState };
    multiverse.set(creator, universe);
    var connectedCallback2 = creator.connectedCallback;
    creator.connectedCallback = function() {
      multiverse.set(creator, universe);
      if (connectedCallback2) {
        connectedCallback2.call(creator);
      }
    };
    var disconnectedCallback2 = creator.disconnectedCallback;
    creator.disconnectedCallback = function() {
      multiverse.delete(creator);
      if (disconnectedCallback2) {
        disconnectedCallback2.call(creator);
      }
    };
    el.addEventListener("openWormhole", function(event) {
      event.stopPropagation();
      var _a = event.detail, consumer = _a.consumer, onOpen = _a.onOpen;
      if (wormholes.has(consumer))
        return;
      if (typeof consumer !== "symbol") {
        var connectedCallback_1 = consumer.connectedCallback, disconnectedCallback_1 = consumer.disconnectedCallback;
        consumer.connectedCallback = function() {
          wormholes.set(consumer, event.detail);
          if (connectedCallback_1) {
            connectedCallback_1.call(consumer);
          }
        };
        consumer.disconnectedCallback = function() {
          wormholes.delete(consumer);
          if (disconnectedCallback_1) {
            disconnectedCallback_1.call(consumer);
          }
        };
      }
      wormholes.set(consumer, event.detail);
      updateConsumer(event.detail, universe.state);
      onOpen === null || onOpen === void 0 ? void 0 : onOpen.resolve(function() {
        wormholes.delete(consumer);
      });
    });
    el.addEventListener("closeWormhole", function(event) {
      var consumer = event.detail;
      wormholes.delete(consumer);
    });
  },
  Provider: function(_a, children) {
    var state = _a.state;
    var creator = getRenderingRef();
    if (multiverse.has(creator)) {
      var universe = multiverse.get(creator);
      universe.state = state;
      universe.wormholes.forEach(function(opening) {
        updateConsumer(opening, state);
      });
    }
    return children;
  }
};
const aviaAdProgressBarCss = "avia-ad-progress-bar{display:block;position:absolute;background:var(--avia-ad-progress-track-color);position:absolute;height:3px;bottom:0;left:0;right:0;user-select:none}.avia-ad-prog-bar{height:3px;user-select:none;background-color:var(--avia-ad-progress-color);width:0%}";
const AviaAdProgressBar$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.onRef = (element) => {
      this.pbar = element;
      this.adPlayheadPositionHandler(this.adPlayheadPosition);
    };
    this.adPlayheadPosition = 0;
    this.isLiveLinear = false;
  }
  adPlayheadPositionHandler(val) {
    if (!this.pbar || val === null || val === void 0 || isNaN(val) || val < 0) {
      return;
    }
    this.pbar.style.width = `${val * 100}%`;
  }
  render() {
    return h("div", { class: "avia-ad-prog-bar", ref: this.onRef });
  }
  static get watchers() {
    return {
      "adPlayheadPosition": ["adPlayheadPositionHandler"]
    };
  }
  static get style() {
    return aviaAdProgressBarCss;
  }
};
openWormhole(AviaAdProgressBar$1, ["adPlayheadPosition", "isLiveLinear"]);
const aviaButtonCss = "avia-button{display:inline-block;background-color:transparent;height:var(--avia-control-bar-btn-height);width:var(--avia-control-bar-btn-width);color:var(--avia-control-bar-btn-text-color);border:var(--avia-control-bar-btn-border);border-width:var(--avia-control-bar-btn-border-width);border-radius:var(--avia-control-bar-btn-border-radius);outline:var(--avia-control-bar-btn-border-outline);cursor:var(--avia-control-bar-btn-border-cursor);pointer-events:all}avia-button:hover{color:var(--avia-control-bar-btn-text-color-hover)}avia-button[disabled]{cursor:var(--avia-control-bar-btn-disabled-cursor);opacity:var(--avia-control-bar-btn-disabled-opacity);pointer-events:none}avia-button[icon]{padding:0;margin:0;background-position:center;background-size:var(--avia-icon-btn-bg-size);background-repeat:no-repeat;user-select:none}avia-button[compact]{width:var(--avia-compact-button-width);height:var(--avia-compact-button-height);border-radius:var(--avia-compact-button-border-radius);background-color:var(--avia-compact-button-background-color)}";
const AviaButton$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.TAP_THRESHOLD = 300;
    this.isTouch = "ontouchstart" in document.documentElement;
    this.locId = void 0;
    this.toggled = false;
    this.compact = false;
    this.icon = false;
    this.variant = false;
    this.ids = "";
    this.actions = "";
    this.localeData = void 0;
    this.label = "";
    this.labelledby = "";
    this.disabled = false;
    this.focusIndex = 0;
    this.focused = false;
  }
  onDisabledChange(disabled) {
    this.disabledEvent.emit({ disabled });
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  onClick(event) {
    if (this.isTouch || this.disabled) {
      blockEvent(event);
      return;
    }
    this.execAction();
  }
  onTouchStart(event) {
    blockEvent(event);
    this.touchStartStamp = event.timeStamp;
  }
  onTouchEnd(event) {
    if (!this.disabled && this.touchStartStamp && event.timeStamp - this.touchStartStamp <= this.TAP_THRESHOLD) {
      this.touchStartStamp = null;
      this.execAction();
    }
  }
  onFocus() {
    if (!this.element.classList.contains("focus-visible")) {
      return;
    }
    this.focused = true;
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.BUTTON });
  }
  onBlur() {
    if (!this.focused) {
      return;
    }
    this.focused = false;
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.BUTTON });
  }
  onKeyDown(event) {
    const { avia, action } = event.detail;
    const { ActionKey } = avia;
    switch (action) {
      case ActionKey.SELECT:
        this.element.click();
        blockEvent(event);
        return;
    }
  }
  getCsvValue(state, index = +this.toggled) {
    return csvToArray(state)[index];
  }
  execAction() {
    const action = this.getCsvValue(this.actions);
    if (!action) {
      return;
    }
    this.actionEvent.emit({ action });
  }
  focus(options) {
    if (this.focused) {
      return;
    }
    if ((options === null || options === void 0 ? void 0 : options.focusVisible) === true) {
      this.element.classList.add("focus-visible");
      this.element.dataset.focusVisibleAdded = "";
    }
    this.onFocus();
    this.focused = true;
    H.prototype.focus.call(this.element, options);
  }
  render() {
    var _a;
    const id = this.getCsvValue(this.ids) || this.locId;
    const ariaLabel = this.label || ((_a = this.localeData) === null || _a === void 0 ? void 0 : _a[id]);
    const attributes = {
      "aria-label": ariaLabel
    };
    if (!this.focused && ariaLabel) {
      attributes.title = ariaLabel;
    }
    if (this.labelledby) {
      attributes["aria-labelledby"] = this.labelledby;
    }
    return h(Host, Object.assign({ role: "button", tabindex: this.disabled ? -1 : this.focusIndex }, attributes));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "disabled": ["onDisabledChange"]
    };
  }
  static get style() {
    return aviaButtonCss;
  }
};
openWormhole(AviaButton$1, ["localeData"]);
const aviaControlBarCss = 'avia-control-bar{box-sizing:border-box;width:100%;padding:0 var(--avia-default-spacing);background:var(--avia-control-bar-bg);display:none;transition:var(--avia-active-transition-in);padding-bottom:auto;pointer-events:auto}avia-ui[control-mode="content"] avia-control-bar{display:block}avia-ui:not([active]) avia-control-bar{opacity:0;transition:var(--avia-active-transition-out)}.avia-control-container{display:flex;justify-content:space-between;align-items:center;height:calc(var(--avia-control-bar-btn-height) + 6px);flex-wrap:nowrap}avia-control-bar.avia-layout-c-30 .avia-control-group-left,avia-control-bar.avia-layout-c-30 .avia-control-group-right{width:35%}avia-control-bar.avia-layout-c-30 .avia-control-group-center{width:30%}avia-control-bar.avia-layout-c-40 .avia-control-group-left,avia-control-bar.avia-layout-c-40 .avia-control-group-right{width:30%}avia-control-bar.avia-layout-c-40 .avia-control-group-center{width:40%}avia-control-bar.avia-layout-c-50 .avia-control-group-left,avia-control-bar.avia-layout-c-50 .avia-control-group-right{width:25%}avia-control-bar.avia-layout-c-50 .avia-control-group-center{width:50%}avia-control-bar.avia-layout-c-60 .avia-control-group-left,avia-control-bar.avia-layout-c-60 .avia-control-group-right{width:20%}avia-control-bar.avia-layout-c-60 .avia-control-group-center{width:60%}avia-control-bar.avia-layout-c-70 .avia-control-group-left,avia-control-bar.avia-layout-c-70 .avia-control-group-right{width:15%}avia-control-bar.avia-layout-c-70 .avia-control-group-center{width:70%}avia-control-bar[avia-layout=default] .avia-control-group-left,avia-control-bar[avia-layout=default] .avia-control-group-right{display:flex;flex-basis:auto}avia-control-bar[avia-layout=default] .avia-control-group-left{flex-grow:1}.avia-control-container-top{min-height:var(--avia-slider-handle-height)}.avia-control-group-left,.avia-control-group-right,.avia-control-group-center,.avia-control-group-left>*,.avia-control-group-right>*,.avia-control-group-center>*{display:flex;flex-basis:auto;align-items:center}.avia-control-group-center>*{flex-grow:1;justify-content:space-evenly}.avia-control-group-right,.avia-control-group-right>*{justify-content:flex-end}.avia-control-group-left>*{justify-content:flex-start}.avia-control-group-left>*>*{margin-right:var(--avia-half-spacing)}.avia-control-group-right>*>*{margin-left:var(--avia-half-spacing)}.avia-control-group-right avia-current-time{text-align:right}.avia-control-group-right avia-duration{text-align:right}avia-control-bar avia-progress-bar{position:relative;top:2px}.avia-control-group-left>*:empty,.avia-control-group-right>*:empty,.avia-control-group-center>*:empty{display:none}.avia-control-group-top{display:flex}.avia-control-group-top-left{flex-grow:1}';
const AviaControlBar$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.active = false;
    this.controlMode = ControlMode.NONE;
    this.deviceMode = DeviceMode.DESKTOP;
    this.isLts = false;
    this.isLiveLinear = false;
    this.isIosNative = false;
    this.settings = null;
  }
  getHeight() {
    return __async(this, null, function* () {
      return this.element.getBoundingClientRect().height;
    });
  }
  render() {
    var _a, _b;
    const isDesktop = this.deviceMode === DeviceMode.DESKTOP;
    const isTv = this.deviceMode === DeviceMode.TV;
    const hasSettings = ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.languageEnabled) || ((_b = this.settings) === null || _b === void 0 ? void 0 : _b.qualityEnabled);
    return h(Host, { role: "menu" }, h("div", { class: "avia-control-container-top" }, h("slot", { name: "top" }, h("div", null, isTv ? h("avia-control-group", { orientation: Orientation.HORIZONTAL, class: "avia-control-group-top" }, h("div", { class: "avia-control-group-top-left" }, this.isLiveLinear ? h("avia-live-control", null) : ""), h("div", { class: "avia-control-group-top-right" }, h("avia-text-toggle", null), h("avia-settings-toggle", null))) : "", !this.isLiveLinear ? h("avia-progress-bar", null) : ""))), h("avia-control-group", { orientation: Orientation.HORIZONTAL, class: "avia-control-container" }, h("div", { class: "avia-control-group-left" }, h("slot", { name: "left" }, h("div", { class: "avia-control-group-left" }, !isTv ? h("avia-play-toggle", null) : "", !isTv ? h("avia-mute-toggle", null) : "", isDesktop ? h("avia-volume-slider", null) : "", isTv && !this.isLiveLinear ? h("avia-current-time", null) : ""))), h("div", { class: "avia-control-group-center" }, h("slot", { name: "center" })), h("div", { class: "avia-control-group-right" }, h("slot", { name: "right" }, h("div", { class: "avia-control-group-right" }, !isTv ? h(Fragment, null, h("avia-time-display", null), this.isLiveLinear || this.isLts ? h("avia-live-control", null) : "", !this.isIosNative ? h("avia-text-toggle", null) : "", !this.isIosNative ? h("avia-settings-toggle", { disabled: !hasSettings }) : "", h("avia-fullscreen-toggle", null)) : "", isTv && !this.isLiveLinear ? h("avia-time-remaining", null) : "")))), h("div", { class: "avia-control-container-bottom" }, h("slot", { name: "bottom" })));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaControlBarCss;
  }
};
openWormhole(AviaControlBar$1, [
  "active",
  "controlMode",
  "deviceMode",
  "isLts",
  "isIosNative",
  "isLiveLinear",
  "settings"
]);
const aviaControlBarCompactCss = 'avia-control-bar-compact{display:none;position:absolute;top:50%;left:50%;width:var(--avia-compact-control-bar-width);height:var(--avia-compact-button-height);border-radius:var(--avia-compact-button-border-radius);margin-left:var(--avia-compact-control-bar-margin-left);margin-top:var(--avia-compact-control-bar-margin-top)}avia-ui[control-mode="compact"][active] avia-control-bar-compact{display:flex;flex-direction:row;align-items:center;justify-content:space-between}';
const AviaControlBarCompact$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("avia-mute-toggle", { compact: true }), h("avia-play-toggle", { compact: true }), h("avia-fullscreen-toggle", { compact: true }));
  }
  static get style() {
    return aviaControlBarCompactCss;
  }
};
const aviaControlGroupCss = "";
const AviaControlGroup$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.orientation = Orientation.HORIZONTAL;
  }
  render() {
    const role = this.orientation === Orientation.VERTICAL ? "menu" : "menubar";
    return h(Host, { role });
  }
  static get style() {
    return aviaControlGroupCss;
  }
};
const aviaCurrentTimeCss = "avia-current-time{user-select:none;height:var(--avia-time-height);line-height:var(--avia-time-line-height);font-size:var(--avia-time-font-size);color:var(--avia-time-color);font-family:var(--avia-time-font-family)}";
const AviaCurrentTime$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.currentTimeSeconds = void 0;
    this.localeData = void 0;
  }
  render() {
    const time = this.currentTimeSeconds || 0;
    const label = this.localeData ? createLocalizedTimeString(time, this.localeData) : "";
    return h(Host, { "aria-label": label, title: label }, secToHms(time));
  }
  static get style() {
    return aviaCurrentTimeCss;
  }
};
openWormhole(AviaCurrentTime$1, [
  "currentTimeSeconds",
  "localeData"
]);
const aviaDurationCss = "avia-duration{user-select:none;height:var(--avia-time-height);line-height:var(--avia-time-line-height);font-size:var(--avia-time-font-size);color:var(--avia-time-color);font-family:var(--avia-time-font-family)}";
const AviaDuration$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.durationSeconds = void 0;
    this.localeData = void 0;
  }
  render() {
    const time = this.durationSeconds || 0;
    const label = this.localeData ? createLocalizedTimeString(time, this.localeData) : "";
    return h(Host, { "aria-label": label, title: label }, secToHms(this.durationSeconds || 0));
  }
  static get style() {
    return aviaDurationCss;
  }
};
openWormhole(AviaDuration$1, [
  "durationSeconds",
  "localeData"
]);
const aviaFullscreenToggleCss = "avia-fullscreen-toggle avia-button{background-image:var(--avia-fs-icon)}avia-fullscreen-toggle avia-button:hover{background-image:var(--avia-fs-icon-hover)}avia-fullscreen-toggle avia-button[toggled]{background-image:var(--avia-fs-exit-icon)}avia-fullscreen-toggle avia-button[toggled]:hover{background-image:var(--avia-fs-exit-icon-hover)}";
const AviaFullscreenToggle$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.fullscreen = false;
    this.fullscreenDisabled = true;
    this.compact = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    return h("avia-button", { ref: (element) => this.focusElement = element, ids: `${LocalizationId.FULL_SCREEN_ENTER}, ${LocalizationId.FULL_SCREEN_EXIT}`, actions: `${Action.ENTER_FULLSCREEN}, ${Action.EXIT_FULLSCREEN}`, focusIndex: this.focusIndex, label: this.label, labelledby: this.labelledby, disabled: this.disabled || this.fullscreenDisabled, toggled: this.fullscreen, compact: this.compact, icon: true });
  }
  static get style() {
    return aviaFullscreenToggleCss;
  }
};
openWormhole(AviaFullscreenToggle$1, ["fullscreen", "fullscreenDisabled"]);
const aviaLiveControlCss = "avia-live-control{margin-right:var(--avia-default-spacing)}avia-live-control avia-button{width:auto;height:auto !important;font-size:0.9em;text-align:right;overflow:hidden}avia-live-control avia-button[disabled]{opacity:1;cursor:default}avia-live-control avia-button::before,avia-live-control avia-button[disabled]::before{content:'• ';color:red;font-size:0.9em}";
const AviaLiveControl$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.isLiveLinear = false;
    this.isLts = false;
    this.live = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    if (!(this.isLiveLinear || this.isLts)) {
      return;
    }
    const isLive = this.live || this.isLiveLinear;
    const locId = isLive ? LocalizationId.LIVE : LocalizationId.GO_LIVE;
    return h("avia-button", { ref: (element) => this.focusElement = element, actions: `${Action.NONE}, ${Action.GO_TO_LIVE}`, toggled: !this.live, focusIndex: this.focusIndex, label: this.label, labelledby: this.labelledby, disabled: this.disabled || isLive }, h("avia-text", { "loc-id": locId }));
  }
  static get style() {
    return aviaLiveControlCss;
  }
};
openWormhole(AviaLiveControl$1, ["isLiveLinear", "live", "isLts"]);
const aviaMenuCss = "avia-menu{display:flex;flex-direction:column;font-size:0.95em;width:100%}.avia-menu-titlebar{padding-left:1em;color:var(--avia-accent-color);font-size:0.9em;font-weight:bold;height:2em;line-height:2em;background-color:black;border-bottom:1px solid #444}.avia-menu-content{scrollbar-width:thin;scrollbar-color:var(--avia-menu-text-color) transparent}.avia-menu-content::-webkit-scrollbar{width:8px;height:0}.avia-menu-content::-webkit-scrollbar-track{background-color:transparent}.avia-menu-content::-webkit-scrollbar-thumb{background-color:var(--avia-menu-text-color);border-radius:20px}.avia-menu-content::-webkit-scrollbar-thumb:hover{background-color:var(--avia-control-bar-btn-text-color-hover)}.avia-menu-content::-webkit-scrollbar-corner{background-color:transparent}";
var __rest = function(s, e) {
  var t = {};
  for (var p in s)
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
        t[p[i]] = s[p[i]];
    }
  return t;
};
const AviaMenu$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.localeData = void 0;
    this.hasSubmenu = false;
    this.locId = void 0;
    this.titlebar = false;
    this.options = [];
    this.disabled = false;
  }
  onDisabledChange(disabled) {
    this.disabledEvent.emit({ disabled });
  }
  onAction(event) {
    if (event.detail.action !== Action.LIST_ITEM_SELECT) {
      return;
    }
    const { key, value } = event.detail.value;
    const item = this.element.querySelector(`[data-key="${key}"][data-value="${value}"]`);
    if (item) {
      this.selectListItem(item);
    }
  }
  onKeydown(event) {
    var _a;
    if (this.disabled) {
      return;
    }
    const { avia, action } = event.detail;
    const { ActionKey } = avia;
    switch (action) {
      case ActionKey.RIGHT:
        if (!this.hasSubmenu) {
          return;
        }
        (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.click();
        break;
    }
  }
  selectListItem(element) {
    const selected = this.element.querySelector("[selected]");
    if (selected) {
      selected.selected = false;
      selected.disabled = false;
    }
    element.selected = true;
  }
  createDataAttributes(data) {
    return Object.entries(data).reduce((acc, entry) => {
      acc[`data-${entry[0]}`] = entry[1];
      return acc;
    }, {});
  }
  onFocusIn(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.MENU });
  }
  onFocusOut(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.MENU });
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => {
        var _a;
        return (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
      }, { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    var _a;
    const label = (_a = this.localeData) === null || _a === void 0 ? void 0 : _a[this.locId];
    const action = this.hasSubmenu ? Action.MENU_ITEM_SELECT : Action.LIST_ITEM_SELECT;
    return h(Host, { "aria-label": label, role: "menu" }, this.titlebar ? h("div", { class: "avia-menu-titlebar" }, label) : "", h("div", { class: "avia-menu-content" }, this.options.map((option, index) => {
      const { value, disabled } = option, attrs = __rest(option, ["value", "disabled"]);
      return h("avia-menu-item", Object.assign({ key: index, ref: (element) => {
        if (index === 0) {
          this.focusElement = element;
        }
      } }, attrs, { hasSubmenu: this.hasSubmenu, disabled: this.disabled || disabled, action }, this.createDataAttributes(value)));
    })));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "disabled": ["onDisabledChange"]
    };
  }
  static get style() {
    return aviaMenuCss;
  }
};
openWormhole(AviaMenu$1, [
  "localeData"
]);
const aviaMenuItemCss = "avia-menu-item{display:block;width:100%;height:auto;border:none;outline:none;text-align:left;color:var(--avia-menu-text-color);background-color:transparent;background-position:right center;background-repeat:no-repeat;background-size:20% 20%;margin:0}avia-menu-item:hover{color:var(--avia-menu-text-color-hover);background-color:rgba(0, 0, 0, 0.65)}avia-menu-item[aria-haspopup=true]{background-image:var(--avia-chevron-right)}avia-menu-item[disabled]{cursor:default;opacity:0.55}avia-menu-item[disabled]:hover{background-color:transparent;color:var(--avia-menu-text-color)}avia-menu-item button{border:none;outline:none;width:100%;height:100%;padding:1em;margin:0;color:var(--avia-menu-text-color);background-color:transparent;text-align:left;cursor:pointer;font-size:var(--avia-menu-text-size)}avia-menu-item button:focus-visible,avia-menu-item button.focus-visible{outline:none;box-shadow:var(--avia-focus-box-shadow-inner)}avia-menu-item button[aria-haspopup=true]{background-image:var(--avia-chevron-right);background-position:right center;background-repeat:no-repeat;background-size:20% 20%}avia-menu-item[data-description] button:after{content:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAVCAYAAABc6S4mAAACG0lEQVQ4jZ2Vz0tVQRTHP89QKJ9lm6ikzN6zJAlxJ1E8CJO27oo2IdKmRdBWwRZhkH9A4kJoI7ppIUWkibRsERpILpQCF9lPLPpBQc+vTJ0Lh+lduc8Dw8z9zJlz5sw5MzcniR1IAegDDgJrwCjwvqKZ4CBDa5VUkrTf6YbNnZc0JemHpHFJtbGtrBF0AOeAI8AxYAp44OYvAo+BT0AJeFVtBEnbI2lI/+RZtOPDxsuSmnwEd4FG4E+06xxQa2c8DSy6uSKwYufeBnwxfgGYAZaBU0kEWeWJpONux822bjWK8qHx63+PX9J6FU5+SWp3xm4av+PYSWMh8XXhiNat3IIMA5+BGqAM1ANX7BgSCfotwG/T+wrkgV3AptMJNrviCNKSOxlF0ufm7hu77NiIsVs1UWJbUsr0EvDBffe48YL1JcdeW98bO9hO5lI28tb63Y6VrS9U48Dn4Z0b563fdCyX6MUONlKMXwU63fdzNy5Y/8axpGgexUnukLRPUqOkvZKKkgYqlOtRl9AlY82OLRvrjh38lPTdavhbyl245gy1G1t07IDTzWNvR1a5EZXviq1rdeyesZHkJr+QtLZNeylpzG6oNz5R4U4UjYXo6xIH1bYGSfNmqD9a+9H42YRlNV4v6bSkQUkLkp5KanPzh5zxXr82i/HwXoX3vdsS3Bm9qLetKEI1ndjpHy2W8P84Y09GEzAGzP6nBWwBc7kMbCgO6BoAAAAASUVORK5CYII=');left:0.4em;top:0.25em;position:relative}avia-menu-item[selected] button{font-weight:bold;cursor:default;background-position:94% center;background-repeat:no-repeat;background-size:0.9em;background-image:var(--avia-selected-icon);pointer-events:none}";
const AviaMenuItem$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.disabled = false;
    this.selected = false;
    this.label = "";
    this.action = "";
    this.hasSubmenu = false;
  }
  onDisabledChange(disabled) {
    this.disabledEvent.emit({ disabled });
  }
  onClick(event) {
    if (this.disabled || this.selected) {
      return;
    }
    blockEvent(event);
    this.actionEvent.emit({
      action: this.action,
      value: this.element.dataset
    });
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  onKeyDown(event) {
    const { avia, action } = event.detail;
    const { ActionKey } = avia;
    switch (action) {
      case ActionKey.SELECT:
        this.element.click();
        blockEvent(event);
        return;
    }
  }
  render() {
    return h(Host, null, h("button", { ref: (element) => this.focusElement = element, role: this.hasSubmenu ? "menuitem" : "menuitemradio", "aria-haspopup": String(this.hasSubmenu), "aria-checked": String(this.selected), disabled: this.disabled }, h("label", null, this.label), h("slot", null)));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "disabled": ["onDisabledChange"]
    };
  }
  static get style() {
    return aviaMenuItemCss;
  }
};
const aviaMuteToggleCss = "avia-mute-toggle avia-button{background-image:var(--avia-unmuted-icon)}avia-mute-toggle avia-button:hover{background-image:var(--avia-unmuted-icon-hover)}avia-mute-toggle avia-button[toggled]{background-image:var(--avia-mute-icon)}avia-mute-toggle avia-button[toggled]:hover{background-image:var(--avia-mute-icon-hover)}";
const AviaMuteToggle$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.muted = false;
    this.muteDisabled = true;
    this.compact = false;
    this.label = "";
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    return h("avia-button", { ref: (element) => this.focusElement = element, ids: `${LocalizationId.MUTE}, ${LocalizationId.UNMUTE}`, actions: `${Action.MUTE}, ${Action.UNMUTE}`, toggled: this.muted, focusIndex: this.focusIndex, disabled: this.disabled || this.muteDisabled, label: this.label, labelledby: this.labelledby, compact: this.compact, icon: true });
  }
  static get style() {
    return aviaMuteToggleCss;
  }
};
openWormhole(AviaMuteToggle$1, ["muted", "muteDisabled"]);
const aviaOverlayCss = "avia-overlay{background:transparent;position:absolute;width:100%;height:100%;top:0;left:0;border:none;padding:0;margin:0}avia-overlay[centered]{justify-content:center;align-items:center;display:flex}";
const AviaOverlay$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.centered = false;
  }
  render() {
    return h(Host, { centered: this.centered });
  }
  static get style() {
    return aviaOverlayCss;
  }
};
const aviaPanelCss = "avia-panel{width:100%;height:100%}.avia-panel-titlebar{padding:0.5em 0.25em 0.5em 0.75em;color:var(--avia-accent-color);background-color:black;border-bottom:1px solid #444;display:flex;align-items:center;justify-content:center;font-weight:bold}.avia-panel-close-button{width:1.75em;height:2em;background-image:var(--avia-x-symbol);background-repeat:no-repeat;padding:0px}.avia-panel-back-button{width:1.75em;height:1.75em;background-image:var(--avia-chevron-right);background-repeat:no-repeat;background-size:47.5% 47.5%;transform:rotate(180deg);margin-right:1em}.avia-panel-content{display:flex;flex-direction:row;overflow:hidden}.avia-panel-content>div{width:180px;color:var(--avia-menu-text-color)}.avia-panel-content>div:first-child{border-right:1px solid #888}.avia-panel-content>div:only-child{border-right:none}";
const AviaPanel$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.localeData = void 0;
    this.titlebar = true;
    this.back = false;
    this.locId = void 0;
  }
  render() {
    var _a;
    const label = (_a = this.localeData) === null || _a === void 0 ? void 0 : _a[this.locId];
    return h("avia-control-group", { orientation: Orientation.VERTICAL }, this.titlebar ? h("avia-control-group", { class: "avia-panel-titlebar", orientation: Orientation.HORIZONTAL }, this.back ? h("avia-button", { "loc-id": LocalizationId.BACK, class: "avia-panel-back-button", disabled: false, actions: Action.PANEL_BACK, icon: true }) : "", h("span", null, label), h("span", { class: "avia-spacer" }), h("avia-button", { "loc-id": LocalizationId.CLOSE, class: "avia-panel-close-button", disabled: false, actions: Action.PANEL_CLOSE, icon: true })) : "", h("div", { class: "avia-panel-content" }, h("slot", null)));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaPanelCss;
  }
};
openWormhole(AviaPanel$1, [
  "localeData"
]);
const aviaPauseOverlayCss = ":root{--avia-pause-large-width:66px;--avia-pause-large-height:66px;--avia-pause-large-border-radius:calc(var(--avia-pause-large-width) / 2);--avia-pause-large-bg-image:var(--avia-pause-icon);--avia-pause-large-bg-position:50%;--avia-pause-large-bg-color:rgba(64, 64, 64, 0.5);--avia-pause-large-bg-size:calc(var(--avia-pause-large-width) / 2) calc(var(--avia-pause-large-height) / 2)}avia-pause-overlay div{width:var(--avia-pause-large-width);height:var(--avia-pause-large-height);background-image:var(--avia-pause-large-bg-image);background-repeat:no-repeat;background-position-x:calc(var(--avia-pause-large-bg-position) + 6%);background-position-y:var(--avia-pause-large-bg-position);background-size:var(--avia-pause-large-bg-size)}";
const AviaPauseOverlay$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.started = false;
    this.playing = false;
    this.waiting = false;
  }
  render() {
    if (!this.started || this.waiting || this.playing) {
      this.started = true;
      return;
    }
    return h("avia-overlay", { centered: true }, h("div", null));
  }
  static get style() {
    return aviaPauseOverlayCss;
  }
};
openWormhole(AviaPauseOverlay$1, [
  "playing",
  "waiting"
]);
const aviaPlayCtaCss = "avia-play-cta avia-button{width:var(--avia-play-cta-width);height:var(--avia-play-cta-height);border-radius:var(--avia-play-cta-border-radius);background-image:var(--avia-play-cta-bg-image);background-color:var(--avia-play-cta-bg-color);background-repeat:no-repeat;background-position-x:calc(var(--avia-play-cta-bg-position) + 6%);background-position-y:var(--avia-play-cta-bg-position);background-size:var(--avia-play-cta-bg-size);cursor:pointer}";
const AviaPlayCta$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    return h("avia-button", { ref: (element) => this.focusElement = element, focusIndex: this.focusIndex, disabled: this.disabled, label: this.label, labelledby: this.labelledby, actions: Action.PLAY, "loc-id": LocalizationId.PLAY });
  }
  static get style() {
    return aviaPlayCtaCss;
  }
};
const aviaPlayOverlayCss = "avia-play-overlay{background-color:var(--avia-play-overlay-bg-color)}avia-play-overlay.focus-visible avia-play-cta{box-shadow:var(--avia-focus-box-shadow-inner)}";
const AviaPlayOverlay$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.playing = false;
    this.controlMode = ControlMode.NONE;
    this.playDisabled = true;
    this.pausable = true;
    this.isTouch = false;
    this.focusIndex = 0;
  }
  onClick() {
    const action = this.playing ? Action.PAUSE : Action.PLAY;
    this.actionEvent.emit({ action });
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    const paused = !this.playing;
    const noTouch = !paused && this.isTouch;
    if (noTouch || this.playDisabled || !this.pausable || this.controlMode !== ControlMode.CONTENT) {
      return;
    }
    return h("avia-overlay", { centered: true }, paused ? h("avia-play-cta", { ref: (element) => this.focusElement = element }) : "");
  }
  static get style() {
    return aviaPlayOverlayCss;
  }
};
openWormhole(AviaPlayOverlay$1, [
  "controlMode",
  "isTouch",
  "pausable",
  "playDisabled",
  "playing"
]);
const aviaPlayToggleCss = "avia-play-toggle avia-button{background-image:var(--avia-play-icon)}avia-play-toggle avia-button:hover{background-image:var(--avia-play-icon-hover)}avia-play-toggle avia-button[toggled]{background-image:var(--avia-pause-icon)}avia-play-toggle avia-button[toggled]:hover{background-image:var(--avia-pause-icon-hover)}avia-play-toggle avia-button[toggled][variant]{background-image:var(--avia-stop-icon)}avia-play-toggle avia-button[toggled][variant]:hover{background-image:var(--avia-stop-icon-hover)}";
const AviaPlayToggle$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.playing = false;
    this.playDisabled = true;
    this.pausable = void 0;
    this.compact = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    const paused = !this.playing;
    const ids = [LocalizationId.PLAY, this.pausable ? LocalizationId.PAUSE : LocalizationId.STOP];
    const actions = [Action.PLAY, this.pausable ? Action.PAUSE : Action.STOP];
    const locId = paused ? this.pausable ? LocalizationId.PAUSE : LocalizationId.STOP : LocalizationId.PLAY;
    return h("avia-button", { ref: (element) => this.focusElement = element, ids: ids.join(","), actions: actions.join(","), focusIndex: this.focusIndex, disabled: this.disabled || this.playDisabled, label: this.label, labelledby: this.labelledby, "loc-id": locId, toggled: this.playing, compact: this.compact, variant: !this.pausable, icon: true });
  }
  static get style() {
    return aviaPlayToggleCss;
  }
};
openWormhole(AviaPlayToggle$1, ["playing", "playDisabled", "pausable"]);
const aviaPosterCss = "avia-poster img{width:100%;height:auto}";
const AviaPoster$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.canceled = false;
    this.posterActive = false;
    this.posterImageUrl = void 0;
    this.playing = false;
    this.waiting = false;
  }
  playingStateWatcher() {
    this.canceled = true;
  }
  waitingStateWatcher() {
    this.canceled = true;
  }
  handleAction(event) {
    this.canceled = true;
    this.actionEvent.emit({ action: Action.POSTER_PLAY });
    blockEvent(event, true);
  }
  render() {
    if (this.canceled || !this.posterActive) {
      return "";
    }
    return h("avia-overlay", null, !isEmpty(this.posterImageUrl) ? h("img", { src: this.posterImageUrl, alt: "" }) : "", h("div", { class: "" }, h("slot", null)), h("avia-overlay", { centered: true }, h("avia-play-cta", null)));
  }
  static get watchers() {
    return {
      "playing": ["playingStateWatcher"],
      "waiting": ["waitingStateWatcher"]
    };
  }
  static get style() {
    return aviaPosterCss;
  }
};
openWormhole(AviaPoster$1, [
  "playing",
  "posterActive",
  "posterImageUrl",
  "waiting"
]);
const aviaProgressBarCss = ":root{--avia-progress-preview-height:24px;--avia-progress-preview-width:50px;--avia-progress-preview-line-height:24px;--avia-progress-preview-top:-34px;--avia-progress-preview-bg-color:rgba(44, 44, 44, 0.7);--avia-progress-preview-color:rgb(220, 220, 220);--avia-progress-preview-font-size:13px;--avia-progress-preview-border-radius:4px}avia-progress-bar .avia-slider-range-item{background-color:var(--avia-buffered-range-background-color)}avia-progress-bar.focus-visible{outline:none}.avia-progress-preview{position:absolute;line-height:var(--avia-progress-preview-line-height);background:var(--avia-progress-preview-bg-color);color:var(--avia-progress-preview-color);font-size:var(--avia-progress-preview-font-size);text-align:center;border-radius:var(--avia-progress-preview-border-radius);user-select:none;overflow:hidden;bottom:1em;margin-bottom:calc(var(--avia-slider-handle-height) / 2)}.avia-progress-text{padding:0 0.5em 0 0.5em;white-space:nowrap}";
const AviaProgressBar$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.actionEvent = createEvent(this, "action", 7);
    this.updateEvent = createEvent(this, "update", 7);
    this.engagedEvent = createEvent(this, "engaged", 7);
    this.hoverDelay = 250;
    this.engaged = false;
    this.imgElement = document.createElement("img");
    this.dragging = false;
    this.bufferedRanges = void 0;
    this.currentTimeSeconds = void 0;
    this.durationSeconds = void 0;
    this.live = false;
    this.localeData = void 0;
    this.options = void 0;
    this.segmentBreakPositions = void 0;
    this.preview = void 0;
    this.increment = 15;
    this.progressMode = null;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
    this.hovering = false;
    this.cursor = 0;
    this.value = 0;
  }
  focus(options) {
    const focus = () => {
      this.focusElement.focus(options);
    };
    if (this.focusElement) {
      focus();
    } else {
      this.element.addEventListener("ready", focus, { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  showPreview(time) {
    return __async(this, null, function* () {
      if (isNaN(time)) {
        this.triggerEngaged(false);
        this.onCurrentTimeSeconds();
        return;
      }
      this.focus();
      this.value = time;
    });
  }
  hidePreview() {
    return __async(this, null, function* () {
      if (this.engaged) {
        this.triggerEngaged(false);
        this.onCurrentTimeSeconds();
      }
    });
  }
  onCurrentTimeSeconds() {
    if (this.cursorActive || this.engaged) {
      return;
    }
    this.value = this.live ? this.durationSeconds : this.currentTimeSeconds;
  }
  onMouseEnter(event) {
    if (this.engaged) {
      return;
    }
    clearTimeout(this.hoverTimeoutHandle);
    this.hoverTimeoutHandle = setTimeout(() => {
      this.hovering = true;
      this.onMouseMove(event);
    }, this.hoverDelay);
  }
  onMouseLeave() {
    clearTimeout(this.hoverTimeoutHandle);
    this.hovering = false;
  }
  onMouseMove(event) {
    if (!this.mouseActive) {
      return;
    }
    const offset = this.sliderElement.getBoundingClientRect();
    const pos = getEventPos(event).x - offset.left;
    const percent = clampValue(pos / offset.width, 0, 1);
    this.cursor = percent;
    this.actionEvent.emit({ action: Action.PREVIEW, value: { time: percent * this.durationSeconds, percent } });
  }
  onKeydown(event) {
    if (this.progressMode !== ProgressMode.CURSOR) {
      return;
    }
    const engage = (engaged) => {
      blockEvent(event);
      this.triggerEngaged(engaged);
    };
    const { action, avia } = event.detail;
    const { ActionKey } = avia;
    switch (action) {
      case ActionKey.LEFT:
      case ActionKey.RIGHT:
        engage(true);
        break;
      case ActionKey.SELECT:
        if (!this.engaged) {
          return;
        }
        engage(false);
        this.value = this.sliderElement.value;
        this.actionEvent.emit({ action: Action.SEEK, value: this.sliderElement.value });
        break;
      case ActionKey.CANCEL:
        if (!this.engaged) {
          return;
        }
        engage(false);
        this.resetCursor();
        this.sliderElement.value = this.value;
        break;
    }
  }
  get active() {
    return this.mouseActive || this.previewActive || this.cursorActive;
  }
  get cursorActive() {
    return this.progressMode === ProgressMode.CURSOR && this.engaged;
  }
  get previewActive() {
    return this.mouseActive || this.engaged;
  }
  get mouseActive() {
    return this.hovering || this.dragging;
  }
  onChange(event) {
    if (this.progressMode === ProgressMode.CURSOR) {
      return;
    }
    this.actionEvent.emit({ action: Action.SEEK, value: event.detail.value });
  }
  onDragging(event) {
    this.dragging = event.detail.value;
  }
  onFocus() {
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.SEEK });
  }
  onBlur() {
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.SEEK });
    this.resetCursor();
    this.triggerEngaged(false);
  }
  onClick() {
    if (this.progressMode !== ProgressMode.CURSOR) {
      return;
    }
    const value = this.cursor * this.durationSeconds;
    this.value = value;
    this.actionEvent.emit({ action: Action.SEEK, value });
  }
  onUpdate(event) {
    if (!this.engaged || this.dragging || this.hovering) {
      return;
    }
    const { percent } = event.detail;
    this.cursor = percent;
    this.actionEvent.emit({ action: Action.PREVIEW, value: { time: percent * this.durationSeconds, percent } });
  }
  hasPreview() {
    var _a, _b;
    return !!((_b = (_a = this.preview) === null || _a === void 0 ? void 0 : _a.thumbs) === null || _b === void 0 ? void 0 : _b.length);
  }
  resetCursor() {
    this.cursor = this.value / this.sliderElement.max;
  }
  triggerEngaged(engaged) {
    if (this.engaged === engaged) {
      return;
    }
    this.engaged = engaged;
    const action = engaged ? Action.ENTER_CONTEXT : Action.EXIT_CONTEXT;
    this.actionEvent.emit({ action, value: ActionKeyContext.SLIDER_ENGAGED });
    this.engagedEvent.emit({ value: engaged, engaged });
    this.actionEvent.emit({ action: Action.LOCK_ACTIVE, value: { locked: engaged } });
    this.actionEvent.emit({ action: Action.PREVIEW, value: { time: this.value, percent: this.value / this.durationSeconds } });
  }
  componentWillLoad() {
    var _a, _b;
    (_a = this.progressMode) !== null && _a !== void 0 ? _a : this.progressMode = ((_b = this.options) === null || _b === void 0 ? void 0 : _b.progressMode) || ProgressMode.VALUE;
  }
  componentDidRender() {
    const slider = this.sliderElement;
    const parentWidth = slider.offsetWidth;
    if (this.hasPreview()) {
      const thumbnailWidth = parentWidth * this.preview.thumbnailScaleFactor;
      const img = this.imgElement;
      const thumb = this.preview.thumbs.reduce((acc, thumb2) => {
        if (!acc) {
          return thumb2;
        }
        const current = Math.abs(thumbnailWidth - acc.width);
        const target = Math.abs(thumbnailWidth - thumb2.width);
        if (current > target) {
          return thumb2;
        }
        return acc;
      }, null);
      const draw = () => {
        const canvas = this.canvasElement;
        const scale = Math.min(thumbnailWidth / thumb.width, 1);
        const context = canvas.getContext("2d");
        const width = thumb.width * scale;
        const height = thumb.height * scale;
        canvas.width = width;
        canvas.height = height;
        context.drawImage(img, thumb.x, thumb.y, thumb.width, thumb.height, 0, 0, width, height);
      };
      if (thumb) {
        if (img.src !== thumb.url) {
          img.src = thumb.url;
          img.onload = draw;
        } else {
          draw();
        }
      }
    }
    const preview = this.previewElement;
    const margin = preview.offsetWidth / 2;
    const max = parentWidth - margin;
    const pos = this.cursor * parentWidth;
    const offset = pos < margin ? margin - pos : pos > max ? max - pos : 0;
    preview.style.marginLeft = `${offset - margin}px`;
  }
  render() {
    var _a;
    const list = csvToArray(this.segmentBreakPositions).map((i) => ({ value: parseFloat(i) }));
    const attributes = {};
    if (!(this.label || this.labelledby) && this.localeData) {
      attributes["aria-valuetext"] = valueOfTotal(Math.round(this.value), Math.round(this.durationSeconds), this.localeData);
    }
    return h("avia-slider", Object.assign({ ref: (e) => this.focusElement = this.sliderElement = e, "loc-id": LocalizationId.SEEK, list, value: this.value, max: this.durationSeconds, ranges: this.bufferedRanges, increment: this.increment, onChange: (event) => this.onChange(event), onDragging: (event) => this.onDragging(event), onUpdate: (event) => this.onUpdate(event), onFocus: () => this.onFocus(), onBlur: () => this.onBlur(), onClick: () => this.onClick(), focusIndex: this.focusIndex, disabled: this.disabled, label: this.label, labelledby: this.labelledby }, attributes), h("div", { ref: (e) => this.previewElement = e, class: "avia-progress-preview", style: {
      visibility: this.active ? "visible" : "hidden",
      left: toCssPercent(this.cursor)
    } }, h("canvas", { ref: (e) => this.canvasElement = e, class: "avia-progress-img", style: { display: this.hasPreview() && this.imgElement.complete ? "block" : "none" } }), h("div", { ref: (e) => this.textElement = e, class: "avia-progress-text" }, (_a = this.preview) === null || _a === void 0 ? void 0 : _a.value)), h("slot", { name: "handle" }));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "currentTimeSeconds": ["onCurrentTimeSeconds"],
      "live": ["onCurrentTimeSeconds"]
    };
  }
  static get style() {
    return aviaProgressBarCss;
  }
};
openWormhole(AviaProgressBar$1, [
  "bufferedRanges",
  "currentTimeSeconds",
  "cursorPosition",
  "durationSeconds",
  "live",
  "localeData",
  "options",
  "preview",
  "segmentBreakPositions"
]);
const aviaScrubIndicatorCss = `avia-scrub-indicator{position:absolute;display:inline-block;box-sizing:border-box;border-radius:var(--avia-seek-indicator-border-radius);background-color:var(--avia-seek-indicator-background-color);color:var(--avia-seek-indicator-color);height:var(--avia-seek-indicator-height);font-size:var(--avia-seek-indicator-font-size);font-family:var(--avia-seek-indicator-font-family);line-height:var(--avia-seek-indicator-line-height);top:calc(50% - 24px)}avia-scrub-indicator.avia-acc-fwd{right:12px;padding-left:48px;padding-right:12px;text-align:right}avia-scrub-indicator.avia-acc-back{left:12px;padding-right:48px;padding-left:12px}avia-scrub-indicator .avia-acc-arrow{width:24px;height:18px;position:absolute;top:calc(50% - 9px);background-image:url("data:image/svg+xml,%3Csvg viewBox='0 -256 512 512' version='1.1' width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3E%3Cg transform='matrix(0.31427155,0,0,-0.31427155,-24.298031,281.39149)'%3E%3Cpath d='m 181.67796,150.76271 q -19,-19 -32,-13 -12.99999,6 -12.99999,32 V 1641.7627 q 0,26 12.99999,32 13,6 32,-13 l 710,-709.99999 q 8,-8 13,-19 v 709.99999 q 0,26 13,32 13,6 32,-13 L 1659.678,950.76271 q 19,-19 19,-45 0,-26 -19,-45 l -710.00004,-710 q -19,-19 -32,-13 -13,6 -13,32 v 710 q -5,-10 -13,-19 z' style='fill:%23ffffff' /%3E%3C/g%3E%3C/svg%3E");background-repeat:no-repeat;background-size:24px 18px}avia-scrub-indicator.avia-acc-fwd .avia-acc-arrow{left:12px}avia-scrub-indicator.avia-acc-back .avia-acc-arrow{transform:rotate(180deg);right:12px}`;
const AviaScrubIndicator$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.accIndicatorState = void 0;
  }
  render() {
    const { seekForward, seekBack, multiplier } = this.accIndicatorState;
    if (!(seekForward || seekBack) || !multiplier) {
      return "";
    }
    return h(Host, { class: seekForward ? CssNames.ACC_FWD : CssNames.ACC_BACK }, h("span", null, multiplier, "x"), h("div", { class: "avia-acc-arrow" }));
  }
  static get style() {
    return aviaScrubIndicatorCss;
  }
};
openWormhole(AviaScrubIndicator$1, [
  "accIndicatorState"
]);
const aviaSeekBackButtonCss = "avia-seek-back-button avia-button{background-image:var(--avia-seek-back-icon)}avia-seek-back-button avia-button:hover{background-image:var(--avia-seek-back-icon-hover)}";
const AviaSeekBackButton$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.seekBackDisabled = false;
    this.isLiveLinear = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    if (this.isLiveLinear) {
      return "";
    }
    return h("avia-button", { ref: (element) => this.focusElement = element, actions: Action.SEEK_BACK, focusIndex: this.focusIndex, disabled: this.disabled || this.seekBackDisabled, label: this.label, labelledby: this.labelledby, "loc-id": LocalizationId.SEEK_BACK, icon: true });
  }
  static get style() {
    return aviaSeekBackButtonCss;
  }
};
openWormhole(AviaSeekBackButton$1, ["seekBackDisabled", "isLiveLinear"]);
const aviaSeekForwardButtonCss = "avia-seek-forward-button avia-button{background-image:var(--avia-seek-forward-icon)}avia-seek-forward-button avia-button:hover{background-image:var(--avia-seek-forward-icon-hover)}";
const AviaSeekForwardButton$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.seekForwardDisabled = false;
    this.isLiveLinear = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    if (this.isLiveLinear) {
      return "";
    }
    return h("avia-button", { ref: (element) => this.focusElement = element, actions: Action.SEEK_FORWARD, focusIndex: this.focusIndex, disabled: this.disabled || this.seekForwardDisabled, label: this.label, labelledby: this.labelledby, "loc-id": LocalizationId.SEEK_FORWARD, icon: true });
  }
  static get style() {
    return aviaSeekForwardButtonCss;
  }
};
openWormhole(AviaSeekForwardButton$1, ["seekForwardDisabled", "isLiveLinear"]);
const aviaSeekIndicatorCss = "avia-seek-indicator{position:absolute;display:inline-block;box-sizing:border-box;border-radius:var(--avia-seek-indicator-border-radius);background-color:var(--avia-seek-indicator-background-color);color:var(--avia-seek-indicator-color);height:var(--avia-seek-indicator-height);font-size:var(--avia-seek-indicator-font-size);font-family:var(--avia-seek-indicator-font-family);line-height:var(--avia-seek-indicator-line-height);top:calc(50% - 24px);opacity:0;transition-property:opacity;transition-duration:300ms;transition-timing-function:ease-in}avia-seek-indicator.avia-indicator-active{opacity:1}avia-seek-indicator:empty{opacity:0}.avia-acc-fwd{right:12px;padding-left:48px;padding-right:12px;text-align:right}.avia-acc-back{left:12px;padding-right:48px;padding-left:12px}avia-seek-indicator .avia-acc-arrow{width:24px;height:18px;position:absolute;top:calc(50% - 9px);background-image:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2017.81%2024%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22Layer_2%22%20data-name%3D%22Layer%202%22%3E%3Cg%20id%3D%22Layer_2-2%22%20data-name%3D%22Layer%202%22%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M0%2C6.55V17.79a.54.54%2C0%2C0%2C0%2C.54.54l5.15-.08a.54.54%2C0%2C0%2C1%2C.54.54v4.67a.54.54%2C0%2C0%2C0%2C.92.38l10.51-11.2a.56.56%2C0%2C0%2C0%2C0-.76L7.25.17a.54.54%2C0%2C0%2C0-.93.37V5.39a.54.54%2C0%2C0%2C1-.54.54L.54%2C6A.54.54%2C0%2C0%2C0%2C0%2C6.55Z%22%2F%3E%3C%2Fg%3E%3C%2Fg%3E%3C%2Fsvg%3E');background-repeat:no-repeat;background-size:24px 18px}.avia-acc-fwd .avia-acc-arrow{left:12px}.avia-acc-back .avia-acc-arrow{transform:rotate(180deg);right:12px}";
const AviaSeekIndicator$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.durationSeconds = void 0;
    this.accIndicatorState = void 0;
  }
  componentDidRender() {
    if (!this.debouncer && this.accIndicatorState.displayTime > 0) {
      this.debouncer = debounce(() => {
        var _a;
        (_a = this.el) === null || _a === void 0 ? void 0 : _a.classList.remove(CssNames.INDICATOR_ACTIVE);
        this.visible = false;
      }, this.accIndicatorState.displayTime);
    }
    if (this.visible) {
      setTimeout(() => this.el.classList.add(CssNames.INDICATOR_ACTIVE), 0);
      this.debouncer && this.debouncer();
    }
  }
  render() {
    const acc = this.accIndicatorState;
    if (!(acc.seekForward || acc.seekBack) || acc.multiplier) {
      this.visible = false;
      return "";
    }
    this.visible = true;
    const t = this.accIndicatorState.seekTime;
    const d = this.durationSeconds;
    const hasD = d && !isNaN(d);
    let str = "";
    if (hasD) {
      const dur = secToHms(d);
      if (!isNaN(t) && t >= 0) {
        const p = secToHms(t);
        str = p + " / " + dur;
      }
    }
    return h(Host, { class: acc.seekForward ? CssNames.ACC_FWD : CssNames.ACC_BACK }, h("span", null, str), h("div", { class: "avia-acc-arrow" }));
  }
  get el() {
    return this;
  }
  static get style() {
    return aviaSeekIndicatorCss;
  }
};
openWormhole(AviaSeekIndicator$1, ["durationSeconds", "accIndicatorState"]);
const aviaSettingsCss = ":root{--avia-chevron-right:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22white%22%3E%3Cpath%20id%3D%22Arrow_2_1%22%20d%3D%22M0%2C24L14.4%2C11.556%2C0%2C0%2C6.74%2C0%2C24%2C11.556%2C6.74%2C24Z%22%2F%3E%3C%2Fsvg%3E');--avia-x-symbol:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2012%2012%22%20width%3D%2212%22%20height%3D%2212%22%3E%3Cstyle%3Etspan%20%7B%20white-space%3Apre%20%7D%3C%2Fstyle%3E%3Cpath%20fill%3D%22%23FFF%22%20d%3D%22M0.07%202.19L2.26%200L5.91%203.65L9.56%200L11.75%202.19L8.1%205.84L11.75%209.49L9.56%2011.68L5.91%208.03L2.26%2011.68L0.07%209.49L3.72%205.84L0.07%202.19Z%22%20%2F%3E%3C%2Fsvg%3E');--avia-menu-text-color:var(--avia-text-color);--avia-menu-text-size:var(--avia-text-size);--avia-menu-text-color-hover:var(--avia-text-color-hover)}avia-settings{display:flex;align-self:flex-end;pointer-events:none;min-width:180px;height:auto;background-color:rgba(0, 0, 0, 0.65);flex-direction:column;max-height:calc(100% - 1em - var(--avia-control-bar-height));border-radius:0.25em;overflow:hidden;position:absolute;bottom:64px;right:var(--avia-default-spacing)}avia-settings>*{pointer-events:auto}.avia-settings-nudge-left avia-settings{right:calc(var(--avia-default-spacing) + 48px)}[device-mode=tv] avia-settings{bottom:118px}";
const AviaSettings$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.settings = null;
    this.localeData = null;
    this.controlMode = null;
    this.deviceMode = DeviceMode.DESKTOP;
    this.options = void 0;
    this.qualityLabel = 0;
    this.currentId = LocalizationId.SETTINGS;
    this.menu = void 0;
  }
  onMenuChange(newValue) {
    if (!newValue || !this.menu) {
      return;
    }
    this.menu.focus();
  }
  onAction(event) {
    switch (event.detail.action) {
      case Action.PANEL_BACK:
        this.currentId = LocalizationId.SETTINGS;
        break;
      case Action.PANEL_CLOSE:
        this.close();
        break;
      case Action.MENU_ITEM_SELECT:
        this.currentId = event.detail.value.action;
        break;
    }
  }
  onKeyDown(event) {
    var _a;
    if (!((_a = this.settings) === null || _a === void 0 ? void 0 : _a.active)) {
      return;
    }
    const { avia, action } = event.detail;
    const { ActionKey } = avia;
    switch (action) {
      case ActionKey.CANCEL:
        this.close();
        break;
    }
  }
  onFocusIn(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.PANEL });
  }
  onFocusOut(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.PANEL });
  }
  close() {
    return __async(this, null, function* () {
      this.actionEvent.emit({ action: Action.SETTINGS_OFF });
    });
  }
  focus(options) {
    if (this.menu) {
      this.menu.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.menu.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.menu) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    var _a, _b;
    if (!((_a = this.settings) === null || _a === void 0 ? void 0 : _a.active) || !this.localeData) {
      return;
    }
    if (this.controlMode !== ControlMode.CONTENT && ((_b = this.settings) === null || _b === void 0 ? void 0 : _b.active)) {
      this.close();
      return;
    }
    if (this.deviceMode === DeviceMode.TV) {
      return h("avia-settings-language", { ref: (element) => this.menu = element });
    }
    return h("avia-panel", { locId: this.currentId, back: this.currentId !== LocalizationId.SETTINGS }, this.getMenu());
  }
  getMenu() {
    switch (this.currentId) {
      case LocalizationId.SETTINGS:
        const options = [];
        if (this.settings.languageEnabled) {
          options.push({
            label: this.localeData[LocalizationId.LANGUAGE],
            value: { action: LocalizationId.LANGUAGE }
          });
        }
        if (this.settings.qualityEnabled) {
          options.push({
            label: this.localeData[LocalizationId.QUALITY],
            value: { action: LocalizationId.QUALITY }
          });
        }
        return h("avia-menu", { ref: (element) => this.menu = element, locId: LocalizationId.SETTINGS, key: LocalizationId.SETTINGS, options, titlebar: false, hasSubmenu: true });
      case LocalizationId.LANGUAGE:
        return h("avia-settings-language", { ref: (element) => this.menu = element, key: LocalizationId.LANGUAGE });
      case LocalizationId.QUALITY:
        return h("avia-settings-quality", { key: LocalizationId.QUALITY, ref: (element) => this.menu = element });
    }
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "menu": ["onMenuChange"]
    };
  }
  static get style() {
    return aviaSettingsCss;
  }
};
openWormhole(AviaSettings$1, [
  "controlMode",
  "deviceMode",
  "localeData",
  "options",
  "qualityLabel",
  "settings"
]);
const aviaSettingsAudioCss = "";
const AviaSettingsAudio$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.localeData = void 0;
    this.settings = void 0;
  }
  onAction(e) {
    switch (e.detail.action) {
      case Action.LIST_ITEM_SELECT:
        const { key, value } = e.detail.value;
        this.actionEvent.emit({
          action: Action.LANGUAGE_SELECT,
          value: { trackType: key, trackId: value }
        });
        break;
    }
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    const { audioTrack, audioTracks } = this.settings;
    const selected = audioTrack === null || audioTrack === void 0 ? void 0 : audioTrack.index;
    const options = audioTracks.map((track) => ({
      selected: track.index === selected,
      disabled: audioTracks.length === 1,
      label: getLangLabel(track.language) || this.localeData[LocalizationId.UNKNOWN],
      value: {
        key: "audio",
        value: track.id,
        description: track.type === "description"
      }
    }));
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
      return;
    }
    return h("avia-menu", { ref: (element) => this.focusElement = element, locId: LocalizationId.AUDIO, options, titlebar: true });
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaSettingsAudioCss;
  }
};
openWormhole(AviaSettingsAudio$1, [
  "localeData",
  "settings"
]);
const aviaSettingsLanguageCss = "avia-settings-language{display:flex;flex-direction:row}avia-menu{min-width:180px}";
const AviaSettingsLanguage$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.localeData = void 0;
    this.settings = void 0;
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    return h(Host, { role: "menubar" }, h("avia-settings-text", { ref: (element) => this.focusElement = element }), h("avia-settings-audio", null));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaSettingsLanguageCss;
  }
};
openWormhole(AviaSettingsLanguage$1, [
  "localeData",
  "settings"
]);
const aviaSettingsQualityCss = "avia-settigs-quality{display:flex;flex-direction:row}avia-menu{min-width:180px}";
const AviaSettingsQuality$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.localeData = void 0;
    this.settings = void 0;
    this.qualityLabel = 0;
  }
  onAction(e) {
    switch (e.detail.action) {
      case Action.LIST_ITEM_SELECT:
        this.actionEvent.emit({
          action: Action.QUALITY_SELECT,
          value: { index: parseInt(e.detail.value.value) }
        });
        break;
    }
  }
  getQualityLabel(quality) {
    var _a;
    if ((_a = quality.category) === null || _a === void 0 ? void 0 : _a.length) {
      return quality.category[this.qualityLabel || 0];
    }
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    const { quality, qualities, qualityAuto } = this.settings;
    const unique = qualities.reduce((acc, qual) => {
      const label2 = this.getQualityLabel(qual);
      const item = acc.find((i) => i.label === label2);
      if (qual.enabled) {
        if (!item) {
          acc.push({
            label: label2,
            value: {
              key: "quality",
              value: qual.index,
              bitrate: qual.bitrate
            }
          });
        } else if (qual.bitrate > item.value.bitrate) {
          item.value.value = qual.index;
          item.value.bitrate = qual.bitrate;
        }
      }
      return acc;
    }, []);
    const label = this.getQualityLabel(quality);
    const disabled = unique.length === 1;
    const options = unique.map((option) => Object.assign(Object.assign({}, option), { selected: disabled || !qualityAuto && option.label === label, disabled })).sort((a, b) => b.value.bitrate - a.value.bitrate);
    if (options.length > 1) {
      options.unshift({
        selected: qualityAuto,
        disabled: false,
        label: `${this.localeData[LocalizationId.AUTO]} (${label})`,
        value: {
          key: "quality",
          value: -1
        }
      });
    }
    return h(Host, null, h("avia-menu", { ref: (element) => this.focusElement = element, locId: LocalizationId.QUALITY, options, titlebar: false }));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaSettingsQualityCss;
  }
};
openWormhole(AviaSettingsQuality$1, [
  "localeData",
  "settings",
  "qualityLabel"
]);
const aviaSettingsTextCss = "";
const AviaSettingsText$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "action", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.localeData = void 0;
    this.settings = void 0;
  }
  onAction(e) {
    switch (e.detail.action) {
      case Action.LIST_ITEM_SELECT:
        const { key, value } = e.detail.value;
        this.actionEvent.emit({
          action: Action.LANGUAGE_SELECT,
          value: { trackType: key, trackId: value }
        });
        break;
    }
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    const { textTrack, textTracks } = this.settings;
    const selected = textTrack === null || textTrack === void 0 ? void 0 : textTrack.id;
    const options = textTracks.map((track) => ({
      selected: track.id === selected,
      disabled: textTracks.length === 1,
      label: getLangLabel(track.language) || this.localeData[LocalizationId.UNKNOWN],
      value: {
        key: "text",
        value: track.id
      }
    }));
    if (!(options === null || options === void 0 ? void 0 : options.length)) {
      return;
    }
    return h("avia-menu", { ref: (element) => this.focusElement = element, locId: LocalizationId.CAPTIONS, options, titlebar: true });
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaSettingsTextCss;
  }
};
openWormhole(AviaSettingsText$1, [
  "localeData",
  "settings"
]);
const aviaSettingsToggleCss = "avia-settings-toggle avia-button{background-image:var(--avia-settings-icon)}avia-settings-toggle avia-button:hover{background-image:var(--avia-settings-icon-hover)}";
const AviaSettingsToggle$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.settings = void 0;
    this.settingsDisabled = true;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    var _a;
    const toggled = ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.active) === true;
    return h("avia-button", { ref: (element) => this.focusElement = element, actions: `${Action.SETTINGS_ON},${Action.SETTINGS_OFF}`, focusIndex: this.focusIndex, disabled: this.disabled || this.settingsDisabled, label: this.label, labelledby: this.labelledby, "loc-id": LocalizationId.SETTINGS, "aria-haspopup": "true", "aria-expanded": toggled ? "true" : "false", toggled, icon: true });
  }
  static get style() {
    return aviaSettingsToggleCss;
  }
};
openWormhole(AviaSettingsToggle$1, ["settings", "settingsDisabled"]);
const aviaSliderCss = ":root{--avia-slider-height:12px;--avia-slider-color:var(--avia-accent-color);--avia-slider-handle-color:var(--avia-accent-color);--avia-slider-track-color:#444;--avia-slider-track-radius:2px;--avia-slider-value-height:4px;--avia-slider-handle-width:12px;--avia-slider-handle-height:12px;--avia-slider-handle-radius:12px}avia-slider{display:block;height:var(--avia-slider-height);cursor:pointer;position:relative;box-shadow:none;outline:none}avia-slider.focus-visible{box-shadow:none;outline:none}.avia-slider-track{position:absolute;width:100%;height:var(--avia-slider-value-height);top:calc((var(--avia-slider-height) - var(--avia-slider-value-height)) * 0.5);background:var(--avia-slider-track-color);border-radius:var(--avia-slider-track-radius);overflow:hidden}.avia-slider-value{position:absolute;height:var(--avia-slider-value-height);top:0;background-color:var(--avia-slider-color)}.avia-slider-handle-container{position:absolute}.avia-slider-handle{width:var(--avia-slider-handle-width);height:var(--avia-slider-handle-height);margin-top:calc((var(--avia-slider-handle-height) - var(--avia-slider-height)) / -2);margin-left:calc(var(--avia-slider-handle-width) / -2);background-color:var(--avia-slider-handle-color);border-radius:var(--avia-slider-handle-radius);cursor:pointer;opacity:0;transition-property:opacity;transition-duration:250ms}avia-slider:hover .avia-slider-handle{opacity:1.0}avia-slider.focus-visible .avia-slider-handle{opacity:1.0;box-shadow:var(--avia-focus-box-shadow)}.avia-slider-ranges{position:absolute;width:100%;height:var(--avia-slider-value-height);top:0;background:transparent}.avia-slider-range-item{position:absolute;height:var(--avia-segment-marker-height);top:0;background-color:#fff}.avia-slider-list{position:absolute;width:100%;height:var(--avia-slider-value-height);top:0;background:transparent}.avia-slider-list-item{background-color:var(--avia-segment-marker-color);width:var(--avia-segment-marker-width);height:var(--avia-segment-marker-height);position:absolute;top:0}";
const AviaSlider$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.actionEvent = createEvent(this, "action", 7);
    this.changeEvent = createEvent(this, "change", 7);
    this.inputEvent = createEvent(this, "input", 7);
    this.updateEvent = createEvent(this, "update", 7);
    this.draggingEvent = createEvent(this, "dragging", 7);
    this.dragging = false;
    this.localeData = void 0;
    this.deviceMode = void 0;
    this.locId = void 0;
    this.min = 0;
    this.max = 1;
    this.value = 1;
    this.ranges = [];
    this.list = [];
    this.increment = 0.1;
    this.label = "";
    this.labelledby = "";
    this.disabled = false;
    this.focusIndex = 0;
    this.valueInternal = this.value;
  }
  onDisabledChange(disabled) {
    this.disabledEvent.emit({ disabled });
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  onValueInternalChange() {
    this.update();
  }
  onValueChange(value) {
    if (this.dragging) {
      return;
    }
    if (value < this.min) {
      this.value = this.min;
      return;
    }
    if (value > this.max) {
      this.value = this.max;
      return;
    }
    this.valueInternal = value;
  }
  onMinChange(value, old) {
    if (!isNaN(this.min) && !isNaN(this.max)) {
      this.value = mapToRange(this.value, old || this.min, this.max, value, this.max);
    }
  }
  onMaxChange(value, old) {
    if (!isNaN(this.min) && !isNaN(this.max)) {
      this.value = mapToRange(this.value, this.min, old || this.max, this.min, value);
    }
  }
  onListChange(value) {
    if (value) {
      return;
    }
    this.list = [];
    this.update();
  }
  onMouseDown(event) {
    var _a;
    if (this.disabled) {
      return;
    }
    (_a = this.gestureStartDebouncer) === null || _a === void 0 ? void 0 : _a.call(this, event);
  }
  onMouseMove(event) {
    if (this.disabled || !this.dragging) {
      return;
    }
    blockEvent(event);
    this.move(event);
  }
  onMouseUp(event) {
    var _a;
    if (this.disabled) {
      return;
    }
    (_a = this.gestureEndDebouncer) === null || _a === void 0 ? void 0 : _a.call(this, event);
  }
  onKeydown(event) {
    if (this.disabled) {
      return;
    }
    const { action, avia } = event.detail;
    const { ActionKey } = avia;
    const change = (v) => {
      const value = this.value += v;
      this.input(value);
      this.change(value);
      blockEvent(event);
    };
    switch (action) {
      case ActionKey.RIGHT:
        change(this.increment);
        break;
      case ActionKey.LEFT:
        change(-this.increment);
        break;
      case ActionKey.UP:
        if (this.deviceMode === DeviceMode.DESKTOP) {
          change(this.increment);
        }
        break;
      case ActionKey.DOWN:
        if (this.deviceMode === DeviceMode.DESKTOP) {
          change(-this.increment);
        }
        break;
    }
  }
  move(event) {
    const offset = this.element.getBoundingClientRect();
    const pos = getEventPos(event);
    if (pos.x === null) {
      return;
    }
    const percent = clampValue((pos.x - offset.left) / offset.width, 0, 1);
    const value = mapToRange(percent, 0, 1, this.min, this.max);
    this.input(value);
  }
  toPercent(value) {
    return toCssPercent(mapToRange(value, this.min, this.max));
  }
  update() {
    const { list, max, min, value } = this;
    this.updateEvent.emit({ value, min, max, list, percent: mapToRange(value, min, max) });
  }
  input(v) {
    const previous = this.valueInternal;
    const value = clampValue(v, this.min, this.max);
    this.valueInternal = value;
    this.inputEvent.emit({ value, previous });
  }
  change(v) {
    const previous = this.value;
    const value = clampValue(v, this.min, this.max);
    this.value = value;
    this.changeEvent.emit({ value, previous });
  }
  connectedCallback() {
    this.gestureStartDebouncer = debounce((event) => {
      if (event.which > 1 || event.button > 0) {
        return;
      }
      blockEvent(event);
      this.dragging = true;
      this.draggingEvent.emit({ value: true });
      this.move(event);
    }, 200);
    this.gestureEndDebouncer = debounce((event) => {
      if (this.dragging) {
        blockEvent(event);
        this.dragging = false;
        this.draggingEvent.emit({ value: false });
        this.move(event);
        this.change(this.valueInternal);
      }
    }, 200);
    Promise.resolve().then(() => this.valueInternal = this.value);
  }
  disconnectedCallback() {
    var _a, _b;
    (_a = this.gestureStartDebouncer) === null || _a === void 0 ? void 0 : _a.cancel();
    (_b = this.gestureEndDebouncer) === null || _b === void 0 ? void 0 : _b.cancel();
  }
  onFocus() {
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.SLIDER });
  }
  onBlur() {
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.SLIDER });
  }
  focus(options) {
    if ((options === null || options === void 0 ? void 0 : options.focusVisible) === true) {
      this.element.classList.add("focus-visible");
      this.element.dataset.focusVisibleAdded = "";
    }
    H.prototype.focus.call(this.element, options);
  }
  render() {
    var _a;
    const percent = this.toPercent(this.valueInternal);
    const ariaLabel = this.label || ((_a = this.localeData) === null || _a === void 0 ? void 0 : _a[this.locId]);
    const attributes = {
      "aria-label": ariaLabel
    };
    if (this.labelledby) {
      attributes["aria-labelledby"] = this.labelledby;
    }
    if (!this.label) {
      Object.assign(attributes, {
        "role": "slider",
        "aria-valuemin": Math.round(this.min),
        "aria-valuemax": Math.round(this.max),
        "aria-valuenow": Math.round(this.value)
      });
    }
    return h(Host, Object.assign({ tabindex: this.disabled ? -1 : this.focusIndex }, attributes), h("div", { class: "avia-slider-track" }, h("div", { class: "avia-slider-ranges" }, this.ranges.map((item, index) => h("div", { class: "avia-slider-range-item", key: index, style: { left: this.toPercent(item.start), width: this.toPercent(item.end - item.start) } }))), h("div", { class: "avia-slider-value", style: { width: percent } }), h("div", { class: "avia-slider-list" }, this.list.map((item) => h("div", { class: "avia-slider-list-item", key: item.value, style: { left: this.toPercent(item.value) } })))), h("slot", null), h("div", { class: "avia-slider-handle-container", style: { left: percent } }, h("slot", { name: "handle" }, h("div", { class: "avia-slider-handle" }))));
  }
  get element() {
    return this;
  }
  static get watchers() {
    return {
      "disabled": ["onDisabledChange"],
      "valueInternal": ["onValueInternalChange"],
      "value": ["onValueChange"],
      "min": ["onMinChange"],
      "max": ["onMaxChange"],
      "list": ["onListChange"]
    };
  }
  static get style() {
    return aviaSliderCss;
  }
};
openWormhole(AviaSlider$1, [
  "deviceMode",
  "localeData"
]);
const aviaSpinnerCss = "avia-spinner{display:block;width:var(--avia-spinner-diameter);height:var(--avia-spinner-diameter);overflow:visible;background-size:var(--avia-spinner-diameter);background-repeat:no-repeat;background-image:var(--avia-spinner-image);animation:avia-rotate 2s linear infinite}@keyframes avia-rotate{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}";
const AviaSpinner$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null);
  }
  static get style() {
    return aviaSpinnerCss;
  }
};
const aviaTextCss = "avia-text{color:var(--avia-control-bar-btn-text-color)}";
const AviaText$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.localeData = void 0;
    this.locId = void 0;
  }
  render() {
    var _a;
    return h(Host, null, (_a = this.localeData) === null || _a === void 0 ? void 0 : _a[this.locId]);
  }
  static get style() {
    return aviaTextCss;
  }
};
openWormhole(AviaText$1, ["localeData"]);
const aviaTextToggleCss = "avia-text-toggle avia-button{background-image:var(--avia-text-on-icon)}avia-text-toggle avia-button:hover{background-image:var(--avia-text-on-icon-hover)}avia-text-toggle avia-button[toggled]{background-image:var(--avia-text-off-icon)}avia-text-toggle avia-button[toggled]:hover{background-image:var(--avia-text-off-icon-hover)}";
const AviaTextToggle$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.textTrackEnabled = false;
    this.textDisabled = true;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  render() {
    return h("avia-button", { ref: (element) => this.focusElement = element, ids: `${LocalizationId.CLOSED_CAPTIONS_ON}, ${LocalizationId.CLOSED_CAPTIONS_OFF}`, actions: `${Action.TEXT_ON}, ${Action.TEXT_OFF}`, focusIndex: this.focusIndex, disabled: this.disabled || this.textDisabled, label: this.label, labelledby: this.labelledby, toggled: this.textTrackEnabled, icon: true });
  }
  static get style() {
    return aviaTextToggleCss;
  }
};
openWormhole(AviaTextToggle$1, [
  "textTrackEnabled",
  "textDisabled"
]);
const aviaTimeDisplayCss = "avia-time-display{margin-right:var(--avia-default-spacing)}.avia-time-display{display:inline-block;user-select:none;height:var(--avia-time-height);line-height:var(--avia-time-line-height);font-size:var(--avia-time-font-size);color:var(--avia-time-color);font-family:var(--avia-time-font-family)}.avia-control-group-right .avia-time-display{text-align:right}";
const AviaTimeDisplay$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.timeDisplayValue = void 0;
    this.currentTimeSeconds = void 0;
    this.durationSeconds = void 0;
    this.isLiveLinear = false;
    this.isLts = false;
  }
  render() {
    const inactive = this.isLiveLinear || this.isLts;
    if (inactive) {
      return "";
    }
    return h("div", { class: "avia-time-display" }, this.timeDisplayValue);
  }
  static get style() {
    return aviaTimeDisplayCss;
  }
};
openWormhole(AviaTimeDisplay$1, [
  "timeDisplayValue",
  "currentTimeSeconds",
  "durationSeconds",
  "isLiveLinear",
  "isLts"
]);
const aviaTimeRemainingCss = "avia-time-remaining{user-select:none;height:var(--avia-time-height);line-height:var(--avia-time-line-height);font-size:var(--avia-time-font-size);color:var(--avia-time-color);font-family:var(--avia-time-font-family)}";
const AviaTimeRemaining$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.currentTimeSeconds = 0;
    this.durationSeconds = 0;
    this.localeData = void 0;
  }
  render() {
    const time = Math.max(this.durationSeconds - this.currentTimeSeconds, 0);
    const label = this.localeData ? createLocalizedTimeString(time, this.localeData) : "";
    return h(Host, { "aria-label": label, title: label }, `-${secToHms(time)}`);
  }
  static get style() {
    return aviaTimeRemainingCss;
  }
};
openWormhole(AviaTimeRemaining$1, [
  "currentTimeSeconds",
  "durationSeconds",
  "localData"
]);
const aviaUiCss = `:root{--avia-accent-color:#3aacff;--avia-text-color:#dedede;--avia-text-color-hover:#ffffff;--avia-font-family:Arial, sans-serif;--avia-control-bar-bg:linear-gradient(to top, rgba(2, 0, 36, 0.8) 0%, rgba(1, 0, 10, 0.5029586834733894) 62%, rgba(0, 0, 0, 0) 100%);--avia-control-bar-height:64px;--avia-default-spacing:12px;--avia-half-spacing:6px;--avia-live-padding-top:12px;--avia-compact-button-width:48px;--avia-compact-button-height:48px;--avia-compact-button-border-radius:calc(var(--avia-compact-button-width) / 2);--avia-compact-button-background-color:rgba(64, 64, 64, 0.5);--avia-compact-control-bar-width:calc((var(--avia-compact-button-width) * 3) + (var(--avia-default-spacing) * 2));--avia-compact-control-bar-margin-left:calc(var(--avia-compact-control-bar-width) / -2);--avia-compact-control-bar-margin-top:calc(var(--avia-compact-button-height) / -2);--avia-play-overlay-bg-color:rgba(0, 0, 0, 0.35);--avia-play-cta-width:66px;--avia-play-cta-height:66px;--avia-play-cta-border-radius:calc(var(--avia-play-cta-width) / 2);--avia-play-cta-bg-image:var(--avia-play-icon);--avia-play-cta-bg-position:50%;--avia-play-cta-bg-color:rgba(64, 64, 64, 0.5);--avia-play-cta-bg-size:calc(var(--avia-play-cta-width) / 2) calc(var(--avia-play-cta-height) / 2);--avia-control-bar-btn-height:48px;--avia-control-bar-btn-width:48px;--avia-control-bar-btn-text-color:var(--avia-text-color);--avia-control-bar-btn-text-color-hover:var(--avia-text-color-hover);--avia-control-bar-btn-border:none;--avia-control-bar-btn-border-width:0;--avia-control-bar-btn-border-radius:0;--avia-control-bar-btn-border-outline:none;--avia-control-bar-btn-border-cursor:pointer;--avia-control-bar-btn-disabled-cursor:not-allowed;--avia-control-bar-btn-disabled-opacity:0.5;--avia-icon-btn-bg-width:50%;--avia-icon-btn-bg-height:37.5%;--avia-icon-btn-bg-size:var(--avia-icon-btn-bg-width) var(--avia-icon-btn-bg-height);--avia-fs-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M1%207a1%201%200%200%201-1-1V1a1%201%200%200%201%201-1h5a1%201%200%200%201%200%202H2.5a.5.5%200%200%200-.5.5V6a1%201%200%200%201-1%201zM6%2018H1a1%201%200%200%201-1-1v-5a1%201%200%200%201%202%200v3.5a.5.5%200%200%200%20.5.5H6a1%201%200%200%201%200%202zM23%2018h-5a1%201%200%200%201%200-2h3.5a.5.5%200%200%200%20.5-.5V12a1%201%200%200%201%202%200v5a1%201%200%200%201-1%201zM23%207a1%201%200%200%201-1-1V2.5a.5.5%200%200%200-.5-.5H18a1%201%200%200%201%200-2h5a1%201%200%200%201%201%201v5a1%201%200%200%201-1%201z%22%2F%3E%3C%2Fsvg%3E');--avia-fs-icon-hover:var(--avia-fs-icon);--avia-fs-exit-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M4%206H1a1%201%200%200%201%200-2h2.5a.5.5%200%200%200%20.5-.5V1a1%201%200%200%201%202%200v3a2%202%200%200%201-2%202zM23%206h-4a1%201%200%200%201-1-1V1a1%201%200%200%201%202%200v2.5a.5.5%200%200%200%20.5.5H23a1%201%200%200%201%200%202zM19%2018a1%201%200%200%201-1-1v-3a2%202%200%200%201%202-2h3a1%201%200%200%201%200%202h-2.5a.5.5%200%200%200-.5.5V17a1%201%200%200%201-1%201zM5%2018a1%201%200%200%201-1-1v-2.5a.5.5%200%200%200-.5-.5H1a1%201%200%200%201%200-2h3a2%202%200%200%201%202%202v3a1%201%200%200%201-1%201z%22%2F%3E%3C%2Fsvg%3E');--avia-fs-exit-icon-hover:var(--avia-fs-exit-icon);--avia-play-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Ctitle%3EPlay%3C%2Ftitle%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M19%2010L6.84%2017.81a1.19%201.19%200%200%201-1.84-1V1.19a1.19%201.19%200%200%201%201.83-1L19%208a1.19%201.19%200%200%201%200%202z%22%2F%3E%3C%2Fsvg%3E');--avia-play-icon-hover:var(--avia-play-icon);--avia-pause-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Ctitle%3EPause%3C%2Ftitle%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Crect%20x%3D%226%22%20width%3D%224%22%20height%3D%2218%22%20rx%3D%221%22%2F%3E%3Crect%20x%3D%2214%22%20width%3D%224%22%20height%3D%2218%22%20rx%3D%221%22%2F%3E%3C%2Fsvg%3E');--avia-pause-icon-hover:var(--avia-pause-icon);--avia-stop-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Ctitle%3EStop%3C%2Ftitle%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Crect%20x%3D%223%22%20width%3D%2218%22%20height%3D%2218%22%20rx%3D%221%22%2F%3E%3C%2Fsvg%3E');--avia-stop-icon-hover:var(--avia-stop-icon);--avia-mute-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M3.58%206H2a1%201%200%200%200-1%201v4a1%201%200%200%200%201%201h1.58a1%201%200%200%201%20.72.3l5%205a1%201%200%200%200%201.7-.74V1.44A1%201%200%200%200%209.27.73l-5%205a1%201%200%200%201-.69.27zM19.77%209.33a.5.5%200%200%201%200-.71l.94-.94a1%201%200%200%200%200-1.41%201%201%200%200%200-1.42%200l-.94.94a.5.5%200%200%201-.7%200l-.94-.94a1%201%200%200%200-1.42%200%201%201%200%200%200%200%201.41l.94.94a.5.5%200%200%201%200%20.71l-.94.94a1%201%200%200%200%200%201.41%201%201%200%200%200%201.42%200l.94-.94a.5.5%200%200%201%20.7%200l.94.94a1%201%200%200%200%201.42%200%201%201%200%200%200%200-1.41z%22%2F%3E%3C%2Fsvg%3E');--avia-mute-icon-hover:var(--avia-mute-icon);--avia-unmuted-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M3.59%206H2a1%201%200%200%200-1%201v4a1%201%200%200%200%201%201h1.59a1%201%200%200%201%20.7.29l5%205a1%201%200%200%200%201.71-.7V1.41a1%201%200%200%200-1.71-.7l-5%205a1%201%200%200%201-.7.29zM14%2018a1%201%200%200%201%200-2%207%207%200%200%200%200-14%201%201%200%200%201%200-2%209%209%200%200%201%200%2018z%22%2F%3E%3Cpath%20d%3D%22M14%2014a1%201%200%200%201%200-2%203%203%200%200%200%200-6%201%201%200%200%201%200-2%205%205%200%200%201%200%2010z%22%2F%3E%3C%2Fsvg%3E');--avia-unmuted-icon-hover:var(--avia-unmuted-icon);--avia-text-on-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill%3Anone%3Bstroke%3A%23fff%3Bstroke-linecap%3Around%3Bstroke-miterlimit%3A10%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath%20d%3D%22M23%200H1a1%201%200%2000-1%201v12a1%201%200%20001%201h2.5a.5.5%200%2001.5.5V17a1%201%200%2000.62.92A.84.84%200%20005%2018a1%201%200%2000.71-.29l3.56-3.56a.47.47%200%2001.35-.15H23a1%201%200%20001-1V1a1%201%200%2000-1-1zm-1%2011a1%201%200%2001-1%201H9a1%201%200%2000-.71.29L6%2014.59V13a1%201%200%2000-1-1H3a1%201%200%2001-1-1V3a1%201%200%20011-1h18a1%201%200%20011%201z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20class%3D%22b%22%20d%3D%22M4.5%206.5h5M16.5%206.5h3M12.5%206.5h1M4.5%209.5h3M18.5%209.5h1M10.5%209.5h5%22%2F%3E%3C%2Fsvg%3E');--avia-text-on-icon-hover:var(--avia-text-on-icon);--avia-text-off-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill%3Anone%3Bstroke%3A%23231f20%3Bstroke-linecap%3Around%3Bstroke-miterlimit%3A10%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath%20d%3D%22M23%200H1a1%201%200%2000-1%201v12a1%201%200%20001%201h2.5a.5.5%200%2001.5.5V17a1%201%200%2000.62.92A.84.84%200%20005%2018a1%201%200%2000.71-.29l3.56-3.56a.47.47%200%2001.35-.15H23a1%201%200%20001-1V1a1%201%200%2000-1-1z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20class%3D%22b%22%20d%3D%22M4.5%206.5h5M16.5%206.5h3M12.5%206.5h1M4.5%209.5h3M18.5%209.5h1M10.5%209.5h5%22%2F%3E%3C%2Fsvg%3E');--avia-text-off-icon-hover:var(--avia-text-off-icon);--avia-text-icon-disabled:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cdefs%3E%3Cstyle%3E.b%7Bfill%3Anone%3Bstroke%3A%23fff%3Bstroke-linecap%3Around%3Bstroke-miterlimit%3A10%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cpath%20d%3D%22M23%200H1a1%201%200%2000-1%201v12a1%201%200%20001%201h2.5a.5.5%200%2001.5.5V17a1%201%200%2000.62.92A.84.84%200%20005%2018a1%201%200%2000.71-.29l3.56-3.56a.47.47%200%2001.35-.15H23a1%201%200%20001-1V1a1%201%200%2000-1-1zm-1%2011a1%201%200%2001-1%201H9a1%201%200%2000-.71.29L6%2014.59V13a1%201%200%2000-1-1H3a1%201%200%2001-1-1V3a1%201%200%20011-1h18a1%201%200%20011%201z%22%20fill%3D%22%23fff%22%2F%3E%3Cpath%20class%3D%22b%22%20d%3D%22M4.5%206.5h5M16.5%206.5h3M12.5%206.5h1M4.5%209.5h3M18.5%209.5h1M10.5%209.5h5%22%2F%3E%3C%2Fsvg%3E');--avia-seek-forward-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2015.52%2017.29%22%3E%3Cpath%20d%3D%22M14.69%2C1.16%2C14%2C1.8A8.76%2C8.76%2C0%2C0%2C0%2C1.81%2C3.37%2C8.59%2C8.59%2C0%2C0%2C0%2C3.39%2C15.49a8.77%2C8.77%2C0%2C0%2C0%2C11.5-.74A1%2C1%2C0%2C0%2C0%2C15%2C13.4a1%2C1%2C0%2C0%2C0-1.36-.11l-.11.11a6.81%2C6.81%2C0%2C0%2C1-9.58%2C0%2C6.69%2C6.69%2C0%2C0%2C1-.06-9.51%2C6.82%2C6.82%2C0%2C0%2C1%2C8.73-.77L11.8%2C4a.47.47%2C0%2C0%2C0%2C0%2C.67.5.5%2C0%2C0%2C0%2C.37.15H15a.49.49%2C0%2C0%2C0%2C.49-.48V1.49a.47.47%2C0%2C0%2C0-.83-.33Z%22%20style%3D%22fill%3A%23fff%22%2F%3E%3C%2Fsvg%3E');--avia-seek-forward-icon-hover:var(--avia-seek-forward-icon);--avia-seek-back-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2015.52%2017.29%22%3E%3Cdefs%3E%3Cstyle%3E.cls-1%7Bfill%3A%23fff%3B%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Cg%20id%3D%22Layer_2%22%20data-name%3D%22Layer%202%22%3E%3Cpath%20class%3D%22cls-1%22%20d%3D%22M.46%2C1A.48.48%2C0%2C0%2C0%2C0%2C1.49V4.33a.49.49%2C0%2C0%2C0%2C.48.48h2.9a.51.51%2C0%2C0%2C0%2C.37-.15.48.48%2C0%2C0%2C0%2C0-.67L2.9%2C3.17a6.82%2C6.82%2C0%2C0%2C1%2C8.73.77%2C6.69%2C6.69%2C0%2C0%2C1-.05%2C9.51A6.82%2C6.82%2C0%2C0%2C1%2C2%2C13.4a.52.52%2C0%2C0%2C0-.1-.11%2C1%2C1%2C0%2C0%2C0-1.37.11%2C1%2C1%2C0%2C0%2C0%2C.11%2C1.35%2C8.76%2C8.76%2C0%2C0%2C0%2C11.49.74A8.59%2C8.59%2C0%2C0%2C0%2C13.7%2C3.37%2C8.76%2C8.76%2C0%2C0%2C0%2C1.48%2C1.8L.82%2C1.16A.45.45%2C0%2C0%2C0%2C.46%2C1Z%22%20transform%3D%22translate(0%200)%22%2F%3E%3C%2Fg%3E%3C%2Fsvg%3E');--avia-seek-back-icon-hover:var(--avia-seek-back-icon);--avia-settings-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22white%22%20viewBox%3D%220%200%2024%2018%22%3E%3Cpath%20fill%3D%22none%22%20d%3D%22M0%200h24v18H0z%22%2F%3E%3Cpath%20d%3D%22M20.43%2010.4l-.93-.53a1%201%200%200%201%200-1.74l.93-.53a1%201%200%200%200%20.36-1.37l-2-3.46a1%201%200%200%200-1.36-.37l-.93.54a1%201%200%200%201-1.5-.87V1a1%201%200%200%200-1-1h-4a1%201%200%200%200-1%201v1.07a1%201%200%200%201-1.5.87l-.93-.54a1%201%200%200%200-1.36.37l-2%203.46a1%201%200%200%200%20.36%201.37l.93.53a1%201%200%200%201%200%201.74l-.93.53a1%201%200%200%200-.36%201.37l2%203.46a1%201%200%200%200%201.36.37l.93-.54a1%201%200%200%201%201.5.87V17a1%201%200%200%200%201%201h4a1%201%200%200%200%201-1v-1.07a1%201%200%200%201%201.5-.87l.93.54a1%201%200%200%200%201.36-.37l2-3.46a1%201%200%200%200-.36-1.37zM12%2012a3%203%200%201%201%203-3%203%203%200%200%201-3%203z%22%2F%3E%3C%2Fsvg%3E');--avia-settings-icon-hover:var(--avia-settings-icon);--avia-selected-icon:url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2224%22%20height%3D%2224%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22white%22%3E%3Cpath%20d%3D%22M20.285%202l-11.285%2011.567-5.286-5.011-3.714%203.716%209%208.728%2015-15.285z%22%2F%3E%3C%2Fsvg%3E');--avia-time-height:48px;--avia-time-width:86px;--avia-time-line-height:48px;--avia-time-font-size:13px;--avia-time-color:var(--avia-text-color);--avia-time-font-family:var(--avia-font-family);--avia-segment-marker-color:var(--avia-text-color);--avia-segment-marker-height:4px;--avia-segment-marker-width:2px;--avia-ad-progress-color:#ffe83a;--avia-ad-progress-track-color:transparent;--avia-ad-control-bg-color:rgba(0, 0, 0, 0.7);--avia-ad-control-border-radius:4px;--avia-seek-indicator-border-radius:4px;--avia-seek-indicator-background-color:rgba(0, 0, 0, 0.5);--avia-seek-indicator-color:var(--avia-text-color);--avia-seek-indicator-height:48px;--avia-seek-indicator-font-size:20px;--avia-seek-indicator-font-family:var(--avia-font-family);--avia-seek-indicator-line-height:48px;--avia-volume-indicator-border-radius:6px;--avia-volume-indicator-background-color:rgba(0, 0, 0, 0.5);--avia-volume-indicator-width:64px;--avia-volume-indicator-height:64px;--avia-volume-indicator-right:12px;--avia-volume-indicator-bottom:72px;--avia-focus-box-shadow:0 0 2px 3px rgba(247, 228, 85, 0.85);--avia-focus-box-shadow-inner:inset 0 0 2px 3px rgba(247, 228, 85, 0.85);--avia-spinner-image:url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" stroke="white" stroke-width="1" width="40" height="40" fill="white" viewBox="0 0 37.84 41"><path d="M18,39.61V32.09a.93.93,0,0,1,.26-.66.85.85,0,0,1,.64-.27.83.83,0,0,1,.63.27.89.89,0,0,1,.26.66v7.52a.91.91,0,0,1-.89.89.85.85,0,0,1-.64-.27.87.87,0,0,1-.26-.62Zm-6.4-10.27a.89.89,0,0,1,.59-.37.82.82,0,0,1,.65.16.79.79,0,0,1,.36.59.94.94,0,0,1-.15.69L8.8,36.47a.8.8,0,0,1-.57.38,1,1,0,0,1-.67-.16.84.84,0,0,1-.36-.59,1,1,0,0,1,.16-.7ZM1.13,25.53,8,23.21a.92.92,0,0,1,.67.05.93.93,0,0,1,.4,1.23,1,1,0,0,1-.52.47L1.64,27.27A.87.87,0,0,1,1,27.22a.82.82,0,0,1-.43-.53,1,1,0,0,1,0-.72.81.81,0,0,1,.54-.44Zm.51-11.8L8.56,16a1,1,0,0,1,.52.47.93.93,0,0,1-.4,1.23.92.92,0,0,1-.67.05L1.13,15.47A.81.81,0,0,1,.59,15a1,1,0,0,1,0-.72A.82.82,0,0,1,1,13.78a.87.87,0,0,1,.67,0ZM8.8,4.53l4.27,6.06a.94.94,0,0,1,.15.69.79.79,0,0,1-.36.59.82.82,0,0,1-.65.16.89.89,0,0,1-.59-.37L7.36,5.6a1,1,0,0,1-.16-.7.84.84,0,0,1,.36-.59,1,1,0,0,1,.67-.16.8.8,0,0,1,.57.38Zm11-3.14V8.91a.89.89,0,0,1-.26.66.83.83,0,0,1-.63.27.85.85,0,0,1-.64-.27A.93.93,0,0,1,18,8.91V1.39a.87.87,0,0,1,.26-.62A.85.85,0,0,1,18.92.5a.83.83,0,0,1,.63.27.83.83,0,0,1,.26.62ZM30.48,5.6l-4.27,6.06a.87.87,0,0,1-.58.37.85.85,0,0,1-.66-.16.86.86,0,0,1-.36-.59,1,1,0,0,1,.16-.69L29,4.53a.76.76,0,0,1,.56-.38.94.94,0,0,1,.67.16.86.86,0,0,1,.37.59,1,1,0,0,1-.16.7Zm6.23,9.87-6.88,2.32a.91.91,0,0,1-.67-.05.93.93,0,0,1-.4-1.23,1,1,0,0,1,.52-.47l6.91-2.31a.87.87,0,0,1,.67,0,.83.83,0,0,1,.44.53,1,1,0,0,1-.06.72.79.79,0,0,1-.53.44Zm-.52,11.8L29.28,25a1,1,0,0,1-.52-.47.93.93,0,0,1,.4-1.23.91.91,0,0,1,.67-.05l6.88,2.32a.79.79,0,0,1,.53.44,1,1,0,0,1,.06.72.83.83,0,0,1-.44.53.87.87,0,0,1-.67.05ZM29,36.47l-4.27-6.06a1,1,0,0,1-.16-.69.86.86,0,0,1,.36-.59.85.85,0,0,1,.66-.16.87.87,0,0,1,.58.37l4.27,6.06a1,1,0,0,1,.16.7.86.86,0,0,1-.37.59.94.94,0,0,1-.67.16.76.76,0,0,1-.56-.38Z"/></svg>');--avia-spinner-diameter:48px;--avia-active-transition-in:opacity 0.5s ease 0s;--avia-active-transition-out:opacity 0.5s ease 0s;--avia-buffered-range-background-color:rgba(255, 255, 255, 0.20)}avia-ui{color:var(--avia-text-color);font-family:var(--avia-font-family)}avia-ui>*{pointer-events:auto;-webkit-user-select:none;user-select:none}avia-ui,avia-ui avia-accessibility,.avia-layer{pointer-events:none;position:absolute;top:0;left:0;bottom:0;right:0}.avia-layer>*{pointer-events:auto}slot-fb[hidden]{display:none}.avia-ui-hidden{display:none}img.avia-poster-img{width:100%;height:auto}.avia-container,avia-ui:focus,avia-ui button:focus{outline:none}avia-ui.focus-visible,avia-ui .focus-visible{box-shadow:var(--avia-focus-box-shadow)}avia-ui.focus-visible .avia-menu-button,avia-ui .focus-visible.avia-menu-button{box-shadow:var(--avia-focus-box-shadow-inner)}avia-ui:not([active])[fullscreen]{cursor:none}.avia-container.avia-controls-vis video::-webkit-media-text-track-container{bottom:calc(var(--avia-control-bar-height) + 4px);height:auto}.avia-controls{display:flex;flex-direction:column}.avia-spacer{pointer-events:none;flex-grow:1}`;
const AviaUi$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.actionEvent = createEvent(this, "uiaction", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.controlMode = ControlMode.NONE;
    this.fullscreen = false;
    this.active = null;
    this.deviceMode = DeviceMode.DESKTOP;
    this.options = null;
    this.fullscreenDisabled = true;
    this.muted = false;
    this.muteDisabled = true;
    this.volume = 1;
    this.playing = false;
    this.playDisabled = true;
    this.textTrackEnabled = false;
    this.textDisabled = true;
    this.timeDisplayValue = "";
    this.isLiveLinear = false;
    this.isLts = false;
    this.live = false;
    this.playheadPosition = 0;
    this.durationSeconds = 0;
    this.currentTimeSeconds = 0;
    this.seekDisabled = true;
    this.seekBackDisabled = true;
    this.seekForwardDisabled = true;
    this.settingsDisabled = true;
    this.adPlayheadPosition = 0;
    this.segmentBreakPositions = void 0;
    this.localeData = null;
    this.preview = null;
    this.accIndicatorState = void 0;
    this.unmuteCtaVisible = false;
    this.settings = null;
    this.posterActive = false;
    this.posterImageUrl = "";
    this.qualityLabel = 0;
    this.waiting = false;
    this.initialized = false;
    this.pausable = true;
    this.isTouch = false;
    this.isIosNative = false;
    this.linkMuteAndVolume = true;
    this.playerDimensions = { width: 0, height: 0 };
    this.bufferedRanges = [];
  }
  handleAction(event) {
    var _a;
    this.actionEvent.emit(event.detail);
    if (event.detail.action === Action.SETTINGS_OFF) {
      (_a = this.element.querySelector("avia-settings-toggle")) === null || _a === void 0 ? void 0 : _a.focus();
    }
  }
  onFocusIn(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.ENTER_CONTEXT, value: ActionKeyContext.UI });
  }
  onFocusOut(event) {
    if (this.element.contains(event.relatedTarget)) {
      return;
    }
    this.actionEvent.emit({ action: Action.EXIT_CONTEXT, value: ActionKeyContext.UI });
  }
  componentWillLoad() {
    Universe.create(this, this);
  }
  componentDidLoad() {
    this.readyEvent.emit();
  }
  render() {
    if (!this.initialized) {
      return;
    }
    const isTv = this.deviceMode === DeviceMode.TV;
    return h(Host, null, h(Universe.Provider, { state: this }, h("div", { class: "avia-layer" }, h("slot", { name: "underlay" })), h("slot", { name: "play-overlay" }, !isTv ? h("avia-play-overlay", null) : ""), h("slot", { name: "pause-overlay" }, isTv ? h("avia-pause-overlay", null) : ""), h("slot", { name: "waiting-overlay" }, h("avia-waiting-overlay", null)), h("slot", { name: "unmute-cta" }, !isTv ? h("avia-unmute-cta", null) : ""), h("slot", { name: "accessibility" }, h("avia-accessibility", null)), h("slot", { name: "poster" }, !isTv ? h("avia-poster", null) : ""), h("div", { class: "avia-layer avia-controls" }, h("div", { class: "avia-spacer" }), h("slot", { name: "settings" }, h("avia-settings", null)), h("slot", { name: "control-bar" }, h("avia-control-bar", null)), h("slot", { name: "ad-control-bar" }, h("avia-ad-control-bar", null)), h("slot", { name: "compact-control-bar" }, !isTv ? h("avia-control-bar-compact", null) : "")), h("div", { class: "avia-layer" }, h("slot", { name: "overlay" }))));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaUiCss;
  }
};
const aviaUnmuteCtaCss = "avia-unmute-cta{box-sizing:border-box;display:inline-block;position:absolute;top:64px;height:var(--avia-control-bar-btn-height);left:var(--avia-default-spacing);pointer-events:auto;background-color:rgba(0, 0, 0, 0.415);border-radius:4px;opacity:1}avia-unmute-cta avia-button{background-image:var(--avia-mute-icon);background-position:-31px center;background-repeat:no-repeat;background-size:60% 45%;line-height:var(--avia-control-bar-btn-height);padding-right:var(--avia-default-spacing);padding-left:50px;font-size:1.1em;text-align:left;width:auto;height:var(--avia-control-bar-btn-height);color:white;cursor:pointer;opacity:0.85}avia-unmute-cta avia-button:hover{background-image:var(--avia-mute-icon-hover)}";
const AviaUnmuteCta$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.muted = false;
    this.unmuteCtaVisible = false;
    this.isTouch = false;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.focus(options);
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  getText() {
    return this.isTouch ? LocalizationId.TAP_TO_UNMUTE : LocalizationId.CLICK_TO_UNMUTE;
  }
  render() {
    if (!this.unmuteCtaVisible || !this.muted) {
      return "";
    }
    return h("avia-button", { actions: Action.UNMUTE, ref: (element) => this.focusElement = element, focusIndex: this.focusIndex, label: this.label, labelledby: this.labelledby, disabled: this.disabled }, h("avia-text", { "loc-id": this.getText() }));
  }
  static get style() {
    return aviaUnmuteCtaCss;
  }
};
openWormhole(AviaUnmuteCta$1, ["muted", "unmuteCtaVisible", "isTouch"]);
const aviaVolumeIndicatorCss = `avia-volume-indicator{position:absolute;display:block;box-sizing:border-box;border-radius:var(--avia-volume-indicator-border-radius);background-color:var(--avia-volume-indicator-background-color);width:0;height:0;right:var(--avia-volume-indicator-right);bottom:var(--avia-volume-indicator-bottom);visibility:hidden;padding-top:48px;opacity:0;transition-property:opacity;transition-duration:300ms;transition-timing-function:ease-in;box-shadow:0px 0px 1px 1px rgba(0, 0, 0, 0.3)}avia-volume-indicator:empty{opacity:0}.avia-acc-vol{width:48px;margin:0 auto;background-color:black;height:4px;position:relative}.avia-acc-vol-meter{height:4px;background-color:#fff}.avia-vol-meter-overlay{position:absolute;top:0;left:0;height:4px;background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAECAYAAACp8Z5+AAAAFElEQVQImWNAA/+Z0EUICDAwMAAANNwBBuf8FlcAAAAASUVORK5CYII=');width:100%}avia-volume-indicator.avia-indicator-active{width:var(--avia-volume-indicator-width);height:var(--avia-volume-indicator-height);opacity:1.0}avia-volume-indicator.avia-volume-on::before,avia-volume-indicator.avia-volume-off::before{content:"";position:absolute;top:0px;right:0px;bottom:0px;left:0px;opacity:0.85;background-repeat:no-repeat;background-position:center 12px;background-size:40% 30%}avia-volume-indicator.avia-volume-on::before{background-image:var(--avia-unmuted-icon)}avia-volume-indicator.avia-volume-on::before:hover{background-image:var(--avia-unmuted-icon-hover)}avia-volume-indicator.avia-volume-off::before{background-image:var(--avia-mute-icon)}avia-volume-indicator.avia-volume-off::before:hover{background-image:var(--avia-mute-icon-hover)}`;
const AviaVolumeIndicator$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.volume = void 0;
    this.accIndicatorState = void 0;
  }
  componentDidRender() {
    var _a;
    if (!this.debouncer && this.accIndicatorState.displayTime > 0) {
      this.debouncer = debounce(() => {
        var _a2;
        (_a2 = this.el) === null || _a2 === void 0 ? void 0 : _a2.classList.remove(CssNames.INDICATOR_ACTIVE);
        this.visible = false;
      }, this.accIndicatorState.displayTime);
    }
    if (this.visible) {
      setTimeout(() => this.el.classList.add(CssNames.INDICATOR_ACTIVE), 0);
      (_a = this.debouncer) === null || _a === void 0 ? void 0 : _a.call(this);
    }
  }
  render() {
    var _a;
    const acc = this.accIndicatorState;
    if (!acc.volumeKey) {
      (_a = this.el) === null || _a === void 0 ? void 0 : _a.classList.remove(CssNames.INDICATOR_ACTIVE);
      this.visible = false;
      return "";
    }
    this.visible = true;
    const vol = this.volume === 0 ? 0 : clampValue(this.volume, 0, 1);
    return h(Host, { class: acc.muted || this.volume === 0 ? CssNames.ACC_VOL_OFF : CssNames.ACC_VOL_ON }, h("div", { class: CssNames.ACC_VOL }, h("div", { class: CssNames.ACC_VOL_METER, style: { width: toCssPercent(vol) } }), h("div", { class: CssNames.ACC_VOL_OVERLAY })));
  }
  get el() {
    return this;
  }
  static get style() {
    return aviaVolumeIndicatorCss;
  }
};
openWormhole(AviaVolumeIndicator$1, ["volume", "accIndicatorState"]);
const aviaVolumeSliderCss = "avia-volume-slider{margin-left:var(--avia-default-spacing)}avia-volume-slider avia-slider{width:100%;margin-top:-4px}avia-volume-slider.focus-visible{outline:none}";
const SLIDER_BREAKPOINT_MS = 530;
const SLIDER_BREAKPOINT_HMS = 560;
const SLIDER_WIDTH_SM = 60;
const SLIDER_WIDTH_MD = 100;
const AviaVolumeSlider$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.disabledEvent = createEvent(this, "disabled", 7);
    this.readyEvent = createEvent(this, "ready", 7);
    this.changeEvent = createEvent(this, "action", 7);
    this.volume = void 0;
    this.muted = false;
    this.linkMuteAndVolume = true;
    this.playerDimensions = void 0;
    this.durationSeconds = void 0;
    this.label = void 0;
    this.labelledby = void 0;
    this.disabled = false;
    this.focusIndex = 0;
  }
  focus(options) {
    if (this.focusElement) {
      this.focusElement.focus(options);
    } else {
      this.element.addEventListener("ready", () => this.focusElement.focus(options), { once: true });
    }
  }
  blur() {
    var _a;
    (_a = this.focusElement) === null || _a === void 0 ? void 0 : _a.blur();
  }
  onInput(e) {
    this.changeEvent.emit({ action: Action.VOLUME, value: e.detail.value });
  }
  onDragging(e) {
    if (e.detail.value !== true) {
      return;
    }
    this.changeEvent.emit({ action: Action.UNMUTE, value: true });
  }
  getSliderWidth() {
    const maxPlayerWidth = this.durationSeconds >= 3600 ? SLIDER_BREAKPOINT_HMS : SLIDER_BREAKPOINT_MS;
    return `${this.playerDimensions.width && this.playerDimensions.width <= maxPlayerWidth ? SLIDER_WIDTH_SM : SLIDER_WIDTH_MD}px`;
  }
  render() {
    return h(Host, { style: {
      width: this.getSliderWidth()
    } }, h("avia-slider", { ref: (element) => this.focusElement = element, "loc-id": LocalizationId.VOLUME, value: this.linkMuteAndVolume && this.muted ? 0 : this.volume, onInput: (e) => this.onInput(e), onDragging: (e) => this.onDragging(e), focusIndex: this.focusIndex, disabled: this.disabled, label: this.label, labelledby: this.labelledby }));
  }
  get element() {
    return this;
  }
  static get style() {
    return aviaVolumeSliderCss;
  }
};
openWormhole(AviaVolumeSlider$1, [
  "linkMuteAndVolume",
  "muted",
  "volume",
  "playerDimensions",
  "durationSeconds"
]);
const aviaWaitingOverlayCss = "avia-waiting-overlay{display:block;justify-content:center;align-items:center;display:flex}avia-waiting-overlay slot-fb:not(:empty)~avia-spinner{display:none}";
const AviaWaitingOverlay$1 = class extends H {
  constructor() {
    super();
    this.__registerHost();
    this.waiting = false;
  }
  render() {
    if (!this.waiting) {
      return;
    }
    return h("avia-overlay", { centered: true }, h("avia-spinner", null));
  }
  static get style() {
    return aviaWaitingOverlayCss;
  }
};
openWormhole(AviaWaitingOverlay$1, ["waiting"]);
const AviaAccessibility = /* @__PURE__ */ proxyCustomElement(AviaAccessibility$1, [0, "avia-accessibility"]);
const AviaActive = /* @__PURE__ */ proxyCustomElement(AviaActive$1, [0, "avia-active"]);
const AviaAdControlBar = /* @__PURE__ */ proxyCustomElement(AviaAdControlBar$1, [0, "avia-ad-control-bar"]);
const AviaAdProgressBar = /* @__PURE__ */ proxyCustomElement(AviaAdProgressBar$1, [0, "avia-ad-progress-bar", { "adPlayheadPosition": [2, "ad-playhead-position"], "isLiveLinear": [4, "is-live-linear"] }]);
const AviaButton = /* @__PURE__ */ proxyCustomElement(AviaButton$1, [0, "avia-button", { "locId": [513, "loc-id"], "toggled": [516], "compact": [516], "icon": [516], "variant": [516], "ids": [513], "actions": [1], "localeData": [16], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"], "focused": [32] }, [[0, "click", "onClick"], [0, "touchstart", "onTouchStart"], [1, "touchend", "onTouchEnd"], [0, "focus", "onFocus"], [0, "blur", "onBlur"], [0, "actionkey", "onKeyDown"]]]);
const AviaControlBar = /* @__PURE__ */ proxyCustomElement(AviaControlBar$1, [4, "avia-control-bar", { "active": [516], "controlMode": [513, "control-mode"], "deviceMode": [1, "device-mode"], "isLts": [4, "is-lts"], "isLiveLinear": [4, "is-live-linear"], "isIosNative": [4, "is-ios-native"], "settings": [16] }]);
const AviaControlBarCompact = /* @__PURE__ */ proxyCustomElement(AviaControlBarCompact$1, [0, "avia-control-bar-compact"]);
const AviaControlGroup = /* @__PURE__ */ proxyCustomElement(AviaControlGroup$1, [0, "avia-control-group", { "orientation": [513] }]);
const AviaCurrentTime = /* @__PURE__ */ proxyCustomElement(AviaCurrentTime$1, [0, "avia-current-time", { "currentTimeSeconds": [2, "current-time-seconds"], "localeData": [16] }]);
const AviaDuration = /* @__PURE__ */ proxyCustomElement(AviaDuration$1, [0, "avia-duration", { "durationSeconds": [2, "duration-seconds"], "localeData": [16] }]);
const AviaFullscreenToggle = /* @__PURE__ */ proxyCustomElement(AviaFullscreenToggle$1, [0, "avia-fullscreen-toggle", { "fullscreen": [4], "fullscreenDisabled": [4, "fullscreen-disabled"], "compact": [516], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaLiveControl = /* @__PURE__ */ proxyCustomElement(AviaLiveControl$1, [0, "avia-live-control", { "isLiveLinear": [4, "is-live-linear"], "isLts": [4, "is-lts"], "live": [4], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaMenu = /* @__PURE__ */ proxyCustomElement(AviaMenu$1, [0, "avia-menu", { "localeData": [16], "hasSubmenu": [4, "has-submenu"], "locId": [1, "loc-id"], "titlebar": [4], "options": [1040], "disabled": [516] }, [[0, "action", "onAction"], [0, "actionkey", "onKeydown"], [0, "focusin", "onFocusIn"], [0, "focusout", "onFocusOut"]]]);
const AviaMenuItem = /* @__PURE__ */ proxyCustomElement(AviaMenuItem$1, [4, "avia-menu-item", { "disabled": [1540], "selected": [516], "label": [1], "action": [1], "hasSubmenu": [4, "has-submenu"] }, [[0, "click", "onClick"], [0, "actionkey", "onKeyDown"]]]);
const AviaMuteToggle = /* @__PURE__ */ proxyCustomElement(AviaMuteToggle$1, [0, "avia-mute-toggle", { "muted": [4], "muteDisabled": [4, "mute-disabled"], "compact": [516], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaOverlay = /* @__PURE__ */ proxyCustomElement(AviaOverlay$1, [0, "avia-overlay", { "centered": [516] }]);
const AviaPanel = /* @__PURE__ */ proxyCustomElement(AviaPanel$1, [4, "avia-panel", { "localeData": [16], "titlebar": [4], "back": [4], "locId": [1, "loc-id"] }]);
const AviaPauseOverlay = /* @__PURE__ */ proxyCustomElement(AviaPauseOverlay$1, [0, "avia-pause-overlay", { "playing": [4], "waiting": [4] }]);
const AviaPlayCta = /* @__PURE__ */ proxyCustomElement(AviaPlayCta$1, [0, "avia-play-cta", { "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaPlayOverlay = /* @__PURE__ */ proxyCustomElement(AviaPlayOverlay$1, [0, "avia-play-overlay", { "playing": [4], "controlMode": [1, "control-mode"], "playDisabled": [4, "play-disabled"], "pausable": [4], "isTouch": [4, "is-touch"], "focusIndex": [2, "focus-index"] }, [[2, "click", "onClick"]]]);
const AviaPlayToggle = /* @__PURE__ */ proxyCustomElement(AviaPlayToggle$1, [0, "avia-play-toggle", { "playing": [4], "playDisabled": [4, "play-disabled"], "pausable": [4], "compact": [516], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaPoster = /* @__PURE__ */ proxyCustomElement(AviaPoster$1, [4, "avia-poster", { "posterActive": [4, "poster-active"], "posterImageUrl": [1, "poster-image-url"], "playing": [4], "waiting": [4] }, [[2, "click", "handleAction"]]]);
const AviaProgressBar = /* @__PURE__ */ proxyCustomElement(AviaProgressBar$1, [4, "avia-progress-bar", { "bufferedRanges": [16], "currentTimeSeconds": [2, "current-time-seconds"], "durationSeconds": [2, "duration-seconds"], "live": [4], "localeData": [16], "options": [16], "segmentBreakPositions": [1, "segment-break-positions"], "preview": [16], "increment": [2], "progressMode": [1, "progress-mode"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"], "hovering": [32], "cursor": [32], "value": [32] }, [[1, "mouseenter", "onMouseEnter"], [1, "mouseleave", "onMouseLeave"], [8, "touchmove", "onMouseMove"], [9, "mousemove", "onMouseMove"], [0, "actionkey", "onKeydown"]]]);
const AviaScrubIndicator = /* @__PURE__ */ proxyCustomElement(AviaScrubIndicator$1, [0, "avia-scrub-indicator", { "accIndicatorState": [16] }]);
const AviaSeekBackButton = /* @__PURE__ */ proxyCustomElement(AviaSeekBackButton$1, [0, "avia-seek-back-button", { "seekBackDisabled": [4, "seek-back-disabled"], "isLiveLinear": [4, "is-live-linear"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaSeekForwardButton = /* @__PURE__ */ proxyCustomElement(AviaSeekForwardButton$1, [0, "avia-seek-forward-button", { "seekForwardDisabled": [4, "seek-forward-disabled"], "isLiveLinear": [4, "is-live-linear"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaSeekIndicator = /* @__PURE__ */ proxyCustomElement(AviaSeekIndicator$1, [0, "avia-seek-indicator", { "durationSeconds": [2, "duration-seconds"], "accIndicatorState": [16] }]);
const AviaSettings = /* @__PURE__ */ proxyCustomElement(AviaSettings$1, [0, "avia-settings", { "settings": [16], "localeData": [16], "controlMode": [1, "control-mode"], "deviceMode": [1, "device-mode"], "options": [16], "qualityLabel": [2, "quality-label"], "currentId": [32], "menu": [32] }, [[0, "action", "onAction"], [0, "actionkey", "onKeyDown"], [0, "focusin", "onFocusIn"], [0, "focusout", "onFocusOut"]]]);
const AviaSettingsAudio = /* @__PURE__ */ proxyCustomElement(AviaSettingsAudio$1, [0, "avia-settings-audio", { "localeData": [16], "settings": [16] }, [[0, "action", "onAction"]]]);
const AviaSettingsLanguage = /* @__PURE__ */ proxyCustomElement(AviaSettingsLanguage$1, [0, "avia-settings-language", { "localeData": [16], "settings": [16] }]);
const AviaSettingsQuality = /* @__PURE__ */ proxyCustomElement(AviaSettingsQuality$1, [0, "avia-settings-quality", { "localeData": [16], "settings": [16], "qualityLabel": [2, "quality-label"] }, [[0, "action", "onAction"]]]);
const AviaSettingsText = /* @__PURE__ */ proxyCustomElement(AviaSettingsText$1, [0, "avia-settings-text", { "localeData": [16], "settings": [16] }, [[0, "action", "onAction"]]]);
const AviaSettingsToggle = /* @__PURE__ */ proxyCustomElement(AviaSettingsToggle$1, [0, "avia-settings-toggle", { "settings": [16], "settingsDisabled": [4, "settings-disabled"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaSlider = /* @__PURE__ */ proxyCustomElement(AviaSlider$1, [4, "avia-slider", { "localeData": [16], "deviceMode": [1, "device-mode"], "locId": [1, "loc-id"], "min": [2], "max": [2], "value": [1026], "ranges": [16], "list": [16], "increment": [2], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"], "valueInternal": [32] }, [[1, "touchstart", "onMouseDown"], [0, "mousedown", "onMouseDown"], [8, "touchmove", "onMouseMove"], [8, "mousemove", "onMouseMove"], [9, "touchend", "onMouseUp"], [8, "mouseup", "onMouseUp"], [0, "actionkey", "onKeydown"], [0, "focus", "onFocus"], [0, "blur", "onBlur"]]]);
const AviaSpinner = /* @__PURE__ */ proxyCustomElement(AviaSpinner$1, [0, "avia-spinner"]);
const AviaText = /* @__PURE__ */ proxyCustomElement(AviaText$1, [0, "avia-text", { "localeData": [16], "locId": [513, "loc-id"] }]);
const AviaTextToggle = /* @__PURE__ */ proxyCustomElement(AviaTextToggle$1, [0, "avia-text-toggle", { "textTrackEnabled": [4, "text-track-enabled"], "textDisabled": [4, "text-disabled"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaTimeDisplay = /* @__PURE__ */ proxyCustomElement(AviaTimeDisplay$1, [0, "avia-time-display", { "timeDisplayValue": [1, "time-display-value"], "currentTimeSeconds": [2, "current-time-seconds"], "durationSeconds": [2, "duration-seconds"], "isLiveLinear": [4, "is-live-linear"], "isLts": [4, "is-lts"] }]);
const AviaTimeRemaining = /* @__PURE__ */ proxyCustomElement(AviaTimeRemaining$1, [0, "avia-time-remaining", { "currentTimeSeconds": [2, "current-time-seconds"], "durationSeconds": [2, "duration-seconds"], "localeData": [16] }]);
const AviaUi = /* @__PURE__ */ proxyCustomElement(AviaUi$1, [4, "avia-ui", { "controlMode": [513, "control-mode"], "fullscreen": [516], "active": [516], "deviceMode": [513, "device-mode"], "options": [16], "fullscreenDisabled": [4, "fullscreen-disabled"], "muted": [4], "muteDisabled": [4, "mute-disabled"], "volume": [2], "playing": [4], "playDisabled": [4, "play-disabled"], "textTrackEnabled": [4, "text-track-enabled"], "textDisabled": [4, "text-disabled"], "timeDisplayValue": [1, "time-display-value"], "isLiveLinear": [4, "is-live-linear"], "isLts": [4, "is-lts"], "live": [4], "playheadPosition": [2, "playhead-position"], "durationSeconds": [2, "duration-seconds"], "currentTimeSeconds": [2, "current-time-seconds"], "seekDisabled": [4, "seek-disabled"], "seekBackDisabled": [4, "seek-back-disabled"], "seekForwardDisabled": [4, "seek-forward-disabled"], "settingsDisabled": [4, "settings-disabled"], "adPlayheadPosition": [2, "ad-playhead-position"], "segmentBreakPositions": [1, "segment-break-positions"], "localeData": [16], "preview": [16], "accIndicatorState": [16], "unmuteCtaVisible": [4, "unmute-cta-visible"], "settings": [16], "posterActive": [4, "poster-active"], "posterImageUrl": [1, "poster-image-url"], "qualityLabel": [2, "quality-label"], "waiting": [4], "initialized": [4], "pausable": [4], "isTouch": [4, "is-touch"], "isIosNative": [4, "is-ios-native"], "linkMuteAndVolume": [4, "link-mute-and-volume"], "playerDimensions": [16], "bufferedRanges": [16] }, [[0, "action", "handleAction"], [0, "focusin", "onFocusIn"], [0, "focusout", "onFocusOut"]]]);
const AviaUnmuteCta = /* @__PURE__ */ proxyCustomElement(AviaUnmuteCta$1, [0, "avia-unmute-cta", { "muted": [4], "unmuteCtaVisible": [4, "unmute-cta-visible"], "isTouch": [4, "is-touch"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaVolumeIndicator = /* @__PURE__ */ proxyCustomElement(AviaVolumeIndicator$1, [0, "avia-volume-indicator", { "volume": [2], "accIndicatorState": [16] }]);
const AviaVolumeSlider = /* @__PURE__ */ proxyCustomElement(AviaVolumeSlider$1, [0, "avia-volume-slider", { "volume": [2], "muted": [4], "linkMuteAndVolume": [4, "link-mute-and-volume"], "playerDimensions": [16], "durationSeconds": [2, "duration-seconds"], "label": [1], "labelledby": [1], "disabled": [516], "focusIndex": [2, "focus-index"] }]);
const AviaWaitingOverlay = /* @__PURE__ */ proxyCustomElement(AviaWaitingOverlay$1, [0, "avia-waiting-overlay", { "waiting": [4] }]);
const defineCustomElements = (opts) => {
  if (typeof customElements !== "undefined") {
    [
      AviaAccessibility,
      AviaActive,
      AviaAdControlBar,
      AviaAdProgressBar,
      AviaButton,
      AviaControlBar,
      AviaControlBarCompact,
      AviaControlGroup,
      AviaCurrentTime,
      AviaDuration,
      AviaFullscreenToggle,
      AviaLiveControl,
      AviaMenu,
      AviaMenuItem,
      AviaMuteToggle,
      AviaOverlay,
      AviaPanel,
      AviaPauseOverlay,
      AviaPlayCta,
      AviaPlayOverlay,
      AviaPlayToggle,
      AviaPoster,
      AviaProgressBar,
      AviaScrubIndicator,
      AviaSeekBackButton,
      AviaSeekForwardButton,
      AviaSeekIndicator,
      AviaSettings,
      AviaSettingsAudio,
      AviaSettingsLanguage,
      AviaSettingsQuality,
      AviaSettingsText,
      AviaSettingsToggle,
      AviaSlider,
      AviaSpinner,
      AviaText,
      AviaTextToggle,
      AviaTimeDisplay,
      AviaTimeRemaining,
      AviaUi,
      AviaUnmuteCta,
      AviaVolumeIndicator,
      AviaVolumeSlider,
      AviaWaitingOverlay
    ].forEach((cmp) => {
      if (!customElements.get(cmp.is)) {
        customElements.define(cmp.is, cmp, opts);
      }
    });
  }
};
defineCustomElements();
export {
  ActionKeyContext,
  ActiveMode,
  AviaAccessibility,
  AviaActive,
  AviaAdControlBar,
  AviaAdProgressBar,
  AviaButton,
  AviaControlBar,
  AviaControlBarCompact,
  AviaControlGroup,
  AviaCurrentTime,
  AviaDuration,
  AviaFullscreenToggle,
  AviaLiveControl,
  AviaMenu,
  AviaMenuItem,
  AviaMuteToggle,
  AviaOverlay,
  AviaPanel,
  AviaPauseOverlay,
  AviaPlayCta,
  AviaPlayOverlay,
  AviaPlayToggle,
  AviaPoster,
  AviaProgressBar,
  AviaScrubIndicator,
  AviaSeekBackButton,
  AviaSeekForwardButton,
  AviaSeekIndicator,
  AviaSettings,
  AviaSettingsAudio,
  AviaSettingsLanguage,
  AviaSettingsQuality,
  AviaSettingsText,
  AviaSettingsToggle,
  AviaSlider,
  AviaSpinner,
  AviaText,
  AviaTextToggle,
  AviaTimeDisplay,
  AviaTimeRemaining,
  AviaUi,
  AviaUiPlugin,
  AviaUnmuteCta,
  AviaVolumeIndicator,
  AviaVolumeSlider,
  AviaWaitingOverlay,
  ControlMode,
  DeviceMode,
  ID,
  LocalizationId,
  Orientation,
  PreviewTimeTransform,
  ProgressMode,
  UI,
  createPlugin,
  createUiPlugin,
  defineCustomElements,
  plugin,
  setAssetPath,
  setPlatformOptions,
  ui
};
//# sourceMappingURL=avia.ui.esm.js.map
